import { Quadrant } from './../reaction-set/reaction-set-enums';
import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { saveAs as saveByFileSaver } from "file-saver";
import { ConfirmationService, SelectItem } from 'primeng/api';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { APGTestingService } from './apgtesting.service';
import { CovidSamples } from './model/covid-sample';
import { AnimalBatch, FilesPerManufacturer, WellType } from './model/animalBatch';
import { KitsDTO } from '../masterdata/models/kits-dto';
import { Channel } from './model/channel';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Comment } from './model/comment';
import { MergedBatch } from './model/merged-batch';
import { LabMDM } from '../masterdata/models/lab';
import { MasterDataService } from '../masterdata/masterdata.service';
import { APGCovid19Constants } from './model/apg-newview-constants';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { ChannelTestingTypeMapping } from './model/channel-testing-type-mapping';
import { BatchGroup } from './model/batchGroup';
import { BatchItemHistory } from './model/batchItemHistory';
import { DatePipe } from '@angular/common';
import { SelectableLab } from '../carrier/selectable-lab';
import { SplitBatchDTO } from './model/split-batch';
import { ControlStatus,UnboxedSample } from './model/unboxing-sample';
import { ArchivePlateListRequestDTO } from './model/archive-request-dto';
import { BBResponseContainer } from '../carrier/response-container';
import { AnimalBatchExportFileDTO } from './model/animalBatchExportFile';
import { Controls } from '../masterdata/models/controls';
import { RegexFormatAndPosition } from '../masterdata/models/RegexFormatAndPosition';
import { WorkFlow } from '../masterdata/models/workFlow';




@Component({
  selector: 'app-agptesting-newview',
  templateUrl: './agptesting-newview.component.html',
  styleUrls: ['./agptesting-newview.component.css']
})
export class AgptestingNewviewComponent implements OnInit {

  @ViewChild('focus1')
  searchElement1: ElementRef;

  @ViewChild('focus2')
  searchElement2: ElementRef;

  @ViewChild('focus3')
  searchElement3: ElementRef;

  batches: AnimalBatch[] = [];
  kitsDTO: KitsDTO;
  fileNameString: string = '';
  selectedBatch: AnimalBatch;
  puid: string;
  uploadForm: FormGroup;
  val2: string;
  val1: boolean;
  option1: boolean;
  option2: boolean;
  option3: boolean;
  batchToSearch: string;
  sampleToSearch: string;
  showBatch = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  allowCreate: boolean = false;
  color: string;
  selectedLabId: string;
  isUploadDisabled = true;
  senderList: any[] = [];
  exctractionMachines: any[] = [];
  extractionKitVendorList: any[] = [];
  kitVendorList: any[] = [];
  rtkitVendorList: any[] = [];
  chemicalList: any[] = [];
  chemicalListPCR: any[] = [];
  chemicalMap = new Map();
  chemicalMapWithCovidBatchValues = new Map();
  rtPCRKitVendorList: any[] = [];
  lightCyclers: any[] = [];
  selectedResetStatus: string;
  mapOfStatus = new Map();
  mapOfStatusSaves = new Map();
  showPlateView = false;
  puidValidate: boolean;
  resultResponse: string;
  plateViewData: CovidSamples[] = [];
  plateViewDataFetched = false;
  plateMap = new Map();
  sampleBatch1Map = new Map();
  sampleBatch2Map = new Map();
  sampleBatch3Map = new Map();
  sampleBatch4Map = new Map();
  display: boolean = false;
  displayPCR: boolean = false;
  statusAtKitLot: boolean = false;
  statusAtCpValue: boolean = false;
  mapOfKits = new Map();
  public map = new Map<string, string>();
  public mapOfCpValue = new Map<string, string>();
  viewPlateIcon: string = "fa fa-th"
  NTCOk = false;
  IPCOk = false;
  plateOne: string;
  plateTwo: string;
  plateThree: string;
  plateFour: string;
  sampleBatch1: CovidSamples[] = [];
  sampleBatch2: CovidSamples[] = [];
  sampleBatch3: CovidSamples[] = [];
  sampleBatch4: CovidSamples[] = [];
  sampleBatch1PosControlsPositions: string[] = [];
  sampleBatch2PosControlsPositions: string[] = [];
  sampleBatch3PosControlsPositions: string[] = [];
  sampleBatch4PosControlsPositions: string[] = [];
  sampleBatch1PosControlsPositionsturned: string[] = [];
  sampleBatch2PosControlsPositionsturned: string[] = [];
  sampleBatch3PosControlsPositionsturned: string[] = [];
  sampleBatch4PosControlsPositionsturned: string[] = [];
  backGroundColor: string;
  circleBorder: string;
  crossWidth: string;
  crossColor: string;
  circleStroke: string;
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  columnHeaders384 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  rowHeaders384 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

  columnHeaders96Odd = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  rowHeaders96Odd = ['A', 'C', 'E', 'G', 'I', 'K', 'M', 'O'];

  columnHeaders96Even = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  rowHeaders96Even = ['B', 'D', 'F', 'H', 'J', 'L', 'N', 'P'];

  controlArray = ['POS_EX', 'NTC_EX', 'PCR-PC', 'PCR-NTC'];

  isLoadStandardPrimerPlate: boolean = false;
  sampleSearchDisabled = true;
  batchSearchDisabled = true;
  myFiles: string[] = [];
  ixoFiles: string[] = [];
  isResultUploadDisabled: boolean = true;
  missingBarcodesList: string[];
  samplePopVisible = false;
  selectedSample: CovidSamples = new CovidSamples();
  isResultGroup: boolean = false;
  resultGroupMap: Map<string, any> = new Map<string, any>();
  samplePosition = '';
  sampleType = '';
  tempSampleComment: string;
  tempSampleInvalid: boolean;
  tempSampleResult: string;
  tempICRResult: boolean;
  sampleResultOptions: SelectItem[] = [];
  sampleResultOptionsWithoutPositive: SelectItem[] = [];
  currentScannedSampleCount = 0;
  icrPresentInKit = false;
  icrResultOptionsNormal = [
    { value: true, label: 'Positive' },
    { value: false, label: 'Negative' }
  ];
  icrResultOptionsNegative = [
    { value: true, label: 'Negative' },
    { value: false, label: 'Positive' }
  ];
  positiveControlResultOptions = [
    { value: 'positive', label: 'Passed' },
    { value: 'negative', label: 'Failed' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' },
    { value: 'report', label: 'Report'}
  ];
  resultGroupControlResultOptions: SelectItem[] = [];
  negativeControlResultOptions = [
    { value: 'positive', label: 'Failed' },
    { value: 'negative', label: 'Passed' },
    { value: 'check', label: 'Check' },
    { value: 'ambiguous', label: 'Ambiguous' },
    { value: 'invalid', label: 'Invalid' },
    { value: 'report', label: 'Report'}
  ];

  uploadedTxtFiles: string[] = [];
  uploadedxlsxFiles: string[] = [];
  uploadedPCRDFiles: string[] = [];
  uploadedXMLFiles: string[] = [];
  uploadedCSVFiles: string[] = [];
  bioradLimsFiletypes: Array<string> = ['xlsx', 'pcrd', 'ixo', 'csv'];
  fastFinderFiletypes: Array<string> = ['xlsx', 'pcrd', 'ixo', 'csv'];
  quantStudio5FileTypes: Array<string> = ['xlsx'];
  filetypes: Array<string> = ['ixo', 'txt', 'xml', 'csv'];
  readonly emptyGeneName = 'Empty';
  gene: string = this.emptyGeneName;
  allChecksResolved = true;
  dominantChannelName: string;

  finalStatusList = [
    { label: 'Report', value: 'Report' },
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Redo Lysis', value: 'Redo_Lysis' },
    { label: 'Check', value: 'Check' }
  ];

  finalStatusListWithoutLysis = [
    { label: 'Report', value: 'Report' },
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Check', value: 'Check' }
  ];

  redoStepList = [
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Redo Lysis', value: 'Redo_Lysis' }
  ];

  statusSelectionList = [
    { label: 'Start Clipping', value: 'START_CLIPPING' },
    { label: 'Complete Clipping', value: 'COMPLETE_CLIPPING' },
    { label: 'Start Lysis', value: 'START_LYSIS' },
    { label: 'Complete Lysis', value: 'COMPLETE_LYSIS' },
    { label: 'Verify Reception', value: 'SAMPLE_RECEPTION_CHECKED' },
    { label: 'Start Extraction', value: 'START_EXTRACTION' },
    { label: 'Start Extractor', value: 'START_EXTRACTOR' },
    { label: 'Complete Extraction', value: 'EXTRACTION_COMPLETE' },
    { label: 'Start Precycling', value: 'START_PRECYCLING' },
    { label: 'Complete Precycling', value: 'COMPLETE_PRECYCLING' },
    { label: 'Start Cycling', value: 'START_CYCLING' },
    { label: 'Completed Cycling', value: 'CYCLER_COMPLETE' },
    { label: 'Start Analysis', value: 'ANALYSIS_STARTED' },
    { label: 'Complete Analysis', value: 'ANALYSIS_DONE' },
    { label: 'Complete Batch', value: 'COMPLETED' },
    { label: 'Remove Batch', value: 'REMOVED' },
    { label: 'ReceivedDNA', value: 'RECEIVED_DNA'}
  ];


  displayIndex:number;
  archiveBatchStatus = ["ARCHIVE_DEFINED","ARCHIVED"];
  verifyArchiveBatches : string[] = [];
  verifyArchiveSourceBatches : string[] = [];
  noOftabs: number;
  batchVerifiedCount: number;
  groupedBatches: BatchGroup[] = [];
  batchHistoryId : string;
  batchHistory: SelectItem[] = [];

  // table properties and values
  processSteps: any[];
  filterOptions: any[];
  selectedStates: string[] = [];
  blocked = false;
  loading: boolean;
  fromDate: Date;

  colorList = ['red','green','blue','black','brown'];

  // Scan related properties
  scanTableArray: CovidSamples[] = [];
  scannedControls: CovidSamples[] = [];
  showSampleErrorPopUp = false;
  scannedSampleErrorMessage = '';
  currentScanCell = 0;
  scanAllowedStates = ['SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'];
  mapOfScannedBarcodes: Map<string, string>;
  scanTableBackupMap: Map<string, CovidSamples>;

  posControlsForLab: number;
  negativeControlForLab: number;
  posControlsRemaining: number;
  negativeControlRemaining: number;

  activateSaveScan = false;
  contaminationPopUp = false;
  scannedBarcode = '';
  showDifferentUnboxedErrorPopUp = false;
  differentUnboxedErrorDisabled = false;
  dirty = false;
  scanDialogMessage = 'Scan RNA Plate changes not yet saved. Do you wish to proceed?';
  redoDialogMessage = 'Are you are sure to do the redo?';
  scanBlock = false;
  sameScanBatch = false;
  saveScanErrorHeader = '';
  saveScanErrorBody = '';

  verifyReceptionPUID = false;
  verifyUndoMergePUID = false;
  showFilledTemplateLabel: boolean = false;
  storage: string;
  enteredPuid: string;
  enteredPassword: string;
  enteredPasswordToByeArray: any[];
  puidPopup: boolean = false;
  puidPopupFunction: string;
  counter: number;

  previewComment: Comment;
  showCommentDialog = false;
  commentsMap = new Map<string, Comment[]>();
  newComment: Comment;
  batchCommentVisibility: Map<string, boolean>;

  refStatusOfPrev: string;
  boxColor: string;
  redoReasonsPopup: boolean = false;
  selectedRedoReason: string;
  enteredRedoReason: string;
  selectedMergedBatch: MergedBatch;
  redoReasons: any[];
  machineShortInfos = new Map<string, string>();
  machineIOCapcity = new Map<string, string>();

  changedSampleList: CovidSamples[] = [];
  showAnalysisDialog = false;
  columnList: any[] = [];
  analysisVerifyPUID: string = null;
  commentPopup = false;
  externalFileTransferEnabled = false;
  mapOfSenders = new Map<string, any>();

  selectedLab: LabMDM;
  isIXOMandatory = false;

  bioRadMachineTypes = ["biorad", "biorad_dk"];
  mapOfMachineInfo = new Map<string, any>();
  selectedSender: SenderDTO;
  selectedExtractor: any;

  colorCodes : Map<string, any> = new Map();

  sampleHistoryMap: any;
  batchHeaders: string[] = [];
  selectedSampleHistoryMap: Map<string, Object> = null;

  reset: any[] = [{}];

  headerIndex = 0;
  analysisAndUpwardsStatuses = ['ANALYSIS_STARTED', 'ANALYSIS_DONE', 'REDO', 'DATA_READY', 'COMPLETED'];
  subSender = new Set();
  subSenderForPlateOne = new Set();
  subSenderForPlateTwo = new Set();
  subSenderForPlateThree = new Set();
  subSenderForPlateFour = new Set();
  colorSenderMap = new Map();
  colours = ['#ffb3b3', '#9999e6', '#ff80ff', '#a6a6a6', '#ff5050', '#33cccc', '#80ff80', '#ffaa00', '#0099ff', '#888844'];
  reportingOutsideBB = true;
  manufacturerConfigMap = new Map<string, any>();
  fileTypeCountMap = new Map<string, number>();
  manufacturerFileMandatoryMap = new Map<string, any>();
  filesPerManufacturerMap = new Map<string, FilesPerManufacturer[]>();
  missingFilesPopUp: boolean = false;
  missingPatterns: any[];
  totalPCRControls: number;
  selectableLab: SelectableLab;
  archiveBatchOptions: any[];
  selectedArchiveOption: string;
  filterMapOfSenders= new Map();
  mapOfMergeGroup = new Map();
  mergeBatchList:string[]=[];
  mergeGroupList: any[] = [];
  selectedMergeGroup: string[] = [];
  isFirstTime:boolean;
  singleSampleRedoCount: number;
  resultGroupsDropdown: SelectItem[] = [];
  selectedResultGroup: string;
  kitResults: string[] = [];
  kitimage: string="";
  kitConfirmed: boolean;
  isImageLoading: boolean = true;
  isUndoArchiveBtnDiabled:boolean=true;

  pcrKitForBatch: KitsDTO;
  pcrKitRedoInfoForBatch: any;
  selectedRedoReasonInfo: string;
  redoChannelList:any[]=[];
  askForChannelDisabled:boolean;
  selectedRedoReasonStep:string;
  selectedRedoReasonChannel:string;
  redoChannel:string;
  noRedoReasonConfiguredForLab:boolean = false;
  redoReasonsForLab: any[];
  resultReportPerSender: boolean = false;
  controlType= 'controls';
  controls: Controls[] = []
  mapOfControls = new Map();

  positiveControlRegex: string = "R\\d{2}_D_\\d{3}";
  negativeControlRegex: string = "Negative";
  positiveControlSampleType: string = 'POSITIVE_CONTROL';
  negativeControlSampleType: string = 'NEGATIVE_CONTROL';
  sampleSampleType: string = 'SAMPLE';

  positiveControlsCountForControl: number;
  negativeControlsCountForControl: number;
  positivePCRControlsCountForControl: number;
  negativePCRControlsCountForControl: number;
  
  controlStatus : ControlStatus[] = [];

  mapOfUndefinedPositonArray = [];

  mapOfPositiveAndNegativePositions= new Map();
  positiveExtractionControlArray = [];
  negativeExtractionControlArray = [];
  positivePCRExtractionControlArray = [];
  negativePCRExtractionControlArray = [];
  mapOfParticularControl = new Map();
  gettingPositivePositionKeys = [];
  gettingNegativePositionKeys = [];
  gettingPositivePCRPositionKeys = [];
  gettingNegativePCRPositionKeys = [];
  getPositivePosition = [];
  getNegativePosition = [];
  getPositivePCRPosition = [];
  getNegativePCRPosition = [];
  positiveExtractionRegexControl = [];
  negativeExtractionRegexControl = []
  positionString : String;
  isControl: boolean = false;
  currentRegexFormat: string;
  positivePCRExtractionRegexControl = [];
  negativePCRExtractionRegexControl = [];

  orderList:any;

  strResultStatus: string = "";

  strpResultStatus: string = "";

  testResultStatus: string = "";

  delivery: any;

  parentalResult: any = "";
 
  genevalue:any=[];

  strMarker:any[];
  workFlowNameList: string[] = [];
  workFlowData: WorkFlow[] = [];
  workFlowList=[];
  isValidMatch: boolean;
  matchingUnboxedSample:Map<string, UnboxedSample>;

  constructor(private _messagesService: MessagesService, private apgTestingService: APGTestingService, private formBuilder: FormBuilder, private confirmationService: ConfirmationService, private masterDataService: MasterDataService, public datepipe: DatePipe) {}

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    if (this.dirty) {
      event.returnValue = false;
    }
  }

  canDeactivate() {
    if (this.dirty) {
      return confirm(this.scanDialogMessage);
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.selectedBatch = new AnimalBatch();
    this.previewComment = new Comment();
    this.commentsMap = new Map<string, Comment[]>();
    this.newComment = new Comment();
    this.batchCommentVisibility = new Map<string, boolean>();
    this.selectedBatch.sender = '';
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;
    this.reportingOutsideBB = this.selectableLab.lab.reportingOutsideBB;
    this.findControlesDetails();

    this.puid = localStorage.getItem('PUID');
    this.showAnalysisDialog = false;
    this.populateSenders();
    this.getAllActiveWorkFlowList();
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });

    this.processSteps = [
      { field: 'Recepetion', header: 'Recepetion' },
      { field: 'Extraction', header: 'Extraction' },
      { field: 'PCR', header: 'PCR' },
      { field: 'Result', header: 'Result' }
    ];

    this.filterOptions = [
      { label: 'Scan Complete', value: 'SCAN_COMPLETE' },
      { label: 'Start Clipping', value: "START_CLIPPING" },
      { label: 'Complete Clipping', value: "COMPLETE_CLIPPING" },
      { label: 'Start Lysis', value: "START_LYSIS" },
      { label: 'Complete Lysis', value: "COMPLETE_LYSIS" },
      { label: 'Start Extraction', value: "START_EXTRACTION" },
      { label: 'Start Extractor', value: "START_EXTRACTOR" },
      { label: 'Complete Extraction', value: "EXTRACTION_COMPLETE" },
      { label: 'Start Analysis', value: "ANALYSIS_STARTED" },
      { label: 'Complete Analysis', value: "ANALYSIS_DONE" },
      { label: 'Data Ready', value: "DATA_READY" },
      { label: 'Complete Batch', value: "COMPLETED" },
      { label: 'ReceivedDNA', value: "RECEIVED_DNA" },
      { label: "Cancel Batch", value: "CANCELED"}
    ];
    this.senderList = [
      { value: 'GeLaMed', label: 'GeLaMed' },
      { value: 'LifeCodexx County Pathology', label: 'LifeCodexx County Pathology' },
      { value: 'LifeCodexx Megalab', label: 'LifeCodexx Megalab' },
      { value: 'LifeCodexx Biomnis Ireland Limited', label: 'LifeCodexx Biomnis Ireland Limited' },
      { value: 'LifeCodexx Portugal', label: 'LifeCodexx Portugal' },
      { value: 'Internal', label: 'Internal' }
    ];
    this.mapOfStatus.set('Registration', ["SCAN_COMPLETE", "START_CLIPPING"]);
    this.mapOfStatus.set('Lysis', ["START_LYSIS", "COMPLETE_CLIPPING"]);
    this.mapOfStatus.set('RNA Isolation', ["START_EXTRACTION", "START_EXTRACTOR", "COMPLETE_LYSIS"]);
    this.mapOfStatus.set('Precycling', ["EXTRACTION_COMPLETE", "START_PRECYCLING"]);
    this.mapOfStatus.set('RT PCR', ["START_CYCLING", "COMPLETE_PRECYCLING"]);
    this.mapOfStatus.set('Data Evaluation/Reporting', ["EXTRACTION_COMPLETE","RECEIVED_DNA","COMPLETED"]);
    this.mapOfStatus.set('Export Data', ["COMPLETE_CLIPPING","COMPLETE_LYSIS","RECEIVED_DNA","START_EXTRACTOR","START_EXTRACTION","START_PRECYCLING","EXTRACTION_COMPLETE"]);
    this.mapOfStatus.set('Transfer DNA', ["COMPLETE_LYSIS"]);

    this.mapOfStatusSaves.set("CREATE_BATCH", "createBatch");
    this.mapOfStatusSaves.set("START_CLIPPING", "startClipping");
    this.mapOfStatusSaves.set("COMPLETE_CLIPPING", "completeClipping");
    this.mapOfStatusSaves.set("SAMPLE_RECEPTION_CHECKED", "sampleReceptionChecked");
    this.mapOfStatusSaves.set("START_LYSIS", "startLysis");
    this.mapOfStatusSaves.set("COMPLETE_LYSIS", "completeLysis");
    this.mapOfStatusSaves.set("START_EXTRACTION", "startExtraction");
    this.mapOfStatusSaves.set("START_EXTRACTOR", "startExtractor");
    this.mapOfStatusSaves.set("EXTRACTION_COMPLETE", "extractionComplete");
    this.mapOfStatusSaves.set("START_CYCLING", "startCycling");
    this.mapOfStatusSaves.set("SPLIT", "splitBatch");
    this.mapOfStatusSaves.set("CYCLER_COMPLETE", "cyclerComplete");
    this.mapOfStatusSaves.set("ANALYSIS_STARTED", "analysisStarted");
    this.mapOfStatusSaves.set("ANALYSIS_DONE", "analysisOne");
    this.mapOfStatusSaves.set("COMPLETED", "completeBatch");
    this.mapOfStatusSaves.set("START_PRECYCLING", "startPreCycling");
    this.mapOfStatusSaves.set("COMPLETE_PRECYCLING", "completePreCycling");
    this.mapOfStatusSaves.set("RECEIVED_DNA", "receivedDNA");

    this.sampleResultOptions = [
      { value: 'positive', label: 'Positive' },
      { value: 'negative', label: 'Negative' },
      { value: 'check', label: 'Check' },
      { value: 'ambiguous', label: 'Ambiguous' },
      { value: 'invalid', label: 'Invalid' },
      { value: 'report', label: 'Report'}
    ];
    this.sampleResultOptionsWithoutPositive = [
      { value: 'negative', label: 'Negative' },
      { value: 'check', label: 'Check' },
      { value: 'ambiguous', label: 'Ambiguous' },
      { value: 'invalid', label: 'Invalid' },
      { value: 'report', label: 'Report'}
    ];
    
    this.archiveBatchOptions = [
      { label: 'Storage', value: 'Storage' },
      { label: 'Dispatch', value: 'Dispatch' },
      { label: 'Process', value: 'Process' }
    ];

    this.sortAllDropDown();

    let element = document.getElementById("userID");
    element.focus();
    this.isFirstTime=true;
  }

  private sortAllDropDown() {
    this.sortDropDown(this.senderList);
    this.sortDropDown(this.sampleResultOptions);
    this.sortDropDown(this.sampleResultOptionsWithoutPositive);
    this.sortDropDown(this.archiveBatchOptions);
    this.sortDropDown(this.statusSelectionList);
    this.sortDropDown(this.finalStatusListWithoutLysis);
    this.sortDropDown(this.finalStatusList);
  }

  private sortDropDown(dropDownList: any[]) {
    dropDownList.sort((data1: SelectItem, data2: SelectItem) => {
      return data1.label.localeCompare(data2.label);
    });
  }

  findControlesDetails() {
    this.masterDataService.findLabById(this.selectedLabId).subscribe(
      result => {
        if (result.data == null || result.data == undefined || result.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Lab not found!', detail: 'Contact Administrator to resolve this issue.' });
          return;
        }
        this.selectedLab = result.data;
        this.posControlsRemaining = this.selectedLab.numberOfPC;
        this.negativeControlRemaining = this.selectedLab.numberOfNC;
        this.posControlsForLab = this.selectedLab.numberOfPC;
        this.negativeControlForLab = this.selectedLab.numberOfNC;
        this.resultReportPerSender = this.selectedLab.resultReportPerSender;
        this.totalPCRControls = this.selectedLab.numberOfPositivePCRControls + this.selectedLab.numberOfNegativePCRControls;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  isSearchEnabled(): boolean {
    return (this.puid != null && this.puid != undefined && this.puid != "" && this.batchToSearch != null && this.batchToSearch != undefined && this.batchToSearch != "");
  }

  batchViewVisbility(event: any) {
    this.batchToSearch = event.data.batchID;
    this.sampleToSearch = '';
    this.searchForBatch();
  }

  searchBatch() {
    this.batchToSearch = this.batchHistoryId;
    this.searchForBatch();
  }

  boxCollapseResolver() {
    if (this.batchSearchDisabled) {
      this.batchSearchDisabled = false;
      return;
    }
    this.searchForBatch();
  }

  searchForBatch() {
    if (this.batchToSearch == null || this.batchToSearch == undefined || this.batchToSearch == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to search' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: this.scanDialogMessage,
        header: 'Discard Changes?',
        accept: () => {
          this.dirty = false;
          this.searchForBatchAction(this.selectedLabId, this.batchToSearch.trim());
        },
        reject: () => { }
      });
    } else {
      this.searchForBatchAction(this.selectedLabId, this.batchToSearch.trim());
    }
  }

  searchForBatchAction(labID: string, batchID: string) {
    this.blocked = true;
    this.batchHistoryId = '';
    this.subSender.clear();
    this.subSenderForPlateOne.clear(); 
    this.subSenderForPlateTwo.clear();
    this.subSenderForPlateThree.clear();
    this.subSenderForPlateFour.clear();
    this.apgTestingService.getBatchForLabAndBatchId(labID, batchID).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.findKit();
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          if (this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
            this.getSubSenders();
            this.getResultOfSTRProfile();
            this.getResultOfParentage();
            this.getResultOfGeneTests();
          }
          this.commentsMap = new Map<string, Comment[]>();
          this.setBatchView();
          this.differentUnboxedErrorDisabled = false;
          this.allowCreate = false;
          this.plateViewDataFetched = false;
          this.sampleToSearch = '';
          this.batchToSearch = '';
          this.batchSearchDisabled = true;
          this.mapOfKits = new Map();
          this.extractionKitVendorList = [];
          this.rtPCRKitVendorList = [];
          this.setTemplateButtonLabel();
          this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
          this.chemicalMapWithCovidBatchValues = new Map();
          if (this.selectedSender) {
            this.getMachinesFromMDM();
            this.getKitsFromMDM();
          }
          this.fetchArchiveData();
          this.getResultConfigBykitCycler(this.selectedBatch.rtPCRKitVendor, this.selectedBatch.cyclerManufacturer, this.selectedBatch.lab);
          if (this.selectedBatch.chemicalInfoWithLotNos != null && this.selectedBatch.chemicalInfoWithLotNos != undefined) {
            this.chemicalMapWithCovidBatchValues = new Map(Object.entries(this.selectedBatch.chemicalInfoWithLotNos));
          }
        } else {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with BatchID ' + this.batchToSearch });
        }
        this.externalFileTransferEnabled = false;
        this.isIXOMandatory = false;
        this.checkForAutomatedFileTransfer()
        this.getManufacturerConfig();
        this.showBatch = true;
        this.blocked = false;
        this.kitConfirmed = false;
        this.serviceCallForControls();
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.plateViewDataFetched = false;
        this.setBatchView();
      }
    );

  }

  verifyArchiveBatch(tabNo) {
    let count = 0;
    let message = "";
    if(this.verifyArchiveSourceBatches[tabNo] != this.selectedBatch.batchID){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Target Batch',
        detail: 'Please verify target batch',
      });
      return;
    }
    for (let index = this.indexStartValue(tabNo); index < this.tabEndValue(tabNo); index++) {
      if (this.verifyArchiveBatches[index] != this.selectedBatch.archiveBatchSources[index]) {
        message = message + (message.trim() != "" ? ", " : "");
        message = message + this.selectedBatch.archiveBatchSources[index];
      } else if (this.verifyArchiveBatches[index] == this.selectedBatch.archiveBatchSources[index]) {
        count++;
      }
    }
    if (message.trim() != "") {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid Batch Verification',
        detail: 'Please verify these batches ' + message,
      });
      return;
    }
    this.selectedBatch.verifiedArchiveBatchSources = Object.assign([], this.verifyArchiveBatches);
    this.blocked = true;
    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.batchVerifiedCount = this.batchVerifiedCount + count;
          if(tabNo != (this.noOftabs-1)){
          this.displayIndex = tabNo+1;
          this.focusTargetBatch(tabNo+1);
          }
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
          });
          this.blocked = false;
        }
      },
      error => {
        let errormessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errormessage);
      }
    );
  }
  noOfTabsArray(numberOfTabs) {
    // for (let index = 0; index < numberOfTabs; index++) {
    //   if(this.isTabVerifyComplte(index))

    // }
    return Array(numberOfTabs);
  }
  indexStartValue(tabIndex) {
    return ((tabIndex) * APGCovid19Constants.archiveBatchesPerPlate)
  }
  tabStartValue(tabIndex) {
    return ((tabIndex * APGCovid19Constants.archiveBatchesPerPlate) + 1);
  }
  tabEndValue(tabIndex) {
    let end = (tabIndex + 1) * APGCovid19Constants.archiveBatchesPerPlate;
    return end > this.selectedBatch.archiveBatchSources.length ? this.selectedBatch.archiveBatchSources.length : end;
  }
  getArrayOfRows() {
    return Array(3);
  }
  enableArchiveButton() {
    return !(this.selectedArchiveOption && this.selectedBatch.archiveBatchSources && this.batchVerifiedCount == this.selectedBatch.archiveBatchSources.length);
  }
  isBatchPresent(number) {
    return this.selectedBatch.verifiedArchiveBatchSources[number * 9] != undefined && this.selectedBatch.verifiedArchiveBatchSources[number * 9] != null && this.selectedBatch.verifiedArchiveBatchSources[number * 9] != "";
  }
  isTabVerifyComplte(tabNumber) {
    let verified = this.isBatchPresent(tabNumber);
    return verified;
  }
  getArchivePositionForColumn(rowNumber: number, columnNumber: number) {
    if (rowNumber == 0)
      return 9 - columnNumber;
    else if (rowNumber == 1)
      return 6 - columnNumber;
    else if (rowNumber == 2)
      return 3 - columnNumber;
    return 0;
  }
  isArchiveBatchesToDisplay() {
    return this.selectedBatch.archiveBatchSources && this.selectedBatch.archiveBatchSources.length > 0;
  }
  getPlaceHolder(tabIndex, index) {
    return this.selectedBatch.archiveBatchSources[this.getValueOfIndex(tabIndex, index)] != undefined ? this.selectedBatch.archiveBatchSources[this.getValueOfIndex(tabIndex, index)] : "";
  }
  getValueOfIndex(tabIndex, index) {
    return (tabIndex * 9) + index - 1;
  }
  isArchiveDisabled(tabIndex, index) {
    return (this.getValueOfIndex(tabIndex, index) + 1) > this.selectedBatch.archiveBatchSources.length ? true : false;
  }
  nextBatchFocus(i,j,num){
    let index = 'batch'+i+j+num;
    if(i == (this.noOftabs-1) && j!=2){
      if(this.callArchiveDisabled(i,j,2) || this.callArchiveDisabled(i,j,1) || this.callArchiveDisabled(i,j,0))
        this.callforInactiveFocus(i,j);
    }
    let element = document.getElementById(index);
    if(element!=null){
       element.focus();
    }
  }
  callArchiveDisabled(i,j,number){
    return this.isArchiveDisabled(i,this.getArchivePositionForColumn(j,number));
  }
  callforInactiveFocus(i,j){
    this.nextBatchFocus(i,j+1,'0');
  }
  onTabChange(event){
    this.displayIndex = event.index;
    this.focusTargetBatch(event.index);
  }
  focusTargetBatch(value){
    setTimeout(() => {
      let index = 'targetbatch'+value;
     let element = document.getElementById(index);
      if(element!=null)
          element.focus();
    }, 100);
  }
  fetchArchiveData() {
    if (this.selectedBatch && this.archiveBatchStatus.includes(this.selectedBatch.statusOfTheBatch.trim()) && this.selectedBatch.archiveBatchSources && this.selectedBatch.archiveBatchSources.length) {
      this.batchVerifiedCount = 0;
      this.verifyArchiveSourceBatches = [];
      this.displayIndex =0;
      this.verifyArchiveBatches = Object.assign([], this.selectedBatch.verifiedArchiveBatchSources);
      for (let index = 0; index < this.selectedBatch.archiveBatchSources.length; index++) {
        if (this.isBatchFound(index)) {
          this.batchVerifiedCount++;
        }
      }
      this.noOftabs = this.selectedBatch.archiveBatchSources.length / 9;
      this.noOftabs =  Math.ceil(this.noOftabs);
      for (let index = 0; index < this.noOftabs; index++) {
        if (this.isTabVerifyComplte(index) ){
          this.verifyArchiveSourceBatches[index] = this.selectedBatch.batchID;
          if ((index + 1) * APGCovid19Constants.archiveBatchesPerPlate <= this.selectedBatch.archiveBatchSources.length) {
            this.displayIndex = index + 1;
        }
      }
      }
      this.showPlateView = true;
      this.plateViewDataFetched = false;
    }
  }
  isBatchFound(index) {
    return this.verifyArchiveBatches[index] != undefined && this.verifyArchiveBatches[index] != null && this.verifyArchiveBatches[index] != "";
  }
  getResultConfigBykitCycler(kitLot: string, cycler: string, lab: string) {
    this.resultGroupMap = new Map<string, any>();
    if (kitLot && cycler) {
      this.apgTestingService.getResultConfigBykitCycler(kitLot, cycler, lab).subscribe(
        result => {
          this.resultGroupMap = <Map<string, any>>result.data;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          if (message.detail.includes('No Result Configs found in MDM'))
            return;
          this._messagesService.addErrorMessage(message);
        }
      );
    }
  }

  checkForAutomatedFileTransfer() {
    this.apgTestingService.getProcessList(this.selectedBatch.lab, this.selectedBatch.mergeGroup).subscribe(
      result => {
        if (result && result.data && result.data.length > 0) {
          this.externalFileTransferEnabled = true;
          result.data.forEach(resultProcess => {
            if (resultProcess.mergeGroup == this.selectedBatch.mergeGroup && resultProcess.rawDataRequired) {
              this.isIXOMandatory = true;
            }
          });
        }
      });
  }

  removeBatch(remvoedStatus: string) {
    this.updateBatch(remvoedStatus);
  }

  saveBatchData() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.userID = this.puid;
    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.enteredPassword = "";
          this.enteredPuid = "";
          if (this.allowCreate) {
            this.allowCreate = false;
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Batch Created!',
              detail: 'Batch ' + this.selectedBatch.batchID + ' has been created successfully '
            });
            this.blocked = false;
            return;
          } else {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Batch Updated!',
              detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
            });
            this.blocked = false;
          }
        }
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        this.selectedBatch.statusOfTheBatch = this.refStatusOfPrev;
        this.selectedBatch.previousStatusOfTheBatch = this.refStatusOfPrev;
        this.enteredPassword = "";
        this.enteredPuid = "";
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  createBatch(createButton: string) {
    this.selectedBatch._id = null;
    this.selectedBatch.receptionDateTime = new Date();
    this.selectedBatch.puidUnboxing = this.puid;
    this.selectedBatch.statusOfTheBatch = createButton;
    this.selectedBatch.previousStatusOfTheBatch = createButton;
    this.selectedBatch.lab = this.selectedLabId;
    this.saveBatchData();
  }

  updateBatch(statusOfBatch: string) {
    this.refStatusOfPrev = this.selectedBatch.previousStatusOfTheBatch;
    this.selectedBatch.statusOfTheBatch = statusOfBatch;
    this.selectedBatch.previousStatusOfTheBatch = statusOfBatch;
    this.saveBatchData();
  }

  startClipping(status: string) {
    this.selectedBatch.clippingStartDateTime = new Date();
    this.updateBatch(status);
  }

  completeClipping(status: string) {
    this.selectedBatch.clippingCompletionDateTime = new Date();
    this.updateBatch(status);
  }

  showVerifyReceptionPopUp() {
    const { lab, unboxedSamples, samples } = this.selectedBatch;
    if (unboxedSamples.length) {
      this.blocked = true;
      const filterCodes: Set<string> = new Set<string>(['POS_EX', 'NTC_EX', 'NC-DUMMY']);
      const unboxedSampleBarcodes: Array<string> = unboxedSamples.map((unboxedSample: UnboxedSample) => unboxedSample.eurofinsBarcode);
      const sampleBarcodes: Array<string> = samples.map((sample: CovidSamples) => sample.barcode);
      const combinedBarcodes: Array<string> = unboxedSampleBarcodes.concat(sampleBarcodes).filter((barcode: string) => !filterCodes.has(barcode.toUpperCase()));
      this.apgTestingService.getUnclippedSamples(lab, combinedBarcodes).subscribe((response: any) => {
        this.blocked = false;
        this.showUnClippedWarningPopup(response.data);
      }, (error: any) => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      });
    } else {
      this.openVerifyReceptionPopup();
    }
  }

  showUnClippedWarningPopup(data: Array<string>) {
    if (data.length) {
      const message = `Not all samples has been clipped<br>
      ${data.length <= 10 ?
          `Below are the list of unclipped sample barcodes<br>
         ${data.join(' , ')}<br>` :
          `${data.length} samples are unclipped<br>`
        }
       If you still want to proceed click 'Yes'`
      this.confirmationService.confirm({
        message: message,
        acceptLabel: 'Yes',
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle warning',
        key: 'warning',
        accept: () => {
          this.openVerifyReceptionPopup();
        },
        reject: () => { }
      });
    } else {
      this.openVerifyReceptionPopup();
    }
  }

  openVerifyReceptionPopup() {
    this.enteredPassword = "";
    this.enteredPuid = "";
    this.enteredPasswordToByeArray = [];
    setTimeout(() => {
      this.searchElement1.nativeElement.focus();
    }, 1000);
    this.verifyReceptionPUID = true;
  }

  verifyReceptionPUIDAction(vrPUID: string, vrPassword: string) {
    if (vrPUID.toUpperCase() == this.selectedBatch.puidCompleteClipping.toUpperCase()) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'PUID Verification Failed!',
        detail: 'Reception verification has to be done by a user other than clipping user.',
      });
    } else {
      this.verifyReceptionPUID = false;
      this.verifyReception(vrPUID, vrPassword);
    }
  }

  verifyReception(vrPUID: string, vrPassword: string) {
    var password = this.convertStringToUTF8ByteArray(vrPassword);
    this.sampleReceptionChecked('SAMPLE_RECEPTION_CHECKED', vrPUID, password);
    this.getSubSenders();
  }

  sampleReceptionChecked(sampleReceptionCheckedVal: string, vrPUID: string, vrPassword: any[]) {
    if (this.allControlsNotPresent()) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'All controls not present!',
        detail: 'All controls have not been inserted for the plate.' +
          ' Please insert all the controls in \'Scan RNA Plate\' section',
      });
      return;
    }
    this.showFilledTemplateLabel = true;
    this.selectedBatch.completenessCheckDateTime = new Date();
    this.selectedBatch.puidController2 = vrPUID;
    this.selectedBatch.username = vrPUID;
    this.selectedBatch.password = vrPassword;
    this.selectedBatch.eventForAuthorization = true;
    this.plateViewDataFetched = false;
    this.updateBatch(sampleReceptionCheckedVal);
  }

  showVerifyMergeUndoPopUp() {

    this.enteredPassword = "";
    this.enteredPuid = "";
    this.enteredPasswordToByeArray = [];
    setTimeout(() => {
      this.searchElement3.nativeElement.focus();
    }, 1000);
    this.verifyUndoMergePUID = true;
  }


  verifyUndoMergeAction(vrPUID: string, vrPassword: string, _statusBatch: string) {
    this.verifyUndoMergePUID = false;
    var password = this.convertStringToUTF8ByteArray(vrPassword);
    this.verifyUndoMergeActionChecked(vrPUID, password);
  }

  verifyUndoMergeActionChecked(vrPUID: string, vrPassword: any[]) {
    this.selectedBatch.undoMergeDateTime = new Date();
    this.selectedBatch.puidUndoMerge = vrPUID;
    this.selectedBatch.username = vrPUID;
    this.selectedBatch.password = vrPassword;
    this.selectedBatch.eventForAuthorization = true;
    this.undoMerge();

  }

  undoMerge() {
    this.apgTestingService.undoMerge(this.selectedBatch).subscribe(
      result => {
        this.selectedBatch = result.data;
        this.enteredPassword = "";
        this.enteredPuid = "";
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Undo Merge Completed!',
          detail: 'Batch ' + this.selectedBatch.batchID + ' has been unmerged successfully'
        });

      },
      error => {
        this.enteredPassword = "";
        this.enteredPuid = "";

        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  startLysis(status: string) {
    this.selectedBatch.lysisStartDateTime = new Date();
    this.updateBatch(status);
  }

  completeLysis(status: string) {
    this.selectedBatch.lysisCompletionDateTime = new Date();
    this.updateBatch(status);
  }
  receivedDNA(status: string) {
    this.selectedBatch.receivedDnaDateTime = new Date();
    this.updateBatch(status);
  }
  completeBatch(status: string) {
    // check if all samples of this selected batch having complete results
    var isBatchComplete = true;
    var batchInCompleteSummary = '';
    var batchInCompleteDetail = '';
    if(this.selectedBatch.samples!=null && this.selectedBatch.samples.length!=0){
      this.selectedBatch.samples.forEach(sample => {
        if(sample.sampleType=='SAMPLE' && sample.orderStatus!='COMPLETE'){
          isBatchComplete = false;
       }
      })
      batchInCompleteDetail = 'All samples of this batch does not have complete results, please check and try again';
      batchInCompleteSummary = 'Batch is incomplete';
    }  
    else{
      if(this.selectedBatch.unboxedSamples!=null){
        this.selectedBatch.unboxedSamples.forEach(unboxedSample => {
          if(!unboxedSample.clipped){
            isBatchComplete = false;
          }
        })
      }
      batchInCompleteDetail = 'All samples received/unboxed under this batch are yet to be clipped on to analysis batches';
      batchInCompleteSummary = 'Reception Batch is incomplete';
    }
    if(!isBatchComplete){
      this._messagesService.addErrorMessage({
         severity: 'error', summary: batchInCompleteSummary,
        detail: batchInCompleteDetail
      })
      return;
    }
    this.selectedBatch.completeBatchDateTime = new Date();
    this.updateBatch(status);
  }

  startExtraction(startExtractionVal: string) {
    this.selectedBatch.startExtraction = new Date();
    this.selectedBatch.puidStartExtraction = this.enteredPuid;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.enteredPasswordToByeArray;
    this.selectedBatch.eventForAuthorization = false;
    this.updateBatch(startExtractionVal);
  }
  startExtractor(startExtractorVal: string) {
    this.selectedBatch.startExtractorDateTime = new Date();
    this.updateBatch(startExtractorVal);
  }

  extractionComplete(extractionCompleteVal: string) {
    this.selectedBatch.completionDateTimeExtraction = new Date();
    this.selectedBatch.puidExtraction = this.enteredPuid;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.enteredPasswordToByeArray;
    this.selectedBatch.eventForAuthorization = false;
    this.updateBatch(extractionCompleteVal);
  }

  startPreCycling(startPreCyclingVal: string) {
    this.selectedBatch.precyclingStartDateTime = new Date();
    this.selectedBatch.puidstartPrecycling = this.enteredPuid;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.enteredPasswordToByeArray;
    this.selectedBatch.eventForAuthorization = false;
    this.updateBatch(startPreCyclingVal);
  }

  completePreCycling(completePreCyclingVal: string) {
    this.selectedBatch.precyclingCompletionDateTime = new Date();
    this.selectedBatch.puidCompletePrecycling = this.enteredPuid;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.enteredPasswordToByeArray;
    this.selectedBatch.eventForAuthorization = false;
    this.updateBatch(completePreCyclingVal);
  }

  splitBatch(splitBatch: string) {
    this.selectedBatch.splitBatchDateTime = new Date();
    this.selectedBatch.puidSplitBatch = this.enteredPuid;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.eventForAuthorization = false;
    this.updateBatch(splitBatch);
    this.splitTheBatch();
  }
  splitTheBatch() {
    this.blocked = true;
    this.selectedBatch.mergedBatches.forEach(element => {
      var splitBatchDTO = {} as SplitBatchDTO;
      splitBatchDTO.status = 'CYCLER_COMPLETE';
      splitBatchDTO.quadrant = element.quadrant;
      splitBatchDTO.rtPCRKitVendor = this.selectedBatch.rtPCRKitVendor;
      splitBatchDTO.cyclerManufacturer = this.selectedBatch.cyclerManufacturer;
      splitBatchDTO.machineName1 =  this.selectedBatch.machineName1;
      splitBatchDTO.noOfPositivePCRControls = this.selectedLab.numberOfPositivePCRControls;
      splitBatchDTO.noOfNegativePCRControls = this.selectedLab.numberOfNegativePCRControls;
      this.apgTestingService.splitBatch(element.batchId, this.selectedLabId, splitBatchDTO).subscribe(
        _result => {
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Update Success', detail: 'Batch ' + element.batchId + ' update is successful' });
          this.blocked = false;
        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    });
  }
  startCycling(startCyclingVal: string) {
    this.selectedBatch.startDatePCR = new Date();
    this.selectedBatch.puidPCR2 = this.enteredPuid;
    this.plateViewDataFetched = false;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.enteredPasswordToByeArray;
    this.selectedBatch.eventForAuthorization = false;
    if (this.mapOfMachineInfo.get(this.selectedBatch.machineName1)) {
      this.selectedBatch.cyclerManufacturer = this.mapOfMachineInfo.get(this.selectedBatch.machineName1).manufacturer;
    }
    this.selectedBatch.samples = this.selectedBatch.samples.filter(sample => !['PCR-PC', 'PCR-NTC'].includes(sample.barcode));
    this.updateBatch(startCyclingVal);
    this.getManufacturerConfig();
  }

  cyclerComplete(cyclerComplete: string) {
    this.selectedBatch.completionDateTimePCR = new Date();
    this.selectedBatch.puidPCR1 = this.enteredPuid;
    this.selectedBatch.username = this.enteredPuid;
    this.selectedBatch.password = this.enteredPasswordToByeArray;
    this.selectedBatch.eventForAuthorization = false;
    this.updateBatch(cyclerComplete);
  }

  analysisOne(analysisOneVal: string) {
    if (this.selectedBatch.positiveResultCount > this.selectedBatch.sampleListSizeWithoutControls) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Incorrect Positive Count', detail: 'Positive Count must be less than or equal to the count of uploaded samples' });
      return;
    }
    this.selectedBatch.completionDateTimeEvaluation = new Date();
    this.updateBatch(analysisOneVal);
  }


  resultFileNameRegister(fileNamesSubmitted: string) {
    if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) {
      let missingPatterns = this.checkIfAllMandatoryFilesUploaded();
      if (missingPatterns && missingPatterns.length > 0) {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Files Missing!',
          detail: 'Not all Mandatory Files are Uploaded!',
        });
        return;
      }
    } else if (this.machineShortInfos.get(this.selectedBatch.machineName1) == APGCovid19Constants.bioradLimsMechine) {
      let csvFiles = Array.from(this.selectedBatch.csvFiles.values());
      if (csvFiles.length < 5) {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Missing CSV Files!',
          detail: 'At Least 5 CSV Files Should be Uploaded Before Sending The Files!',
        });
        return;
      }
    }
    this.selectedBatch.resultSentDateTime = new Date();
    this.updateBatch(fileNamesSubmitted);
  }

  returnCovidBatch(covidBatch: AnimalBatch, redoVal: string) {
    let covid = covidBatch;
    covid.statusOfTheBatch = redoVal;
    return covid;
  }

  updateListOfBatches() {
    this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe(
      results => {
        this.batches = results.data;
        this.selectedStates = [];
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  isPUIDPresnt() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  // the file to be uploaded is selected
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
      this.isUploadDisabled = false;
    } else {
      this.isUploadDisabled = true;
    }
  }

  showImage() {
    this.isImageLoading = false;
    let kit:any =this.getPcrKitFromMap(this.selectedBatch.rtPCRKitVendor);
    this.kitimage = "";
    if(kit.kitImageName){
    this.masterDataService.getKitImage(kit.kitName,kit.kitImageName).subscribe(
      results => {
        this.kitimage = 'data:image/jpeg;base64,' + results.data.contents;
       this.isImageLoading = true;
      },
      _error => {
        this.isImageLoading = true;
      },
      );
  } else {
    this.isImageLoading = true;
  }
  }


  submitfileForUpload(fileInput: HTMLInputElement) {
    if (this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
      this.confirmationService.confirm({
        message: 'The existing sample information will be overwritten if you go forward with uploaded excel. Do you wish to continue?',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.onSubmit(fileInput);
        },
        reject: () => {
        }
      });
    } else {
      this.onSubmit(fileInput);
    }
  }

  handleSucc(result: any) {
    if (!result) {
      return;
    }
    this.plateViewDataFetched = false;
    this.selectedBatch = result.data;
    this.previewComment = this.getPreviewComment(this.selectedBatch);
    this.commentsMap = new Map<string, Comment[]>();
    this.selectedBatch.excelUploadCreatedAt = new Date();
    this.selectedBatch.excelUploadCreatedBy = this.puid;
    this.isUploadDisabled = true;
    this.differentUnboxedErrorDisabled = false;
    this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Sample Uploaded', detail: 'Upload Successful' });
  }

  // on upload of the selected file
  onSubmit(fileInput: HTMLInputElement) {
    if (this.isPUIDPresnt()) {
      if (this.selectedBatch != null && this.searchForBatch != undefined && this.selectedBatch.batchID != null && this.selectedBatch.batchID != '' && this.selectedBatch.batchID != undefined) {
        this.selectedBatch.excelUploadCreatedAt = new Date();
        this.selectedBatch.excelUploadCreatedBy = this.puid;
        const formData = new FormData();
        const fileName = this.uploadForm.get('profile').value.name;        
        let fileExt = fileName.split('.').pop();
        formData.append('file', this.uploadForm.get('profile').value);
        formData.append('labId', this.selectedLabId);
        formData.append('batchID', this.selectedBatch.batchID);
        formData.append('excelUploadCreatedBy', this.selectedBatch.excelUploadCreatedBy);
        formData.append('initialValidationCall', 'true');
        let pc = this.selectedLab.numberOfPC == null ? 0 : this.selectedLab.numberOfPC;
        let nc = this.selectedLab.numberOfNC == null ? 0 : this.selectedLab.numberOfNC;
        formData.append("posExNtcExCount", String(pc + '-' + nc));
        var datestr = (new Date(this.selectedBatch.excelUploadCreatedAt)).toUTCString();
        formData.append('excelUploadCreatedAt', datestr);
        fileInput.value = null;
        if(fileExt.toUpperCase() === "CSV"){
          this.apgTestingService.uploadCSV(formData).subscribe(
            result => {
             this.handleSucc(result);
            },
            error => {             
                this.isUploadDisabled = true;
                let message = this.errorHandler.handleError(error);
                this._messagesService.addErrorMessage(message);
            }
          )
        }else{
          this.apgTestingService.uploadExcelSheet(formData,this.selectableLab.lab.clippingMachine).subscribe(
            result => {
              this.handleSucc(result);
            },
            error => {
              if (error.status == 424)
                this.showConfirmDialogForExcelUpload(error, formData);
              else {
                this.isUploadDisabled = true;
                let message = this.errorHandler.handleError(error);
                this._messagesService.addErrorMessage(message);
              }
            }
          )
        }
        
      } else {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Batch ID', detail: 'Please input proper Batch ID before uploading' });
      }
    } else {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before uploading',
      });
    }

  }

  onApplyFilter() {
    this.retainFilter();
    this.loading = true;
    if (!this.fromDate && (this.selectedStates == null || this.selectedStates.length == 0) && (this.selectedMergeGroup == null || this.selectedMergeGroup.length==0) && (this.workFlowNameList ==null|| this.workFlowNameList.length == 0)) {
      this.getAllBatchWithNoFilter();
    } else if ((this.selectedStates == null || this.selectedStates.length == 0) && (this.selectedMergeGroup != null && this.selectedMergeGroup.length > 0) && (this.workFlowNameList ==null || this.workFlowNameList.length == 0)) {
      this.mergeGroupApplyFilter();
    }else if(!this.fromDate && (this.selectedStates == null || this.selectedStates.length == 0) && (this.selectedMergeGroup == null || this.selectedMergeGroup.length==0)  && (this.workFlowNameList !=null || this.workFlowNameList.length !=0)){
      this.getSelectedWorkflowBatches();
    } else {
      let filterDate = this.getDate();
      sessionStorage.setItem('fromDate', JSON.stringify(filterDate));
      let selectedStatusList = this.getSelectedBatchState();
      let selectedMergeGroupList = '';
      let selectedWorkflowNamesList = '';
      if (this.selectedMergeGroup != null){
        selectedMergeGroupList = this.selectedMergeGroup.join(",");
      }
      if(this.workFlowNameList != null){
        selectedWorkflowNamesList = this.workFlowNameList.join(",");
        }
      this.getBatchWithAppliedFilters(selectedStatusList, filterDate, selectedMergeGroupList, selectedWorkflowNamesList);
      sessionStorage.setItem('selectedStates', JSON.stringify(this.selectedStates));
    }
    this.isFirstTime = false;

  }

  setBatchView() {
    this.showPlateView = false;
  }

  getViewPlateIcon() {
    if (this.showPlateView) {
      return 'fa fa-list-alt';
    } else {
      return 'fa fa-th';
    }
  }

  showWorkFile(){
    return this.selectedBatch.statusOfTheBatch == "ARCHIVE_DEFINED";
  }

  getWorkFile(){
    this.apgTestingService.getWorkFile(this.selectedBatch.batchID,this.selectedLabId).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, this.selectedBatch.batchID + ".zip");
      });
  }

  getFlowbotFile(){
    this.apgTestingService.getFlowbotFile(this.selectedBatch.batchID,this.selectedLabId).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, this.selectedBatch.batchID + "-flowbotONE.zip");
      },error => {
        let  message = { severity: 'error', summary: "Conflict", detail: error.bbApiError.message };
        this._messagesService.addErrorMessage(message);
      });
  }
  getPlateList(){
    this.blocked = true;
    let mapOfSourceBatchStorage = new Map();
    this.apgTestingService.getStorageLocations(this.selectedLabId, this.selectedBatch.archiveBatchSources).subscribe(
      results => {
        this.blocked = false;
        if(results.data == 'Plate Not Stored') {
          mapOfSourceBatchStorage = new Map();
        } else if(results.data) {
          mapOfSourceBatchStorage = new Map(Object.entries(results.data));
        }
        this.getStorageExcel(mapOfSourceBatchStorage);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      });
  }

  getStorageExcel(mapOfSourceBatchStorage: Map<string, string>) {
    this.blocked = true;
    let archiveRequestDTO = new ArchivePlateListRequestDTO();
    archiveRequestDTO.archiveBatchSourceIds = this.selectedBatch.archiveBatchSources;
    let storageObject = {};
    mapOfSourceBatchStorage.forEach((v: string, k: string) => {
      if(v) {
        storageObject[k] = v;
      }
    });
    archiveRequestDTO.mapOfSourceBatchStorage = storageObject;
    archiveRequestDTO.mapOfSourceBatchAndSampleCount = this.getMapOfSampleCount();
    this.apgTestingService.getPlateList(this.selectedBatch.batchID, this.selectedLabId, archiveRequestDTO).subscribe(
      results => {
        this.blocked = false;
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, this.selectedBatch.batchID + ".xlsx");
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  getMapOfSampleCount() {
    let sampleList = this.selectedBatch.samples;
    let sourceBatchIds = this.selectedBatch.archiveBatchSources;
    let sampleCountObject = {};
    let mapOfSourceBatchSlots = new Map<number, string>();
    for(let i = 1; i <= sourceBatchIds.length; i++) {
      sampleCountObject[sourceBatchIds[i-1]] = 0;
      mapOfSourceBatchSlots.set(i, sourceBatchIds[i-1], );
    }
    for(let j = 0; j < sampleList.length; j++) {
      let slot = sampleList[j].archiveSlot;
      let batchId = mapOfSourceBatchSlots.get(slot);
      sampleCountObject[batchId]++;
    }
    return sampleCountObject;
  }

  togglePlateView() {
    this.showPlateView = !this.showPlateView;
    this.kitConfirmed = false;
    if(this.showPlateView &&  this.archiveBatchStatus.includes(this.selectedBatch.statusOfTheBatch)){
      this.focusTargetBatch(this.displayIndex);
    }
    if (this.selectedBatch && (this.selectedBatch.wellType == WellType.WELL96) && this.showPlateView && this.isScanningAllowed()) {
      this.sameScanBatch = false;
      this.scanBlock = true;
    }
  }

  fetchDataForPlateView() {
    if (!this.selectedBatch.batchID) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'No Batch Selected', detail: 'Please select/search a batch first.' });
      return;
    }

    if (!this.plateViewDataFetched && !this.scanAllowedStates.includes(this.selectedBatch.statusOfTheBatch)) {
      this.apgTestingService.getPlateViewData(this.selectedBatch.batchID, this.selectedLabId).subscribe(
        results => {
          if (results.data) {
            this.createPlateMaps(results.data);
            this.togglePlateView();
            if (Object.keys(this.resultGroupMap).length > 0) {
              this.getKitValueForResultsLogic();
            }
          } else {
            this._messagesService.addWarningMessage({ severity: 'warn', summary: 'No Samples Found', detail: 'Please Upload samples for the current Batch' });
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    } else if (!this.plateViewDataFetched && this.scanAllowedStates.includes(this.selectedBatch.statusOfTheBatch)) {
      this.createPlateMaps(this.selectedBatch.samples);
      this.initializeScanTable(this.plateMap);
      this.val2 = '96 Detail';
      this.togglePlateView();
    } else {
      this.togglePlateView();
    }
    if (this.selectedBatch.wellType === "WELL384") {
      this.val2 = "384";
    } else if (this.selectedBatch.wellType === "WELL96" && !this.scanAllowedStates.includes(this.selectedBatch.statusOfTheBatch)) {
      this.val2 = "96";
    }
  }

  createPlateMaps(data: any) {
    this.plateOne = undefined;
    this.plateTwo = undefined;
    this.plateThree = undefined;
    this.plateFour = undefined;
    this.plateViewData = data;
    this.plateViewDataFetched = true;
    this.plateMap = new Map();
    this.sampleBatch1Map = new Map();
    this.sampleBatch2Map = new Map();
    this.sampleBatch3Map = new Map();
    this.sampleBatch4Map = new Map();
    this.sampleBatch1 = [];
    this.sampleBatch2 = [];
    this.sampleBatch3 = [];
    this.sampleBatch4 = [];
    this.sampleBatch1PosControlsPositions = [];
    this.sampleBatch2PosControlsPositions = [];
    this.sampleBatch3PosControlsPositions = [];
    this.sampleBatch4PosControlsPositions = [];
    this.sampleBatch1PosControlsPositionsturned =[];
    this.sampleBatch2PosControlsPositionsturned =[];
    this.sampleBatch3PosControlsPositionsturned =[];
    this.sampleBatch4PosControlsPositionsturned =[];
    this.plateMap = this.createMapOutOfCovidSamplesDifferentMap(this.plateViewData, 0, 0, 1);
    this.counter = 0;
    if (this.selectedBatch.wellType === WellType.WELL384) {
      this.getPlateNames(this.selectedBatch.mergedBatches);
      for (let i = 0; i < this.selectedBatch.samples.length; i++) {
        if (this.selectedBatch.samples[i].positionRow % 2 != 0 && this.selectedBatch.samples[i].positionCol % 2 != 0) {
          this.sampleBatch1.push(this.selectedBatch.samples[i]);
          if(this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode){
            this.sampleBatch1PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i],1,1,2));
            this.sampleBatch1PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i],1,1,2))
          }
        } else
          if (this.selectedBatch.samples[i].positionRow % 2 == 0 && this.selectedBatch.samples[i].positionCol % 2 != 0) {
            this.sampleBatch2.push(this.selectedBatch.samples[i]);
            if(this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode){
            this.sampleBatch2PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i],0,1,2));
            this.sampleBatch2PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i],0,1,2));
          }
          } else
            if (this.selectedBatch.samples[i].positionRow % 2 != 0 && this.selectedBatch.samples[i].positionCol % 2 == 0) {
              this.sampleBatch3.push(this.selectedBatch.samples[i]);
              if(this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode){
                this.sampleBatch3PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i],1,0,2));
                this.sampleBatch3PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i],1,0,2));
              }
            } else
              if (this.selectedBatch.samples[i].positionRow % 2 == 0 && this.selectedBatch.samples[i].positionCol % 2 == 0) {
                this.sampleBatch4.push(this.selectedBatch.samples[i]);
                if(this.selectedBatch.samples[i].barcode == APGCovid19Constants.positiveControlBarcode){
                 this.sampleBatch4PosControlsPositions.push(this.getPosition(this.selectedBatch.samples[i],0,0,2));
                 this.sampleBatch4PosControlsPositionsturned.push(this.getPositionturned(this.selectedBatch.samples[i],0,0,2));
                }
              }
      }
      this.getSubSendersForPlateOne();
      this.getSubSendersForPlateTwo();
      this.getSubSendersForPlateThree();
      this.getSubSendersForPlateFour();
      this.sampleBatch1Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch1, 1, 1, 2);
      this.sampleBatch2Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch2, 0, 1, 2);
      this.sampleBatch3Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch3, 1, 0, 2);
      this.sampleBatch4Map = this.createMapOutOfCovidSamplesDifferentMap(this.sampleBatch4, 0, 0, 2);
    }
  }

  getPlateNames(mergedBatches: MergedBatch[]) {
    for(let mergedBatch of mergedBatches) {
      switch(mergedBatch.quadrant.toString()) {
        case "A1":
          this.plateOne = mergedBatch.batchId;
          break;
        case "A2":
          this.plateTwo = mergedBatch.batchId;
          break;
        case "B1":
          this.plateThree = mergedBatch.batchId;
          break;
        case "B2":
          this.plateFour = mergedBatch.batchId;
          break;
        default:
          break;
      }
    }
  }

  createMapOutOfCovidSamplesDifferentMap(plateData: CovidSamples[], rowAdder: number, colAdder: number, divider: number) {
    var mapOfPlateLocVar = new Map();
    if (plateData) {
      plateData.forEach(sample => {
        if (sample) {
          let posRow = (sample.positionRow + rowAdder) / divider;
          let posCol = (sample.positionCol + colAdder) / divider;
          mapOfPlateLocVar.set(this.getRowColStringFromPos(posRow - 1, posCol - 1), sample);
        }
      });
    }
    return mapOfPlateLocVar;
  }


  /**
   * Get the positional String from row and col number.
   * Ex: (1, 1) returns 'A1'
   * @param row
   * @param col
   */
  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders384[row] + this.columnHeaders384[col];
  }

  /**
   * Get samples at given row col value for the plate view
   * @param row
   * @param col
   */
  getSampleAt(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {

    let positionString = this.getRowColStringFromPos(row, col);
    if (mapOfBatch.has(positionString)) {
      return mapOfBatch.get(positionString);
    }
    let sample = new CovidSamples();
    sample.barcode = '';
    return sample;
  }

  getColor(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
    let positionString = this.getRowColStringFromPos(row, col);

    if (this.val2 === '384') {

      if ((row + 1) % 2 != 0 && (col + 1) % 2 != 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#5858fa";
      } else if ((row + 1) % 2 == 0 && (col + 1) % 2 != 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#ff9000";
      } else if ((row + 1) % 2 != 0 && (col + 1) % 2 == 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#39ff14";
      } else if ((row + 1) % 2 == 0 && (col + 1) % 2 == 0 && mapOfBatch.has(positionString)) {
        this.backGroundColor = "#886a08";
      }

    }
    if (mapOfBatch.has(positionString)) {

      this.setColorsForSamplesAndControls(mapOfBatch.get(positionString));

    } else {
      this.color = "white";
      this.backGroundColor = "#FFFFFF";
      this.circleBorder = "black";
      this.circleStroke = "3";
      this.crossWidth = "0";
      this.crossColor = "white";
    }

  }

  isMoreKitResults(){
    return (Object.keys(this.resultGroupMap).length > 0 && this.kitResults.length > 3);
  }
  isResultLogic(){
    return (Object.keys(this.resultGroupMap).length > 0 && this.kitResults.length > 0);
  }
  getLegendColors(result){
    return this.colorCodes.get(result.toLowerCase()).color;
  }
  setColorsForSamplesAndControls(sample: CovidSamples) {
    if (!this.selectedBatch.resultUploaded) {
      if (sample.sampleType === 'POSITIVE_CONTROL') {
        this.color = "aqua";
      } else if (sample.sampleType === 'NEGATIVE_CONTROL') {
        this.color = "yellow";
      } else {
        if(sample.orderStatus && sample.orderStatus==='NEW'){
          this.color = "red"
        }else if(sample.orderStatus && sample.orderStatus==='COMPLETE'){
          this.color = "green"
        }else if(sample.orderStatus && sample.orderStatus==='PARTIAL_COMPLETE'){
          this.color = "blue"
        }else{
          this.color = "red"
        }
      }
      this.circleStroke = "3";
      this.circleBorder = "black";
      this.crossWidth = "0";
      this.crossColor = "white";
    } else {
      if (sample.sampleType === 'POSITIVE_CONTROL') {
        this.color = "aqua";
      } else if (sample.sampleType === 'NEGATIVE_CONTROL') {
        this.color = "yellow";
      } else if (Object.keys(this.resultGroupMap).length > 0) {
        this.crossWidth = "0";
        this.crossColor = "white";
      }
    }

  }

  setColorCodes(color, result) {
    this.colorCodes.set(result.toLowerCase(), { color: color, circleStroke: '5' });
  }

  getKitValueForResultsLogic() {
    this.selectedResultGroup ="";
    this.kitResults = [];
    let selectedpcrKit: any = this.getPcrKitFromMap(this.selectedBatch.rtPCRKitVendor);
    this.colorCodes = new Map();
    if (selectedpcrKit && selectedpcrKit.kitResults && selectedpcrKit.kitResults.length > 0) {
      for (let index = 0; index < selectedpcrKit.kitResults.length; index++) {
        this.kitResults.push(selectedpcrKit.kitResults[index]);
        if (index >= 4) {
          this.setColorCodes(this.colorList[4], selectedpcrKit.kitResults[index]);
        }
        else {
          this.setColorCodes(this.colorList[index], selectedpcrKit.kitResults[index]);
        }
      }
    }
    this.resultGroupsDropdown = [];
    Object.keys(this.resultGroupMap).forEach(resultGroup=>{
      if(resultGroup.toLowerCase().includes('covid')){
        this.selectedResultGroup = resultGroup;
      }
       this.resultGroupsDropdown.push({label:resultGroup , value:resultGroup});
    });
  }

  setControlOkColors() {
    this.circleBorder = "green";
    this.circleStroke = "5";
    this.crossWidth = "0";
    this.crossColor = "white";
  }

  setControlFailedColors() {
    this.circleBorder = "black";
    this.circleStroke = "3";
    this.crossWidth = "4";
    this.crossColor = "red";
  }

  searchForSample() {
    if (this.sampleSearchDisabled) {
      this.sampleSearchDisabled = false;
      return;
    }
    if (this.sampleToSearch == null || this.sampleToSearch == undefined || this.sampleToSearch == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Sample ID Empty', detail: 'Please enter Sample ID to search' });
      return;
    }

    if (this.dirty) {
      this.confirmationService.confirm({
        message: this.scanDialogMessage,
        header: 'Discard Changes?',
        accept: () => {
          this.dirty = false;
          this.searchForSampleAction(this.sampleToSearch.trim(), this.selectedLabId);
        },
        reject: () => { }
      });
    } else {
      this.searchForSampleAction(this.sampleToSearch.trim(), this.selectedLabId);
    }
  }

  searchForSampleAction(sampleID: string, labID: string) {
    this.blocked = true;
    this.apgTestingService.getBatchWithSample(sampleID, labID).subscribe(
      result => {
        if (result && result.data != null) {
          this.batches = result.data;
          this.batches.reverse();
          this.selectedBatch = this.batches[0];
          this.getResultOfSTRProfile();
          this.getResultOfParentage();
          this.getResultOfGeneTests();
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.selectedBatch.rnaPlateID = 'RNA-' + this.selectedBatch.batchID;
          this.selectedBatch.pcrPlateID = 'PCR-' + this.selectedBatch.batchID;
          this.allowCreate = false;
          this.plateViewDataFetched = false;
          this.differentUnboxedErrorDisabled = false;
          this.batchToSearch = '';
          this.sampleSearchDisabled = true;
          this.mapOfKits = new Map();
          this.extractionKitVendorList = [];
          this.rtPCRKitVendorList = [];
          this.setTemplateButtonLabel();
          this.chemicalMapWithCovidBatchValues = new Map();
          this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
          if (this.selectedSender) {
            this.getMachinesFromMDM();
            this.getKitsFromMDM();
          }
          this.fetchArchiveData();
          this.blocked = false;
          if (this.selectedBatch.chemicalInfoWithLotNos != null && this.selectedBatch.chemicalInfoWithLotNos != undefined) {
            this.chemicalMapWithCovidBatchValues = new Map(Object.entries(this.selectedBatch.chemicalInfoWithLotNos));
          }
        } else {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'No Batch Found', detail: 'No Batch found for given sample' });
        }
        this.plateViewDataFetched = false;
        this.setBatchView();
        this.sampleToSearch = "";
        this.kitConfirmed = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.plateViewDataFetched = false;
        this.setBatchView();
      }
    );
  }

  uploadDisabledStatus() {
    if (this.selectedBatch != undefined && this.selectedBatch != null && this.selectedBatch.completenessCheckDateTime != null &&
      this.selectedBatch.completenessCheckDateTime != undefined && this.selectedBatch.puidController2 != null && this.selectedBatch.puidController2 != undefined && this.selectedBatch.puidController2 != '') {
      return true;
    }
    else if (this.isUploadDisabled)
      return true;
    else
      return false;
  }

  verifyDisabledIf() {
    if (this.selectedBatch.clippingCompletionDateTime
      && this.selectedBatch.samples
      && this.selectedBatch.samples.length > 0)
      return false;

    return true;
  }

  disableTDInputsIf(state: string) {
    if (state == 'Registration' && !this.selectedBatch.statusOfTheBatch && this.batchToSearch)
      return false;
    let enabledStates: Array<string> = this.mapOfStatus.get(state);
    if (enabledStates.indexOf(this.selectedBatch.statusOfTheBatch) != -1)
      return false;
    return true;
  }
  getExcel() {
    if (this.selectedBatch != null && this.selectedBatch != undefined && this.selectedBatch.batchID != null && this.selectedBatch.batchID != '' && this.selectedBatch.batchID != undefined) {
      if (!this.showFilledTemplateLabel) {
        this.apgTestingService.excel(this.selectedBatch.batchID).subscribe(
          result => {
            var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
            console.log("File name : " + result.filename);
            this.saveFile(blob, this.selectedBatch.batchID + ".xlsm");

          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        )
      }
      else {
        if (!this.archiveBatchStatus.includes(this.selectedBatch.statusOfTheBatch)) {
          this.apgTestingService.filledExcel(this.selectedBatch.batchID, this.selectedLabId).subscribe(
            result => {
              var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
              this.saveFile(blob, this.selectedBatch.batchID + ".xlsm");

            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messagesService.addErrorMessage(message);
            }
          )
        } else {
          this.apgTestingService.archiveBatchFilledExcel(this.selectedBatch.batchID, this.selectedLabId).subscribe(
            result => {
              var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
              this.saveFile(blob, this.selectedBatch.batchID + ".xlsx");

            },
            error => {
              let message = this.errorHandler.handleError(error);
              this._messagesService.addErrorMessage(message);
            }
          )
        }
      }
    } else {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'No Batch ID Entered', detail: 'Please Batch ID before downloading excel' });
      return;
    }
  }

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }


  saveBatchStatus(status: string) {
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
      return;
    }
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: this.scanDialogMessage,
        header: 'Discard Changes?',
        accept: () => {
          this.dirty = false;
          this.saveBatchStatusAction(status);
        },
        reject: () => { }
      });
    } else {
      this.saveBatchStatusAction(status);
    }
  }

  saveBatchStatusAction(status: string) {
    let functionName = this.mapOfStatusSaves.get(status);
    console.log(functionName);
    this[functionName](status);
  }

  saveComment() {
    if (!this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to save' });
      return;
    }
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }

    this.blocked = true;
    this.newComment.commentDate = new Date();
    this.newComment.userComment = this.newComment.userComment.trim();
    this.selectedBatch.comments.push(this.newComment);
    this.apgTestingService.saveComment(this.selectedBatch.batchID, this.selectedLabId, this.selectedBatch.comments).subscribe(
      result => {
        this.selectedBatch = result.data;
        this.previewComment = this.newComment;
        let cmnt = this.getArrayOfCommentsToAnother(this.selectedBatch.batchID, this.newComment);
        this.commentsMap.set(this.selectedBatch.batchID, cmnt);
        this.batchCommentVisibility.set(this.selectedBatch.batchID, true);
        this.newComment = this.initializeNewComment();
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Comment Saved', detail: 'Comment saved successfully' });
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  showCompletedStatus() {
    return this.selectedBatch.statusOfTheBatch == 'COMPLETED' ? true : false;
  }

  getKitsFromMDM() {

    let allowedExtractionKits = this.selectedSender.allowedExtractionKits.join(",");
    let allowedPCRKits = this.selectedSender.allowedPCRKits.join(",");
    this.apgTestingService.getKitsFromMDM(this.selectedLabId, this.selectedBatch.swabType, allowedExtractionKits, allowedPCRKits).subscribe(
      result => {
        if (result.data == null || result.data == undefined || result.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Extractor Machines not found!', detail: 'Contact Administrator to resolve this issue.' });
          return;
        }
        this.mapOfKits = result.data;
        const mapKits = new Map(Object.entries(this.mapOfKits));
        this.extractionKitVendorList = this.convertArrayOfStringToObjectArray(mapKits, "extraction");
        this.rtPCRKitVendorList = this.convertArrayOfStringToObjectArray(mapKits, "pcr");
        if (this.selectedBatch.chemicalInfoWithLotNos != null && this.selectedBatch.chemicalInfoWithLotNos != undefined) {
          this.chemicalMapWithCovidBatchValues = new Map(Object.entries(this.selectedBatch.chemicalInfoWithLotNos));
        }
        if (this.chemicalMap.get(this.selectedBatch.extractionKitVendor) != null &&
          this.chemicalMap.get(this.selectedBatch.extractionKitVendor) != undefined) {
          const mapForExtractionLot = new Map(Object.entries(this.chemicalMap.get(this.selectedBatch.extractionKitVendor)));
          if (this.selectedBatch.chemicalInfoWithLotNos != null && this.selectedBatch.chemicalInfoWithLotNos != undefined) {
            this.map = new Map(Object.entries(this.selectedBatch.chemicalInfoWithLotNos));
          }
          else if (mapForExtractionLot.get("chemicalInfoWithLotNos") != null && mapForExtractionLot.get("chemicalInfoWithLotNos") != undefined
            && Object.keys(mapForExtractionLot.get("chemicalInfoWithLotNos")).length !== 0) {
            this.map = new Map(Object.entries(mapForExtractionLot.get("chemicalInfoWithLotNos")));
          }
        }
        if (this.chemicalMap.get(this.selectedBatch.rtPCRKitVendor) != null &&
          this.chemicalMap.get(this.selectedBatch.rtPCRKitVendor) != undefined) {
          const mapForCpValue = new Map(Object.entries(this.chemicalMap.get(this.selectedBatch.rtPCRKitVendor)));

          if (this.selectedBatch.chemicalInfoWithCpValues != null && this.selectedBatch.chemicalInfoWithCpValues != undefined) {
            this.mapOfCpValue = new Map(Object.entries(this.selectedBatch.chemicalInfoWithCpValues));
          }
          else if (mapForCpValue.get("chemicalInfoWithCpValues") != null && mapForCpValue.get("chemicalInfoWithCpValues") != undefined
            && Object.keys(mapForCpValue.get("chemicalInfoWithCpValues")).length !== 0) {
            this.mapOfCpValue = new Map(Object.entries(mapForCpValue.get("chemicalInfoWithCpValues")));
          }
        }
        let chemicalForExtraction = this.chemicalMap.get(this.selectedBatch.extractionKitVendor);
        let chemicalForRTPCR = this.chemicalMap.get(this.selectedBatch.rtPCRKitVendor)
        if (chemicalForExtraction) {
          this.getListOfChemicals(this.chemicalMap.get(this.selectedBatch.extractionKitVendor).requiredMaterials);
        }
        if (chemicalForRTPCR) {
          this.getListOfChemicalsForPCR(this.chemicalMap.get(this.selectedBatch.rtPCRKitVendor).requiredMaterials);
        }
        if(this.selectedBatch.rtPCRKitVendor && this.showKitCpValues()){
          this.showImage();
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  convertArrayOfStringToObjectArray(objectToArray: Map<string, Object>, kitType: string) {
    let newArray: any[] = [];
    Object.entries(objectToArray.get(kitType)).forEach(([key, value]) => {
      let obj: any = value;
      this.chemicalMap.set(key, obj);
      newArray.push({ label: key, value: key });
    });
    return newArray;
  }

  onChange(event) {
    let chemical: any = this.chemicalMap.get(event.value);
    this.map = new Map();
    this.chemicalList = [];
    if (chemical.chemicalInfoWithLotNos != undefined || chemical.chemicalInfoWithLotNos != null) {
      this.map = new Map(Object.entries(chemical.chemicalInfoWithLotNos));
    }
    this.getListOfChemicals(chemical.requiredMaterials);
  }

  onChangeRtPCR(event) {
    let chemical: any = this.chemicalMap.get(event.value);
    this.mapOfCpValue = new Map();
    this.chemicalListPCR = [];
    if (chemical.chemicalInfoWithCpValues != undefined || chemical.chemicalInfoWithCpValues != null) {
      this.mapOfCpValue = new Map(Object.entries(chemical.chemicalInfoWithCpValues));
    }
    this.kitConfirmed = false;
    this.showImage();
    this.getListOfChemicalsForPCR(chemical.requiredMaterials);
  }


  onChangeCreateMap(item, event) {
    this.map.set(item, event);
  }

  onChangeCreateMapCpValue(item, event) {
    this.mapOfCpValue.set(item, event);
  }
  getListOfChemicals(chemicals: string) {
    if (chemicals != undefined && chemicals != null) {
      this.chemicalList = chemicals.trim().split(/\s*,\s*/);
      if (this.map == undefined || this.map == null) {
        for (let i = 0; i < this.chemicalList.length; i++) {
          this.map.set(this.chemicalList[i], "");
        }
      } else {
        for (let i = 0; i < this.chemicalList.length; i++) {
          if (this.chemicalMapWithCovidBatchValues.get(this.chemicalList[i]) != undefined && this.chemicalMapWithCovidBatchValues.get(this.chemicalList[i]) != null) {
            this.map.set(this.chemicalList[i], this.chemicalMapWithCovidBatchValues.get(this.chemicalList[i]));
          }
        }
      }

    }
  }
  getListOfChemicalsForPCR(chemicals: string) {
    if (chemicals != undefined && chemicals != null) {
      this.chemicalListPCR = ["PCR-kit Lot", "PCR-kit Value", "PCR-kit Range"];
      this.chemicalListPCR = this.chemicalListPCR.concat(chemicals.trim().split(/\s*,\s*/));
      if (this.mapOfCpValue == undefined || this.mapOfCpValue == null ||
        this.mapOfCpValue.size === 0) {
        this.mapOfCpValue.set("PCR-kit Lot", "");
        this.mapOfCpValue.set("PCR-kit Value", "");
        this.mapOfCpValue.set("PCR-kit Range", "");
        for (let i = 0; i < this.chemicalListPCR.length; i++) {
          this.mapOfCpValue.set(this.chemicalListPCR[i], "");
        }
      } else {
        for (let i = 0; i < this.chemicalListPCR.length; i++) {
          if (this.chemicalMapWithCovidBatchValues.get(this.chemicalListPCR[i]) != undefined && this.chemicalMapWithCovidBatchValues.get(this.chemicalList[i]) != null) {
            this.mapOfCpValue.set(this.chemicalListPCR[i], this.chemicalMapWithCovidBatchValues.get(this.chemicalListPCR[i]));
          }
        }
      }
    }
  }



  showKitLotNumber() {
    return this.selectedBatch.statusOfTheBatch == "START_EXTRACTION" || this.selectedBatch.statusOfTheBatch == "COMPLETE_LYSIS";
  }
  showDialog(statusOfTheBatch: boolean) {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.display) {

      this.kitsDTO = new KitsDTO;
      this.kitsDTO.chemicalInfoWithLotNos = new Map();
      if (this.map != null && this.map != undefined) {
        this.map.forEach((v: string, k: string) => {
          if (v) {
            this.kitsDTO.chemicalInfoWithLotNos[k] = v;
          }
        });

      } else {
        this.kitsDTO.chemicalInfoWithLotNos = null;
      }

      this.kitsDTO.labId = this.selectedLabId;
      this.kitsDTO.kitName = this.selectedBatch.extractionKitVendor;
      this.apgTestingService.updateKitInMDM(this.kitsDTO).subscribe(
        _result => {
          let obj: any = this.chemicalMap.get(this.selectedBatch.extractionKitVendor);
          obj.chemicalInfoWithLotNos = this.kitsDTO.chemicalInfoWithLotNos;
          this.chemicalMap.set(this.selectedBatch.extractionKitVendor, obj);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Chemical lot Updated for the kit', detail: 'Chemical lot Updated for the kit' });
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
      this.selectedBatch.chemicalInfoWithLotNos = this.kitsDTO.chemicalInfoWithLotNos;
      if (this.statusAtKitLot) {
        this.saveBatchStatus('START_EXTRACTOR');
        this.statusAtKitLot = false;
      } else {
        this.saveBatchData();
      }
      this.display = false;
    } else {
      if (statusOfTheBatch) {
        this.statusAtKitLot = true;
      }
      this.display = true;
    }
  }

  showKitCpValues() {
    return this.selectedBatch.statusOfTheBatch == "START_PRECYCLING";
  }

  showDialogForCpValues(statusOfTheBatch: boolean) {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.displayPCR) {
      this.kitsDTO = new KitsDTO;
      this.kitsDTO.chemicalInfoWithCpValues = new Map();
      if (this.mapOfCpValue != null && this.mapOfCpValue != undefined) {
        this.mapOfCpValue.forEach((v: string, k: string) => {
          if (v) {
            this.kitsDTO.chemicalInfoWithCpValues[k] = v;
          }
        });
      } else {
        this.kitsDTO.chemicalInfoWithCpValues = null;
      }

      this.kitsDTO.labId = this.selectedLabId;
      this.kitsDTO.kitName = this.selectedBatch.rtPCRKitVendor;
      this.apgTestingService.updateKitInMDM(this.kitsDTO).subscribe(
        _result => {
          let obj: any = this.chemicalMap.get(this.selectedBatch.rtPCRKitVendor);
          obj.chemicalInfoWithCpValues = this.kitsDTO.chemicalInfoWithCpValues;
          this.chemicalMap.set(this.selectedBatch.rtPCRKitVendor, obj);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Chemical lot Updated for the kit', detail: 'Chemical lot Updated for the kit' });
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
      this.selectedBatch.chemicalInfoWithCpValues = this.kitsDTO.chemicalInfoWithCpValues;

      if (this.statusAtCpValue) {
        this.saveBatchStatus('COMPLETE_PRECYCLING');
        this.statusAtCpValue = false;
      } else {
        this.saveBatchData();
      }

      this.displayPCR = false;
    } else {
      if (statusOfTheBatch)
        this.statusAtCpValue = true;
      this.displayPCR = true;
    }
  }

  getMachinesFromMDM() {

    this.apgTestingService.getMachinesFromMDM(this.selectedLabId).subscribe(
      result => {
        if (result.data == null || result.data == undefined || result.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Extractor Machines not found!', detail: 'Contact Administrator to resolve this issue.' });
          return;
        }
        this.exctractionMachines = [];
        result.data['extractors'].forEach(machine => {
          this.exctractionMachines.push({ value: machine.name, label: machine.name });
        });

        this.lightCyclers = [];
        result.data['cyclers'].forEach(machine => {
          if(this.selectedBatch.wellType == WellType.WELL384){
            if(machine.ioCapacity  == '1*384 to 4*96' || machine.ioCapacity  == '1*384 to 1*384'){
              this.lightCyclers.push({ value: machine.name, label: machine.name });
            }
          }else{
            this.lightCyclers.push({ value: machine.name, label: machine.name });
          }
          this.machineShortInfos.set(machine.name, machine.subType);
          this.mapOfMachineInfo.set(machine.name, machine);
          this.machineIOCapcity.set(machine.name, machine.ioCapacity)
        })
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  showConfirmDialogForExcelUpload(uploadError: any, formData: FormData) {

    this.confirmationService.confirm({
      message: uploadError.error.bbApiError.message,
      header: 'Confirmation',
      icon: 'fa fa-question-circle',
      accept: () => {
        formData.set('initialValidationCall', 'false');
        this.apgTestingService.uploadExcelSheet(formData, this.selectableLab.lab.clippingMachine).subscribe(
          result => {
            if (!result) {
              return;
            }
            this.plateViewDataFetched = false;
            this.selectedBatch = result.data;
            this.previewComment = this.getPreviewComment(this.selectedBatch);
            this.commentsMap = new Map<string, Comment[]>();
            this.differentUnboxedErrorDisabled = false;
            this.selectedBatch.excelUploadCreatedAt = new Date();
            this.selectedBatch.excelUploadCreatedBy = this.puid;
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Sample Uploaded', detail: 'Upload Successful' });

          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        )
      },
      reject: () => {
      }
    });
    this.isUploadDisabled = true;
  }

  disableStartExtraction() {
    return !(this.selectedBatch.batchID && this.selectedBatch.machineName && this.selectedBatch.extractionKitVendor);
  }
  disableStartExtractor() {
    return !(this.selectedBatch.startExtraction && this.selectedBatch.puidStartExtraction);
  }
  disableCompleteExtraction() {
    return !(this.selectedBatch.puidStartExtractor && this.selectedBatch.startExtractorDateTime && (this.selectedBatch.startExtractorDateTime > this.selectedBatch.startExtraction));
  }
  disableSplitBatch() {
    let machineIOCapcity = this.machineIOCapcity.get(this.selectedBatch.machineName1);
    return !(this.selectedBatch.puidPCR2 && this.selectedBatch.wellType == WellType.WELL384 && machineIOCapcity && machineIOCapcity == '1*384 to 4*96')
      || this.selectedBatch.statusOfTheBatch === 'SPLIT';
  }
  disableStartPCR() {
    return !(this.selectedBatch.pcrPlateID && this.selectedBatch.machineName1 && this.selectedBatch.rtPCRKitVendor);
  }

  disableCompletePCR() {
    return !(this.selectedBatch.startDatePCR && this.selectedBatch.puidPCR2 && this.disableSplitBatch());
  }

  disableCompleteAnalysis() {
    return !(this.selectedBatch.analysisStartedDateTime && this.selectedBatch.analysisStartedPUID);
  }
  disableExternalFileTransfer(){
    return (!(this.selectedBatch.completionDateTimeEvaluation && this.selectedBatch.puidEvaluation && this.externalFileTransferEnabled && !['REDO','REMOVED'].includes(this.selectedBatch.statusOfTheBatch))) || this.selectedBatch.locked;
  }
  disableResultSent() {
    if(this.externalFileTransferEnabled) {
      return (!(this.selectedBatch.externalUploadDateTime && this.selectedBatch.externalUploadPUID)) || this.selectedBatch.locked;
    } else {
      return (!(this.selectedBatch.completionDateTimeEvaluation && this.selectedBatch.puidEvaluation)) || this.selectedBatch.locked;
    }
  }

  disableCompleteClipping() {
    return !(this.selectedBatch.clippingStartDateTime && this.selectedBatch.puidClipping)
  }

  disableStartLysis() {
    return !(this.selectedBatch.completenessCheckDateTime && this.selectedBatch.puidController2)
  }

  disableCompleteLysis() {
    return !(this.selectedBatch.lysisStartDateTime && this.selectedBatch.puidstartLysis)
  }

  disableReceivedDNa() {
    return !(this.selectedBatch.lysisCompletionDateTime && this.selectedBatch.puidCompleteLysis)
  }

  disablecompleteBatch() {
    return this.selectedBatch.statusOfTheBatch=="CREATE_BATCH";
  }

  workflowContainsSNP(){
    if(!this.selectedBatch || this.selectedBatch==null || !this.selectedBatch.batchID || this.selectedBatch.batchID===""){
      return false;
    }
    if(this.selectedBatch.workFlow && this.selectedBatch.workFlow.product && 
        this.selectedBatch.workFlow.product.includes('SNP') ){
      return true;
    }
    else
      return false;
  }

  workflowContainsSTR(){
    if(!this.selectedBatch || this.selectedBatch==null || !this.selectedBatch.batchID || this.selectedBatch.batchID===""){
      return false;
    }
    if(this.selectedBatch && this.selectedBatch.workFlow && this.selectedBatch.workFlow.product && 
        (this.selectedBatch.workFlow.product.includes('STR') || this.selectedBatch.workFlow.product.includes('TEST')) || this.selectedBatch.workFlow.product.includes('STR-P')){
      return true;
    }
    else 
      return false;
  }
   
  disableStartPreCycling() {
    if (this.selectedBatch.wellType == WellType.WELL96) {
      return !(this.selectedBatch.completionDateTimeExtraction && this.selectedBatch.puidExtraction && !this.selectableLab.lab.flaTestProcess);
    } else if (this.selectedBatch.wellType == WellType.WELL384) {
      if (!(this.selectedBatch.completionDateTimeExtraction && this.selectedBatch.puidExtraction)
        && !(this.selectedBatch.precyclingStartDateTime && this.selectedBatch.puidstartPrecycling))
        return false;
      return !(this.selectedBatch.precyclingStartDateTime && this.selectedBatch.puidstartPrecycling);
    }
  }

  disableCompletePreCycling() {
    return !(this.selectedBatch.precyclingStartDateTime && this.selectedBatch.puidstartPrecycling && this.selectedBatch.rtPCRKitVendor && this.kitConfirmed)
  }

  disableUndoMerge() {
    return !((this.selectedBatch.statusOfTheBatch == "START_PRECYCLING" ||
      this.selectedBatch.statusOfTheBatch == "COMPLETE_PRECYCLING") &&
      this.selectedBatch.wellType == WellType.WELL384)
  }
  disableWorkfileDownload() {
    if (!(this.selectedBatch.startDatePCR && this.selectedBatch.puidPCR2))
      return true;
    else if (['ANALYSIS_DONE', 'COMPLETED'].includes(this.selectedBatch.statusOfTheBatch)) {
      if (this.selectedBatch.wellType == 'WELL384') {
        for (let mergedBatch of this.selectedBatch.mergedBatches) {
          if (mergedBatch.finalResult == 'Report')
            return false;
        }
        return true;
      }
    } else {
      return (this.selectedBatch.statusOfTheBatch === 'REDO' ? this.selectedBatch.wellType === WellType.WELL384 ? false : true : false);
    }
  }

  getWorkfileForCurrentBatch() {
    if (!this.selectedBatch || !this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Cannot generate workfile without Batch ID' });
      return;
    }
    let pcrKit: any = this.getPcrKitFromMap(this.selectedBatch.rtPCRKitVendor);

    if (!pcrKit) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'PCR Kit Not Found', detail: 'Cannot find PCR kit associated with batch' });
      return;
    }

    if (this.noChannelsFound(pcrKit)) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'No Channels Found!', detail: 'Please configure channels for ' + pcrKit.kitName + ' in MDM' });
      return;
    }
    let redoBatches = [];
    if (['ANALYSIS_DONE', 'COMPLETED'].includes(this.selectedBatch.statusOfTheBatch) && this.selectedBatch.wellType == 'WELL384') {

      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.finalResult != 'Report')
          redoBatches.push(mergedBatch.quadrant);
      });
    }
    let machineSubtype = this.machineShortInfos.get(this.selectedBatch.machineName1);

    if (this.mapOfMachineInfo.get(this.selectedBatch.machineName1) && 
        (this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType == "QuantStudio5" || this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType == "ABI7500") )  {
      this.apgTestingService.getPCRWorkfileForQuantStudio5(this.selectedBatch.batchID, this.selectedLabId, redoBatches, pcrKit).subscribe(
        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Intiating QuantStudio5/ABI7500 workfile download',
            detail: '',
          });
          let txtData = result.data;
          let blobTxt: Blob = new Blob([txtData], { type: 'text/plain' });
          let fileTxt: string = this.selectedBatch.batchID + '.txt';
          saveByFileSaver(blobTxt, fileTxt);
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    } else if (this.selectedBatch.wellType != WellType.WELL384 && this.mapOfMachineInfo.get(this.selectedBatch.machineName1) && this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType == "AriaDX-txt") {
      this.apgTestingService.getPCRWorkfileForAriaDx(this.selectedBatch.batchID, this.selectedLabId, redoBatches, pcrKit).subscribe(
        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Intiating AriaDX workfile download',
            detail: '',
          });
          let txtData = result.data;
          let blobTxt: Blob = new Blob([txtData], { type: 'text/plain' });
          let fileTxt: string = this.selectedBatch.batchID + '-AriaDX.txt';
          saveByFileSaver(blobTxt, fileTxt);
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
    } else if (this.selectedBatch.machineName1 && machineSubtype && this.bioRadMachineTypes.includes(machineSubtype.toLowerCase())) {
      let boxIdRequired: boolean = (machineSubtype.toLowerCase() == "biorad_dk");
      this.apgTestingService.getPCRWorkfileForBiorad(this.selectedBatch.batchID, this.selectedLabId, redoBatches, boxIdRequired).subscribe(
        results => {
          var blob = new Blob([results.fileContent], { type: 'text/plain' });
          this.saveFile(blob, this.selectedBatch.batchID + "-workfile.csv");
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Intiating workfile download',
            detail: '',
          });

        },
        error => {
          let errorHandler = new ErrorHandler();
          console.log("workfile generation error::" + error);
          let message = errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        });
    } else if (this.mapOfMachineInfo.get(this.selectedBatch.machineName1) && this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType == APGCovid19Constants.ariaUKFileType) {
     if(this.selectedBatch.wellType != WellType.WELL96){
      this._messagesService.addErrorMessage({
        severity: "error",
        summary: "File type not supported!!",
        detail: "ariadx file type only supports 96 WELL batches",
      });
      return ;
     }
      this.downloadAriaDXXlsWorkFile(this.selectedBatch.batchID,this.selectedLabId);
    }else if (
      this.selectedBatch.machineName1 &&
      machineSubtype &&
      machineSubtype.toLowerCase() == "bioradlims"
    ) {
      this.apgTestingService
        .getWorkfileForBioRadLims(
          this.selectedBatch.batchID,
          this.selectedLabId,
          redoBatches,
          pcrKit
        )
        .subscribe(
          (results) => {
            var blob = new Blob([results.fileContent], { type: "text/plain" });
            this.saveFile(blob, this.selectedBatch.batchID + "-workfile.csv");
            this._messagesService.addSuccessMessage({
              severity: "success",
              summary: "Intiating workfile download",
              detail: "",
            });
          },
          (error) => {
            let errorHandler = new ErrorHandler();
            console.log("workfile generation error:" + error);
            let message = errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        );
    } else if (
      this.selectedBatch.machineName1 &&
      machineSubtype &&
      machineSubtype == APGCovid19Constants.flaABIMechine
    ) {
      let quadList: string[] = [];
      if (
        this.selectedBatch.wellType == WellType.WELL384 &&
        this.selectedBatch.mergedBatches
      ) {
        this.selectedBatch.mergedBatches.forEach((batch) => {
          if (batch.quadrant) {
            quadList.push(batch.quadrant);
          }
        });
      }
      this.apgTestingService
        .getWorkfileForFLA_ABI(
          this.selectedBatch.batchID,
          this.selectedLabId,
          redoBatches,
          quadList
        )
        .subscribe(
          (result) => {
            let txtData = result.data;
            let batchSize = 384;
            let blobTxt: Blob = new Blob([txtData], { type: "text/plain" });
            if (this.selectedBatch.wellType == WellType.WELL96) {
              batchSize = 96;
            }
            let fileTxt: string =
              "FLA_" + this.selectedBatch.batchID + "_" + batchSize + ".txt";
            saveByFileSaver(blobTxt, fileTxt);
          },
          (error) => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        );
    } else {
      this.apgTestingService
        .getPCRWorkfile(
          this.selectedBatch.batchID,
          this.selectedLabId,
          redoBatches
        )
        .subscribe(
          (result) => {
            let txtData = result.data;
            let blobTxt: Blob = new Blob([txtData], { type: "text/plain" });
            let fileTxt: string = this.selectedBatch.batchID + ".txt";
            saveByFileSaver(blobTxt, fileTxt);
          },
          (error) => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        );
    }

  }
  
  downloadAriaDXXlsWorkFile(batchID, labID) {
    this.loading = true;
    this.apgTestingService.getAriaDxXlsWorkfile(batchID, labID).subscribe(
      result => {  
        this.loading = false;
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, "AriaDX_" + batchID + ".xlsx");
      },
      error => {
        this.loading = false;
        let message = { severity: 'error', summary: "Conflict", detail: error.bbApiError.message };
        this._messagesService.addErrorMessage(message);
      });
  }

  noChannelsFound(pcrKit: any) {
    return ( (!pcrKit.channel1Gene || pcrKit.channel1Gene.trim() == '') && (!pcrKit.channel2Gene || pcrKit.channel2Gene.trim() == '') &&
        (!pcrKit.channel3Gene || pcrKit.channel3Gene.trim() == '') && (!pcrKit.channel4Gene || pcrKit.channel4Gene.trim() == '') && (!pcrKit.channel5Gene || pcrKit.channel5Gene.trim() == '') );
  }
  channelsCount(pcrKit: any) {
    let count =0;
    if(pcrKit) {
    if(pcrKit.channel1Gene && pcrKit.channel1Gene.trim() != '') {
      count++;
    }
    if(pcrKit.channel2Gene && pcrKit.channel2Gene.trim() != '') {
      count++;
    }
    if(pcrKit.channel3Gene && pcrKit.channel3Gene.trim() != '') {
      count++;
    }
    if(pcrKit.channel4Gene && pcrKit.channel4Gene.trim() != '') {
      count++;
    }
    if(pcrKit.channel5Gene && pcrKit.channel5Gene.trim() != '') {
      count++;
    }
  }
  return count;
  }

  onResultFileChange(event) {
    if (event.target.files.length > 1) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Uploaded more than 1 file!',
        detail: 'Maximum of 1 file can be uploaded!',
      });
      this.removeSelection();
      return;
    }
    var file = event.target.files[0];
    var fileName: string = file.name;
    if(!fileName.endsWith('.csv')){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Unsupported file format',
        detail: 'Only csv files are currently supported'
      })
      this.removeSelection();
      return;
    }
    this.fileTypeCountMap.clear();
    this.myFiles.push(file);
    this.disableResultUpload();
  }

  uploadStrResultFile(){
    const formData = new FormData();
    formData.append("file", this.myFiles[0]);
    if(this.isPUIDPresnt()){
      this.removeSelection();
      this.blocked = true;
      this.apgTestingService.uploadStrResultFile(formData, this.selectedBatch.batchID, this.selectedBatch.lab).subscribe(
        _response => {
          this.blocked = false;
          this.plateViewDataFetched = false;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Uploaded successfully',
            detail: 'Result has been uploaded and processed successfully'
          })
        }, err =>{
          this.blocked = false;
          if(err && err.error && err.error.bbApiError){
            this._messagesService.addErrorMessage({
              severity: 'error', summary: err.error.bbApiError.status,
              detail: err.error.bbApiError.message
            })
          }else{
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Failed to process uploaded file',
              detail: 'Some unknown exception occurred while processing the uploaded result file, please try again'
            })
          }
        }
      )
    }else{
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before uploading',
      });
    }
  }


  validateQuantStudio5ResultFileUpload(fileName: string){
    if(this.quantStudio5FileTypes.indexOf(fileName.split('.').pop()) == -1){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid file type',
        detail: 'Upload a file with extension .xlsx',
      });
      this.removeSelection();
    }
  }
  validateFastFinderFileUpload(fileName: string) {
    let batchId = this.selectedBatch.batchID.split('_');
    if (!fileName.includes(batchId[batchId.length - 1]) || this.fastFinderFiletypes.indexOf(fileName.split('.').pop()) == -1) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'File Mismatch',
        detail: 'Upload valid  File with BatchId & extension .xlsx,.ixo,.csv or .pcrd',
      });
      this.removeSelection();
      return
    }
  }
  validateBioradLimsFileUpload(file) {
    if (this.bioradLimsFiletypes.indexOf(file.name.split('.').pop()) == -1) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Please upload a file with valid extension',
        detail: 'allowed file extensions are  .xlsx,.ixo,.csv and .pcrd',
      });
      this.removeSelection();
      return;
    } else if (file.name.endsWith('.xlsx')) {
      if (this.uploadedxlsxFiles.length < 1) {
        this.uploadedxlsxFiles.push(file);
      } else {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 excel file!',
          detail: 'Maximum of 1 excel file can be uploaded!',
        });
        this.removeSelection();
      }
    } else if (file.name.endsWith('.pcrd')) {
      if (this.uploadedPCRDFiles.length < 1) {
        this.uploadedPCRDFiles.push(file);
      } else {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 pcrd  file!',
          detail: 'Maximum of 1 pcrd file can be uploaded!',
        });
        this.removeSelection();
      }
    } else if (file.name.endsWith('.csv')) {
      if (this.uploadedCSVFiles.length < 1) {
        this.uploadedCSVFiles.push(file);
      } else {
        this._messagesService.addWarningMessage({
          severity: 'error', summary: 'Uploaded more than 1 CSV files!',
          detail: 'Maximum of 1 CSV file can be uploaded!',
        });
        this.removeSelection();
      }
    }
  }
  disableResultUpload() {
    if (this.myFiles.length > 0) {
      this.isResultUploadDisabled = false;
    } else {
      this.isResultUploadDisabled = true;
    }
  }

  removeSelection() {
    (<HTMLInputElement>document.getElementById("resultFileChooser")).value = null;
    this.myFiles = [];
    this.uploadedTxtFiles = [];
    this.ixoFiles = [];
    this.uploadedxlsxFiles = [];
    this.uploadedPCRDFiles = [];
    this.uploadedXMLFiles = [];
    this.uploadedCSVFiles = [];
    this.fileTypeCountMap = new Map();
    this.disableResultUpload();
  }

  resultUploadsubmit() {
    const formData = new FormData();
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file", this.myFiles[i]);
    }
    if (this.isPUIDPresnt()) {
      this.removeSelection();
      if (this.gene == 'ICR' && !this.allNonICRChannelsUploaded() && this.machineShortInfos.get(this.selectedBatch.machineName1) != APGCovid19Constants.bioradLimsMechine) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'ICR Channel Upload Error', detail: 'Please upload all non-ICR channel result files before uploading ICR channel' });
        return;
      }
      formData.append("resultConfigMap", JSON.stringify(this.resultGroupMap));
      let dominantChannel = this.getDominantChannelFromKit(this.selectedBatch.rtPCRKitVendor);
      let filesPerManufacturer = (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) ? true : false;
      formData.append("filesPerManufacturer", filesPerManufacturer.toString());
      this.blocked = true;
      if(this.mapOfMachineInfo.get(this.selectedBatch.machineName1)){
        this.apgTestingService.uploadResultFile(formData, this.selectedBatch.batchID, this.gene, dominantChannel, this.selectedLabId, this.selectedBatch.rtPCRKitVendor, this.machineIOCapcity.get(this.selectedBatch.machineName1), this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType).subscribe(
          result => {
            if (!result.data) {
              this.blocked = false;
              this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Result Uploaded', detail: 'Upload Successful' });
              return;
            }
            this.selectedBatch = result.data;
            this.previewComment = this.getPreviewComment(this.selectedBatch);
            this.commentsMap = new Map<string, Comment[]>();
            this.updatePlateMaps();
            if (this.allChannelsUpdatedForBatch() && !(this.selectedBatch.completionDateTimeEvaluation && this.selectedBatch.puidEvaluation)) {
              if (this.selectedBatch.wellType == WellType.WELL96) {
                if (this.selectedBatch.systemResult) {
                  this.selectedBatch.finalResult = "Report";
                }
                else {
                  this.selectedBatch.finalResult = "Check";
                }
              }
              else {
                this.userWarningsForAdjacentPositiveSamples();
                this.selectedBatch.mergedBatches.forEach(meregedBatch => {
                  if (meregedBatch.systemResult) {
                    meregedBatch.finalResult = "Report";
                  }
                  else {
                    meregedBatch.finalResult = "Check";
                  }
                })
              }
            }
            if (this.missingBarcodesList && this.missingBarcodesList.length > 0) {
              let message = 'Theese barcodes are missing from file ' + this.missingBarcodesList.join(',  ') + " . Please Reupload file with missing barcodes to Proceed";
              this._messagesService.addErrorMessage({
                severity: 'error', summary: 'Barcodes Missing in Upload File',
                detail: message,
              })
              this.blocked = false;
              return;
            }
            this.filesPerManufacturerMap.clear();
            if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0 && this.selectedBatch.filesPerManufacturer && this.selectedBatch.filesPerManufacturer.length > 0) {
              this.selectedBatch.filesPerManufacturer.forEach(file => {
                let newFile: FilesPerManufacturer[] = [];
                if (this.filesPerManufacturerMap.has(file.fileType)) {
                  let uploadedFilesForFileType = this.filesPerManufacturerMap.get(file.fileType);
                  uploadedFilesForFileType.push(file);
                  this.filesPerManufacturerMap.set(file.fileType, uploadedFilesForFileType);
                } else {
                  newFile.push(file);
                  this.filesPerManufacturerMap.set(file.fileType, newFile);
                }
              });
            }

            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Result Uploaded', detail: 'Upload Successful' });
            this.blocked = false;
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
            this.blocked = false;
          }
        )
      }else{
        this.blocked = false;
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'RT PCR Cyler machine not found',
          detail: 'No RT PCR Cycler machine found with name: '+this.selectedBatch.machineName1
        });
      }
    } else {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before uploading',
      });
    }
  }
  userWarningsForAdjacentPositiveSamples() {
    if (this.sampleBatch1PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch1PosControlsPositions,this.sampleBatch1Map, this.plateOne, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch1PosControlsPositionsturned,this.sampleBatch1Map, this.plateOne, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, true);
    }
    if (this.sampleBatch2PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch2PosControlsPositions, this.sampleBatch2Map, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch2PosControlsPositionsturned,this.sampleBatch2Map, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch3Map, this.plateThree, this.sampleBatch4Map, this.plateFour, true);
    }
    if (this.sampleBatch3PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch3PosControlsPositions, this.sampleBatch3Map, this.plateThree, this.sampleBatch2Map, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch4Map, this.plateFour, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch3PosControlsPositionsturned, this.sampleBatch3Map, this.plateThree, this.sampleBatch2Map, this.plateTwo, this.sampleBatch1Map, this.plateOne, this.sampleBatch4Map, this.plateFour, true);
    }
    if (this.sampleBatch4PosControlsPositions.length > 0) {
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch4PosControlsPositions,this.sampleBatch4Map, this.plateFour, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch1Map, this.plateOne, false);
      this.warnUsersAboutAdjacentPositiveSamples(this.sampleBatch4PosControlsPositionsturned,this.sampleBatch4Map, this.plateFour, this.sampleBatch2Map, this.plateTwo, this.sampleBatch3Map, this.plateThree, this.sampleBatch1Map, this.plateOne, true);
    }
  }

  warnUsersAboutAdjacentPositiveSamples(posExPositions, selfMap, batchId, verifyMap1, verifyBatchId1, verifyMap2, verifyBatchId2, verifyMap3, verifyBatchId3, turned) {
    let firstBatch: boolean = true;
    let secondBatch: boolean = true;
    let thirdBatch: boolean = true;
    let selfBatch: boolean = true;
    let message: string = "";
      posExPositions.forEach(element => {
        if(turned){
          let selfSample: CovidSamples = selfMap.get(element);
          if(selfSample == undefined || this.controlArray.includes(selfSample.barcode))
            selfBatch = false;
        }
        let firstsample: CovidSamples = verifyMap1.get(element);
        if (firstsample == undefined || this.controlArray.includes(firstsample.barcode))
          firstBatch = false;
        let secondsample: CovidSamples = verifyMap2.get(element);
        if (secondsample == undefined || this.controlArray.includes(secondsample.barcode))
          secondBatch = false;
        let thirdSample: CovidSamples = verifyMap3.get(element);
        if (thirdSample == undefined || this.controlArray.includes(thirdSample.barcode))
          thirdBatch = false;
      });
      if(turned && selfBatch){
        message = message.concat(batchId + " POS-EX positive on " + batchId +  "(turned)");
      }
      if (firstBatch) {
        message = message != "" ? message.concat("<br/>") : "";
        message = message.concat(batchId + " POS-EX positive on " + verifyBatchId1 + (turned ? "(turned)" : ""));
      }
      if (secondBatch) {
        message = message != "" ? message.concat("<br/>") : "";
        message = message.concat(batchId + " POS-EX positive on " + verifyBatchId2 + (turned ? "(turned)" : ""));
      }
      if (thirdBatch) {
        message = message != "" ? message.concat("<br/>") : "";
        message = message.concat(batchId + " POS-EX positive on " + verifyBatchId3 + (turned ? "(turned)" : ""));
      }
      if (message != "") {
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Adjacent Positive samples',
          detail: message,
        });
      }
  }

  showSamplePopUp(row: number, col: number, mapOfBatch: Map<string, CovidSamples>) {
    let positionString = this.getRowColStringFromPos(row, col);
    this.dominantChannelName = this.getDominantChannelFromKit(this.selectedBatch.rtPCRKitVendor);
    if (mapOfBatch.has(positionString)) {
      this.samplePosition = positionString;
      this.selectedSample = Object.assign({}, mapOfBatch.get(positionString));
      if (this.selectedSample.channels) {
        this.selectedSample.channels.sort((channel1: Channel, channel2: Channel) => {
          return channel1.gene.localeCompare(channel2.gene);
        });
      }
      this.tempSampleComment = this.selectedSample.comments;
      this.tempSampleInvalid = this.selectedSample.inValidResult;
      this.isResultGroup = false;
      if (Object.keys(this.resultGroupMap).length > 0 && this.selectedSample.results.length > 0 && this.controlArray.indexOf(this.selectedSample.barcode) == -1) {
        this.isResultGroup = true;
       	this.setSampleResultDropdownValues();
      }
      this.sampleType = (this.controlArray.includes(this.selectedSample.barcode)) ? this.selectedSample.barcode : 'Sample';
      this.batchHeaders = [];
      this.batchHeaders.push("Current");
      this.selectedSampleHistoryMap = this.getSelectedSampleHistoryMap(this.selectedSample.barcode);
      this.headerIndex = 0;
      this.reset[0] = {};
      this.parentalResult=this.getParentageResult(mapOfBatch.get(positionString))
      this.delivery= this.getDeliveryId(mapOfBatch.get(positionString));
      this.genevalue=this.getGeneTestsValue(mapOfBatch.get(positionString));
      this.strMarker=this.getSTRMarkerValue(mapOfBatch.get(positionString));
      this.samplePopVisible = true;
    }
  }
  setSampleResultDropdownValues(){
      let selectedpcrKit: any = this.getPcrKitFromMap(this.selectedBatch.rtPCRKitVendor);
      this.resultGroupControlResultOptions = [];
      if(selectedpcrKit && selectedpcrKit.kitResults && selectedpcrKit.kitResults.length >0){
        selectedpcrKit.kitResults.forEach((element: string) => {
          if(element.toLowerCase().trim() == APGCovid19Constants.samplePositiveResult || element.toLowerCase().trim() =="negative" )
          {
          this.resultGroupControlResultOptions.push({label: element, value: element.toLowerCase()});
          }else{
            this.resultGroupControlResultOptions.push({label: element, value: element});
          }
        });
      }else{
      this.resultGroupControlResultOptions.push({label: 'Positive', value: 'positive'});
      this.resultGroupControlResultOptions.push({label: 'Negative', value: 'negative'});
      }
      this.addDefaultResultValues(this.resultGroupControlResultOptions);
  }

  addDefaultResultValues(resultOptions){
    resultOptions.push({ value: 'retest', label: 'Retest' });
    resultOptions.push({ value: 'check', label: 'Check' });
    resultOptions.push( { value: 'ambiguous', label: 'Ambiguous' });
    resultOptions.push({ value: 'invalid', label: 'Invalid' });
  }
  getChannelsdata(resultName: string) {
    let channels: any[] = [];
    if (Object.keys(this.resultGroupMap).length > 0) {
      let data = this.resultGroupMap[resultName];
      if (data != undefined) {
        data['channelThreshold'].forEach(channel => {
          channels.push(channel['channelName']);
        });
      }
    }
    return channels;
  }
  updateOverviewPlate(sample: CovidSamples) {
    switch (sample.quadrant) {
      case 'A1': this.sampleBatch1Map.set(this.getPosition(sample, 1, 1, 2), sample);
        break;
      case 'A2': this.sampleBatch2Map.set(this.getPosition(sample, 0, 1, 2), sample);
        break;
      case 'B1': this.sampleBatch3Map.set(this.getPosition(sample, 1, 0, 2), sample);
        break;
      case 'B2': this.sampleBatch4Map.set(this.getPosition(sample, 0, 0, 2), sample);
        break;
    }
  }
  getPosition(sample: CovidSamples, rowAdder: number, colAdder: number, divider: number) {
    let posRow = (sample.positionRow + rowAdder) / divider;
    let posCol = (sample.positionCol + colAdder) / divider;
    return this.getRowColStringFromPos(posRow - 1, posCol - 1);
  }
  getPositionturned(sample: CovidSamples, rowAdder: number, colAdder: number, divider: number) {
    let posRow = 9 - ((sample.positionRow + rowAdder) / divider);
    let posCol = 13 - ((sample.positionCol + colAdder) / divider);
    return this.getRowColStringFromPos(posRow - 1, posCol - 1);
  }

  compareCovidSamplesRedoProperties(sample1: CovidSamples, sample2: CovidSamples): boolean {
    if(sample1.result === sample2.result
      && ( (sample1.comments === sample2.comments) || (sample1.comments === undefined && sample2.comments === "") || (sample1.comments === "" && sample2.comments === undefined) ) &&
      sample1.singleSampleRedo === sample2.singleSampleRedo && sample1.singleSampleInconclussiveRedo === sample2.singleSampleInconclussiveRedo &&
      sample1.singleSampleTechnicalRedo === sample2.singleSampleTechnicalRedo)
      return true;
    return false;
  }

  resetSample() {
    this.selectedSample.inValidResult = this.tempSampleInvalid;
    this.selectedSample.comments = this.tempSampleComment;
    this.plateMap.set(this.getRowColStringFromPos(this.selectedSample.positionRow - 1, this.selectedSample.positionCol - 1), this.selectedSample);
  }

  isControlInvalid() {
    if (this.selectedSample.barcode == 'NTC_EX' || this.selectedSample.barcode == 'POS_EX') {
      if (this.selectedSample.inValidResult) {
        return true;
      }
    }
    return false;
  }

  disablePopUpUse() {
    return (!['ANALYSIS_STARTED', 'ANALYSIS_DONE'].includes(this.selectedBatch.statusOfTheBatch));
  }

  updatePlateMaps() {
    let sampleData = this.selectedBatch.samples;
    this.createPlateMaps(sampleData);
  }

  confirmCompleteAnalysis(){
    if(this.selectedBatch.locked){
    this.confirmationService.confirm({
      message: 'This batch is locked for sending out data. Do you still want to complete analysis?',
      acceptLabel: 'OK',
      header: 'Warning',
      icon: 'pi pi-exclamation-triangle',
      key: 'warning',
      accept: () => {
         this.confirmPlates();
      },
      reject: () => {}
    })
  }else{
    this.confirmPlates();
  }
  }

  confirmPlates() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before uploading',
      });
      this.blocked = false;
      return;
    }

    if (!this.allResultsSelected()) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Result Not Selected!',
        detail: 'Please Select a Result other than Check For Each Batch From Result DropDown',
      });
      this.blocked = false;
      return;
    }

    if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) {
      let missingPatterns = this.checkIfAllMandatoryFilesUploaded();
      if (missingPatterns && missingPatterns.length > 0) {
        this.confirmationService.confirm({
          message: 'Not All Mandatory Files are Uploaded, Do you still want to proceed?',
          acceptLabel: 'OK',
          header: 'Warning',
          icon: 'pi pi-exclamation-triangle',
          key: 'warning',
          accept: () => {
            this.showRedoDialog();
          },
          reject: () => { }
        })
      } else {
        this.showRedoDialog();
      }
    } else {
      this.showRedoDialog();
    }
  }

  showRedoDialog() {
    if ((this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report') ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[0] && this.selectedBatch.mergedBatches[0].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[0].redone) ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[1] && this.selectedBatch.mergedBatches[1].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[1].redone) ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[2] && this.selectedBatch.mergedBatches[2].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[2].redone) ||
      (this.selectedBatch.mergedBatches &&
        this.selectedBatch.mergedBatches[3] && this.selectedBatch.mergedBatches[3].finalResult !== 'Report'
        && !this.selectedBatch.mergedBatches[3].redone)) {

      this.confirmationService.confirm({
        message: this.redoDialogMessage,
        header: 'Redo?',
        accept: () => {
          if (this.reportingOutsideBB) {
            this.completeAnalysisForReportingOutsideProcess();
          }
        },
        reject: () => { }
      });
    } else {
      if (this.reportingOutsideBB) {
        this.completeAnalysisForReportingOutsideProcess();
      }
    }
  }

  completeAnalysisProcess() {
    this.showAnalysisDialog = false;
    if ((this.analysisVerifyPUID.toLowerCase() === this.puid.toLowerCase())) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Verification Failed!',
        detail: 'User ID must not be same as logged in PUID',
      });
      return;
    }
    this.blocked = true;
    let resultMap: Map<string, CovidSamples>;
    let isRedoReasonSelected = true;
    if (this.selectedBatch.wellType == WellType.WELL384) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.finalResult != 'Report' && !mergedBatch.redoReason)
          isRedoReasonSelected = false;
      });
      resultMap = this.getResultMapFor384();
    } else {
      isRedoReasonSelected = !(this.selectedBatch.finalResult != 'Report' && !this.selectedBatch.redoReason);
      resultMap = this.getResultMapFor96();
    }
    if (!isRedoReasonSelected) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Redo Reason Not Selected!',
        detail: 'Please Select Redo Reason for Each Batch Set for Redo',
      });
      this.blocked = false;
      return;
    }
    this.selectedBatch.samplesMap = [];
    let resultObject = {};
    resultMap.forEach((v: CovidSamples, k: string) => {
      if (v) {
        resultObject[k] = v;
      }
    });
    this.selectedBatch.analysisVerificationPUID = this.analysisVerifyPUID;
    this.selectedBatch.username = this.analysisVerifyPUID;
    this.selectedBatch.password = this.convertStringToUTF8ByteArray(this.enteredPassword);
    this.selectedBatch.eventForAuthorization = true;
    this.analysisVerifyPUID = null;
    this.enteredPassword = null;
    this.selectedBatch.samplesMap = resultObject;
    this.selectedBatch.completionDateTimeEvaluation = new Date();
    this.selectedBatch.statusOfTheBatch = 'ANALYSIS_DONE';
    this.selectedBatch.previousStatusOfTheBatch = 'ANALYSIS_DONE';
    this.selectedBatch.channelTestingTypeMapping = this.getChannelTestingMapper();
    this.apgTestingService.confirmPlates(this.selectedBatch, this.reportingOutsideBB,this.resultReportPerSender).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.togglePlateView();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Result Upload Successful',
            detail: 'Proceed with file download to view result',
          });
        }
        this.blocked = false;
      },
      error => {
        this.selectedBatch.completionDateTimeEvaluation = null;
        this.selectedBatch.puidEvaluation = '';
        this.selectedBatch.statusOfTheBatch = 'ANALYSIS_STARTED';
        this.selectedBatch.previousStatusOfTheBatch = 'ANALYSIS_STARTED';
        this.selectedBatch.analysisVerificationPUID = null;
        this.selectedBatch.username = null;
        this.selectedBatch.password = null;
        this.selectedBatch.eventForAuthorization = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );

  }

  allResultsSelected() {
    if (this.selectedBatch.wellType === WellType.WELL96) {
      return (this.selectedBatch.finalResult && this.selectedBatch.finalResult != 'Check') ? true : false;
    }
    else {
      let allResultSelected = true;
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (!mergedBatch.finalResult || mergedBatch.finalResult == 'Check')
          allResultSelected = false;
      })
      return allResultSelected;
    }
  }

  getResultMapFor384(): Map<string, CovidSamples> {
    let resultMap = new Map();
    let quadrantMap = this.getValidQuadrants();
    for (let i = 0; i < this.columnHeaders384.length; i++) {
      for (let j = 0; j < this.rowHeaders384.length; j++) {
        let rowPosString = this.getRowColStringFromPos(j, i);
        if (this.plateMap.has(rowPosString) && quadrantMap.has(this.quadrantFromRowColPos(rowPosString))) {
          resultMap.set(rowPosString, this.plateMap.get(rowPosString));
        } else {
          resultMap.set(rowPosString, null);
        }
      }
    }
    return resultMap;
  }

  getValidQuadrants(): Map<string, string> {
    let quadrantMap = new Map();
    for (let i = 0; i < this.selectedBatch.mergedBatches.length; i++) {
      if (this.selectedBatch.mergedBatches[i].finalResult == "Report") {
        quadrantMap.set(this.selectedBatch.mergedBatches[i].quadrant, "");
      }
    }
    return quadrantMap;
  }

  getResultMapFor96(): Map<string, CovidSamples> {
    let resultMap = new Map();
    for (let i = 0; i < this.columnHeaders384.length; i++) {
      for (let j = 0; j < this.rowHeaders384.length; j++) {
        let rowPosString = this.getRowColStringFromPos(j, i);
        if (this.plateMap.has(rowPosString) && this.selectedBatch.finalResult == "Report") {
          resultMap.set(rowPosString, this.plateMap.get(rowPosString));
        } else {
          resultMap.set(rowPosString, null);
        }
      }
    }
    return resultMap;
  }

  quadrantFromRowColPos(position: string) {
    let rowCol = this.getRowColumnNumberFromPosition(position);
    if (!this.isEven(rowCol[0]) && !this.isEven(rowCol[1])) {
      return Quadrant.A1;
    } else if (this.isEven(rowCol[0]) && !this.isEven(rowCol[1])) {
      return Quadrant.A2;
    } else if (!this.isEven(rowCol[0]) && this.isEven(rowCol[1])) {
      return Quadrant.B1;
    } else {
      return Quadrant.B2;
    }
  }

  isEven(num: number) {
    return num % 2 == 0;
  }

  getRowColumnNumberFromPosition(position: string): number[] {
    let row = position.charCodeAt(0) - 64;
    let col = parseInt(position.substring(1), 10);
    return [row, col];
  }

  downloadResultsFile() {
    this.blocked = true;
    this.apgTestingService.downloadResultFile(this.selectedBatch.batchID, this.selectedLabId).subscribe(
      results => {
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, this.selectedBatch.batchID + ".zip");
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Download is successful',
          detail: 'Result files have been downloaded',
        });
        this.blocked = false;
      },
      _error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Download Failed',
          detail: 'Could not download result files.',
        });
      });
  }

  initializeScanTable(mapOfPlatePositions: Map<string, CovidSamples>) {
    this.mapOfScannedBarcodes = new Map();
    this.scanTableBackupMap = new Map();
    this.currentScanCell = 0;
    this.scannedBarcode = '';
    this.activateSaveScan = false;
    this.scanTableArray = [];
    this.scannedControls = [];
    this.posControlsRemaining = this.posControlsForLab;
    this.contaminationPopUp = false;
    this.negativeControlRemaining = this.negativeControlForLab;
    for (let i = 0; i < 12; i++) {
      for (let j = 0; j < 8; j++) {
        let covidSample = new CovidSamples();
        covidSample.barcode = '';
        covidSample.positionRow = j + 1;
        covidSample.positionCol = i + 1;
        covidSample.contaminationType = "No Contamination";
        let positionsString = this.getRowColStringFromPos(j, i);
        if (mapOfPlatePositions.has(positionsString)) {
          let sample = mapOfPlatePositions.get(positionsString);
          if (this.isPositiveControl(sample.barcode,sample.sampleType)) {
            this.posControlsRemaining--;
            this.scannedControls.push(sample);
          } else if (this.isNegativeControl(sample.barcode,sample.sampleType)) {
            this.negativeControlRemaining--;
            this.scannedControls.push(sample);
          } else {
            this.mapOfScannedBarcodes.set(sample.barcode, positionsString);
          }
          covidSample = Object.assign({}, sample);
          this.scanTableBackupMap.set(sample.barcode, sample);
          this.currentScanCell = this.getPositionalValue(j, i);
        }
        this.scanTableArray.push(covidSample);
      }
    }
    if (this.plateMap.size > 0) {
      this.currentScanCell = this.currentScanCell !== 93 ? this.currentScanCell + 1 : this.currentScanCell;
    }
  }

  isPositiveControl(barcode : string, sampleType : string) {
    return barcode === 'POS_EX' ||  sampleType == this.positiveControlSampleType;
  }

  isNegativeControl(barcode : string, sampleType : string) {
    return barcode === 'NTC_EX' ||  sampleType == this.negativeControlSampleType;
  }
  getPositionalValue(row: number, col: number) {
    return (col * 8) + row;
  }
 
  saveSamplesForBatch() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    if(!this.isAllControlsScanned()){
      return;
    }
    let scanArrayToSend = [];
    let scannedBarcodes = [];
    this.scanTableArray.forEach(sample => {
      if (sample.barcode && sample.barcode.trim() != '') {
        scanArrayToSend.push(sample);
        scannedBarcodes.push(sample.barcode);
      }
    });
    this.selectedBatch.scannedBarcodes = scannedBarcodes;
    this.selectedBatch.samples = scanArrayToSend;
    this.selectedBatch.sampleListSizeWithoutControls = scanArrayToSend.length;
    this.selectedBatch.statusOfTheBatch = 'START_CLIPPING';
    this.selectedBatch.previousStatusOfTheBatch = 'START_CLIPPING';
    this.selectedBatch.puidClipping = this.puid;
    this.selectedBatch.scannedControls = this.scannedControls.filter(sample => (sample != null && sample != undefined && sample.barcode && sample.barcode.trim() != ''));
    if (!this.selectedBatch.clippingStartDateTime) {
      this.selectedBatch.clippingStartDateTime = new Date();
    }
    this.apgTestingService.saveScannedSamples(this.selectedBatch).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Samples Saved!',
            detail: 'All samples saved!',
          });
          this.createPlateMaps(this.selectedBatch.samples);
          this.initializeScanTable(this.plateMap);
          this.dirty = false;
          this.differentUnboxedErrorDisabled = false;
          this.activateSaveScan = false;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.scannedSampleErrorMessage = message.summary + ' : ' + message.detail;
        this.showSampleErrorPopUp = true;
      }
    );
  }
  saveScannedSamplesForBatch() {
    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    let scanArrayToSend = [];
    let scannedBarcodes = [];
    this.scanTableArray.forEach(sample => {
      if (sample.barcode && sample.barcode.trim() != '') {
        scanArrayToSend.push(sample);
        scannedBarcodes.push(sample.barcode);
      }
    });
    this.selectedBatch.scannedBarcodes = scannedBarcodes;
    this.selectedBatch.samples = scanArrayToSend;
    this.selectedBatch.sampleListSizeWithoutControls = scanArrayToSend.length;
    this.selectedBatch.statusOfTheBatch = 'START_CLIPPING';
    this.selectedBatch.previousStatusOfTheBatch = 'START_CLIPPING';
    this.selectedBatch.puidClipping = this.puid;
    this.selectedBatch.scannedControls = this.scannedControls.filter(sample => (sample != null && sample != undefined && sample.barcode && sample.barcode.trim() != ''));
    if (!this.selectedBatch.clippingStartDateTime) {
      this.selectedBatch.clippingStartDateTime = new Date();
    }
    this.apgTestingService.saveScannedSamples(this.selectedBatch).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Sample Saved!',
            detail: 'Scanned sample saved!',
          });
          this.createPlateMaps(this.selectedBatch.samples);
          this.initializeScanTable(this.plateMap);
          this.dirty = false;
          this.differentUnboxedErrorDisabled = false;
          this.activateSaveScan = true;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.scannedSampleErrorMessage = message.summary + ' : ' + message.detail;
        this.showSampleErrorPopUp = true;
      }
    );
  }
  isAllControlsScanned() {
    let keysOfScannedBarcodes = Array.from(this.plateMap.keys());
    let keysOfControls = Array.from(this.mapOfControls.keys());
    let newPositiveMissing = [];
    let newNegativeMissing = [];
    let finalValidation = [];

    for(let value of this.controlStatus){
      if(!['POSITIVE_PCR', 'NEGATIVE_PCR'].includes(value.controlType) && !value.isScanned){
        finalValidation.push(value.regex);
      }
    }

    let missingControls = keysOfControls.filter(item => !['POSITIVE_PCR', 'NEGATIVE_PCR'].includes(this.mapOfControls.get(item).controlType) && keysOfScannedBarcodes.indexOf(item) < 0 );

    missingControls.forEach(e => {
      if (this.gettingPositivePositionKeys.includes(e)) {
        newPositiveMissing.push(e);
      } else if (this.gettingNegativePositionKeys.includes(e)) {
        newNegativeMissing.push(e);
      }
    });

    if (newPositiveMissing.length > 0 || newNegativeMissing.length > 0 || finalValidation.length > 0) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Missed Controls ', detail: ' Missed Positive Control Positions Are '+newPositiveMissing.length+ ' :  ' + newPositiveMissing + ','+
        '  Missed Negative Control Positions Are  '+ newNegativeMissing.length+ ' : ' + newNegativeMissing+' '+ ' And Missed Undefined Control Names are : ' + finalValidation.length + '   ' + finalValidation
      });
      return false;
    } else {
      return true;
    }
  }

  isScanningAllowed() {
    let scanAllowedStates = ['SCAN_COMPLETE', 'START_CLIPPING'];
    return scanAllowedStates.includes(this.selectedBatch.statusOfTheBatch);
  }

  focusScannedField() {
    this.scannedBarcode = '';
    this.focusOnCell();
  }

  moveFocus() {
    if (this.currentScanCell < 95-this.totalPCRControls) {
      this.currentScanCell += 1;
      this.focusOnCell();
    }
  }

  getCurrentPositionString(positionValue: number) {
    if (positionValue >= 0) {
      let row = positionValue % 8;
      let col = Math.trunc(positionValue / 8);
      return this.getRowColStringFromPos(row, col);
    } else {
      return '';
    }
  }

  cellSelection(row: number, col: number) {
    let rowColString = this.getRowColStringFromPos(row, col);
    if (this.isScanningAllowed()) {
      let scanCell = this.getPositionalValue(row, col);
      if (scanCell > 95-this.totalPCRControls) {
        this.scannedBarcode = '';
        return;
      }
      if (scanCell == this.currentScanCell
        && this.plateMap.has(rowColString)
        && this.scanTableBackupMap.has(this.plateMap.get(rowColString).barcode)) {
        this.contaminationPopUp = true;
        this.selectedSample = this.scanTableArray[this.currentScanCell];
      } else {
        this.currentScanCell = scanCell;
        this.focusOnCell();
      }
      return;
    }
  }

  regexMatcher(regex: string, barcode: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(barcode);
  }

  placePOSEXControl() {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    if (this.posControlsRemaining > 0) {
      if (!this.scanTableArray[this.currentScanCell].barcode || this.scanTableArray[this.currentScanCell].barcode.trim() === '') {
        this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));//, 'POS_EX', this.positiveControlSampleType);
        this.plateMap.set(currentPositionString, Object.assign({}, this.scanTableArray[this.currentScanCell]));
        this.posControlsRemaining--;
        this.dirty = true;
        this.scannedControls.push(this.plateMap.get(currentPositionString));
        this.activateSaveScan = true;
        this.moveFocus();
      } else {
        this.scannedSampleErrorMessage = 'Occupied Position: Cannot insert POS_EX here.';
        this.showSampleErrorPopUp = true;
      }
    }
    this.focusOnCell();
  }

  placeNTCEXControl() {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    if (this.negativeControlRemaining > 0) {
      if (!this.scanTableArray[this.currentScanCell].barcode || this.scanTableArray[this.currentScanCell].barcode.trim() === '') {
        this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));//, 'Negative', this.negativeControlSampleType);
        this.plateMap.set(currentPositionString, Object.assign({}, this.scanTableArray[this.currentScanCell]));
        this.negativeControlRemaining--;
        this.dirty = true;
        this.scannedControls.push(this.plateMap.get(currentPositionString));
        this.activateSaveScan = true;
        this.moveFocus();
      } else {
        this.scannedSampleErrorMessage = 'Occupied Position: Cannot insert NTC_EX here.';
        this.showSampleErrorPopUp = true;
      }
    }
    this.focusOnCell();
  }

  focusOnCell() {
    this.scannedBarcode = this.scanTableArray[this.currentScanCell].barcode ? this.scanTableArray[this.currentScanCell].barcode : '';
    let element = document.getElementById("scanBarcode");
    element.focus();
  }
    
  preparePositiveExtractionControlData(control: Controls) {
    control.positiveExtractionControl.forEach(possitiveEControls => {
      if (possitiveEControls.position !== undefined && possitiveEControls.position.trim() !== "") {
        this.mapOfControls.set(possitiveEControls.position, {regexFormat: possitiveEControls.regexFormat, controlType: 'POSITIVE_EXTRACTION'});
        this.gettingPositivePositionKeys.push(possitiveEControls.position);
      } else {
        this.mapOfUndefinedPositonArray.push(possitiveEControls.regexFormat);
        this.controlStatus.push({regex: possitiveEControls.regexFormat, isScanned: false, position: '', controlType: 'POSITIVE_EXTRACTION' })
      }
      this.positiveExtractionControlArray.push(possitiveEControls.regexFormat);
      this.controlArray.push(possitiveEControls.regexFormat);
      this.mapOfParticularControl.set(possitiveEControls.regexFormat, 'Positive');
    });
    this.positiveControlsCountForControl = control.numberOfPC;
  }

  prepareNegativeExtractionControlData(control: Controls) {
    control.negativeExtractionControl.forEach(negativeEControls => {
      if (negativeEControls.position !== undefined && negativeEControls.position.trim() !== "") {
        this.mapOfControls.set(negativeEControls.position, {regexFormat: negativeEControls.regexFormat, controlType: 'NEGATIVE_EXTRACTION'});
        this.gettingNegativePositionKeys.push(negativeEControls.position);
      } else {
        this.mapOfUndefinedPositonArray.push(negativeEControls.regexFormat);
        this.controlStatus.push({regex: negativeEControls.regexFormat, isScanned: false, position: '', controlType: 'NEGATIVE_EXTRACTION' })
      }
      this.negativeExtractionControlArray.push(negativeEControls.regexFormat);
      this.controlArray.push(negativeEControls.regexFormat);
      this.mapOfParticularControl.set(negativeEControls.regexFormat, 'Negative')
    });
    this.negativeControlsCountForControl = control.numberOfNC;
  }

  preparePositivePCRControlsData(control: Controls) {
    control.positivePCRControls.forEach(positivePCRControl => {
      if (positivePCRControl.position !== undefined) {
        this.mapOfControls.set(positivePCRControl.position, {regexFormat: positivePCRControl.regexFormat, controlType: 'POSITIVE_PCR'});
        this.gettingPositivePCRPositionKeys.push(positivePCRControl.position);
      } else {
        this.mapOfUndefinedPositonArray.push(positivePCRControl.regexFormat);
        this.controlStatus.push({regex: positivePCRControl.regexFormat, isScanned: false, position: '', controlType: 'POSITIVE_PCR' })
      }
      this.positivePCRExtractionControlArray.push(positivePCRControl.regexFormat);
      this.controlArray.push(positivePCRControl.regexFormat);
      this.mapOfParticularControl.set(positivePCRControl.regexFormat, 'PositivePCR');
    });
    this.positivePCRControlsCountForControl = control.numberOfPositivePCR;
  }

  prepareNegativePCRControlsData(control: Controls) {
    control.negativePCRControls.forEach(negativePCRControl => {
      if (negativePCRControl.position !== undefined) {
        this.mapOfControls.set(negativePCRControl.position, {regexFormat: negativePCRControl.regexFormat, controlType: 'NEGATIVE_PCR'});
        this.gettingNegativePCRPositionKeys.push(negativePCRControl.position);
      } else {
        this.mapOfUndefinedPositonArray.push(negativePCRControl.regexFormat);
        this.controlStatus.push({regex: negativePCRControl.regexFormat, isScanned: false, position: '', controlType: 'NEGATIVE_PCR' })
      }
      this.negativePCRExtractionControlArray.push(negativePCRControl.regexFormat);
      this.controlArray.push(negativePCRControl.regexFormat);
      this.mapOfParticularControl.set(negativePCRControl.regexFormat, 'NegativePCR');
    });
    this.negativePCRControlsCountForControl = control.numberOfNegativePCR;
  }
  
  gettingControls() {
    this.controlArray = [];
    this.controlStatus =[];
    this.positiveControlsCountForControl = -1 ;
    this.negativeControlsCountForControl = -1 ;
    this.positivePCRControlsCountForControl = -1 ;
    this.negativePCRControlsCountForControl = -1 ;

    this.controls.forEach(control => {
        if (this.selectedBatch.workFlow && this.selectedBatch.workFlow.controlSchema === control.controlConfigurationName) {

          if(control.positiveExtractionControl !== undefined) {
            this.preparePositiveExtractionControlData(control);
          }

          if(control.negativeExtractionControl !== undefined) {
            this.prepareNegativeExtractionControlData(control);
          }

          if(control.positivePCRControls !== undefined) {
            this.preparePositivePCRControlsData(control);
          }

          if(control.negativePCRControls !== undefined) {
            this.prepareNegativePCRControlsData(control);
          }

          this.mapOfPositiveAndNegativePositions.set("Positive", this.gettingPositivePositionKeys);
          this.mapOfPositiveAndNegativePositions.set("Negative", this.gettingNegativePositionKeys);
          this.mapOfPositiveAndNegativePositions.set("PositivePCR", this.gettingPositivePCRPositionKeys);
          this.mapOfPositiveAndNegativePositions.set("NegativePCR", this.gettingNegativePCRPositionKeys);
        }
    });

    this.getPositivePosition = this.mapOfPositiveAndNegativePositions.get('Positive');
    this.getNegativePosition = this.mapOfPositiveAndNegativePositions.get('Negative');
    this.getPositivePCRPosition = this.mapOfPositiveAndNegativePositions.get('PositivePCR');
    this.getNegativePCRPosition = this.mapOfPositiveAndNegativePositions.get('NegativePCR');

  }
  isUndefinedBarcode(barcode: string){
    for(let regex of this.mapOfUndefinedPositonArray){
      if (this.regexMatcher(regex, barcode)) {
        return true;
      }
    }
    return false;
    }


  isPossitiveRegexMatch(oldBarcode: string){
    for(let regex of this.positiveExtractionControlArray){
      if (this.regexMatcher(regex, oldBarcode)) {
        return true;
      }
    }
    return false;
  }

  isnegativeRegexMatch(oldBarcode: string){
    for(let regex of this.negativeExtractionControlArray){
      if (this.regexMatcher(regex, oldBarcode)) {
        return true;
      }
    }
    return false;
  }

  serviceCallForControls(){
    this.masterDataService.getControlConfiguration(this.selectedLab, this.controlType).subscribe(
       results => {
         if (!results) {
           return;
         }
         this.controls = results.data;
         this.gettingControls();
         if( this.selectedBatch.samples){
           this.selectedBatch.samples.forEach(sample => {
             let positionalValue = this.getPositionalValue(sample.positionRow, sample.positionCol);
             let positionString = this.getCurrentPositionString(positionalValue);
             if (!this.mapOfControls.has(positionString)) {
                   for(let valueOfStatus of this.controlStatus){
                 if(!valueOfStatus.isScanned &&  this.regexMatcher(valueOfStatus.regex, sample.barcode)){
                   valueOfStatus.isScanned = true;
                   valueOfStatus.position = positionString;
                   break;
                 }
               }
             }
           });
         }
       },
       error => {
         this.controls = [];
         let message = this.errorHandler.handleError(error);
         this._messagesService.addErrorMessage(message);
       }
     );
 }

  verifyScan(barcode: string) {
    if(!this.selectedBatch.workFlow || !this.selectedBatch.workFlow.product || this.selectedBatch.workFlow.product.length<1){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Workflow misconfiguration',
        detail: 'Please make sure a workflow with atleast one product is configured with the batch',
      });
      return;
    }
    let currentBarcode = '';
    let currentCellSample = Object.assign({}, this.scanTableArray[this.currentScanCell]);
    let isBeingReplaced = currentCellSample.barcode != barcode;
    currentBarcode = currentCellSample.barcode;
    this.isControl = false;
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    let count = 0;
    this.currentRegexFormat = '';
    let plateMapSample = this.plateMap.get(currentPositionString);
    
    if (this.mapOfControls.has(currentPositionString)) {
      if (!(this.mapOfControls.get(currentPositionString).regexFormat == barcode || this.regexMatcher(this.mapOfControls.get(currentPositionString).regexFormat, barcode))) {
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Occupied Position!',
          detail: 'Barcode ' + barcode + ' Cannot Insert Here,Already Occupied For Fixed Control..!',
        });
        return;
      }
    }
    
    for (let regString of this.controlArray) {
      count++;
      if (this.regexMatcher(regString, barcode)) {
        this.isControl = true;
        this.currentRegexFormat = regString;
        if (this.mapOfParticularControl.get(this.currentRegexFormat) === 'Positive') {
          this.positiveExtractionRegexControl.push(barcode);
        }
        if(this.mapOfParticularControl.get(this.currentRegexFormat) === 'Negative'){
          this.negativeExtractionRegexControl.push(barcode);
        }
        if (this.mapOfParticularControl.get(this.currentRegexFormat) === 'PositivePCR') {
          this.positivePCRExtractionRegexControl.push(barcode);
        }
        if(this.mapOfParticularControl.get(this.currentRegexFormat) === 'NegativePCR'){
          this.negativePCRExtractionRegexControl.push(barcode);
        }

        let value = this.mapOfControls.get(currentPositionString) ? this.mapOfControls.get(currentPositionString).regexFormat : undefined;
        if (value == undefined && this.isUndefinedBarcode(barcode) && barcode !== "") {
          let isUndefinedPositionMatch = false;
          for(let valueOfStatus of this.controlStatus){
            if(!valueOfStatus.isScanned &&  this.regexMatcher(valueOfStatus.regex, barcode)){
              valueOfStatus.isScanned = true;
              isUndefinedPositionMatch = true;
              valueOfStatus.position = currentPositionString;
              break;
            }
          }

          if (!isUndefinedPositionMatch) {
            this._messagesService.addWarningMessage({
              severity: 'warn', summary: 'Scanned',
              detail: 'Barcode ' + barcode + ' Scanned Already',
            });
            return;
          }
        }
        if (value == undefined && !this.mapOfUndefinedPositonArray.includes(this.currentRegexFormat)) {
          this.isControl = false;
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Occupied Position!',
            detail: 'Barcode ' + barcode + ' We Can Not Insert Here',
          });
          return;
        }
        break;
      }
    }
    
    if (barcode.trim() === '') {
      if (this.plateMap.has(currentPositionString)) {
        let scannedBarcode = plateMapSample.barcode;
        if (this.regexMatcher(this.positiveControlRegex, scannedBarcode)) {
          this.posControlsRemaining++;
          this.scannedControls.splice(this.scannedControls.indexOf(plateMapSample), 1);
        } else if (scannedBarcode === this.negativeControlRegex) {
          this.negativeControlRemaining++;
          this.scannedControls.splice(this.scannedControls.indexOf(plateMapSample), 1);
        } else {
          this.mapOfScannedBarcodes.delete(scannedBarcode);
        }
        this.plateMap.delete(currentPositionString);
        this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));//, '', this.sampleSampleType);
        this.dirty = true;
        this.activateSaveScan = true;
      }
      this.moveFocus();
      return;
    }
    if (this.plateMap.has(currentPositionString) && plateMapSample.barcode !== barcode) {
      this.replacementHandler(plateMapSample);
    }
    if (barcode === 'POS_EX' || barcode === 'NTC_EX' || this.positiveExtractionControlArray.includes(barcode) || this.negativeExtractionControlArray.includes(barcode) || this.positivePCRExtractionControlArray.includes(barcode) || this.negativePCRExtractionControlArray.includes(barcode) || this.isControl) {      if (!this.plateMap.has(currentPositionString)) {
        if (barcode === 'POS_EX' || this.isPossitiveRegexMatch(barcode) ||  this.mapOfParticularControl.get(this.currentRegexFormat) === 'Positive') {
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scanTableArray[this.currentScanCell].barcode = barcode;
            this.scanTableArray[this.currentScanCell].sampleType = 'POSITIVE_CONTROL';
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          this.saveScannedSamplesForBatch();  
          return;
        } else if (barcode === 'NTC_EX' || this.isnegativeRegexMatch(barcode) || this.mapOfParticularControl.get(this.currentRegexFormat) === 'Negative') {
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scanTableArray[this.currentScanCell].barcode = barcode;
          this.scanTableArray[this.currentScanCell].sampleType = 'NEGATIVE_CONTROL';
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          this.saveScannedSamplesForBatch();  
          return;
        }else if (this.positivePCRExtractionControlArray.includes(barcode) ||  this.mapOfParticularControl.get(this.currentRegexFormat) === 'PositivePCR') {
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scanTableArray[this.currentScanCell].barcode = barcode;
            this.scanTableArray[this.currentScanCell].sampleType = 'POSITIVE_CONTROL';
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          this.saveScannedSamplesForBatch();  
          return;
        } else if (this.negativePCRExtractionControlArray.includes(barcode) || this.mapOfParticularControl.get(this.currentRegexFormat) === 'NegativePCR') {
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scanTableArray[this.currentScanCell].barcode = barcode;
          this.scanTableArray[this.currentScanCell].sampleType = 'NEGATIVE_CONTROL';
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          this.saveScannedSamplesForBatch();  
          return;
        } else {
          this.focusScannedField();
          if (isBeingReplaced) {
            this.restoreBarcode(currentCellSample);
            this.focusOnCell();
          }
          this.scannedSampleErrorMessage = 'All ' + barcode + ' controls have already been added.';
          this.showSampleErrorPopUp = true;
          return;
        }
      } else {
        if (plateMapSample && plateMapSample.barcode === barcode) {
          this.moveFocus();
        } else {
          if (isBeingReplaced) {
            this.restoreBarcode(currentCellSample);
            this.focusOnCell();
          }
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Occupied Position!',
            detail: 'Cannot insert control here.',
          });
        }
        return;
      }
    }

    if (this.mapOfScannedBarcodes.has(barcode)) {
      if (currentPositionString === this.mapOfScannedBarcodes.get(barcode)) {
        this.moveFocus();
        return;
      }
      this.scannedSampleErrorMessage = barcode + ' has already been scanned at ' + this.mapOfScannedBarcodes.get(barcode);
      this.showSampleErrorPopUp = true;
      if (isBeingReplaced) {
        this.restoreBarcode(currentCellSample);
      }
      return;
    }

    if (this.scanTableBackupMap.has(barcode)) {
      this.scanTableArray[this.currentScanCell] = this.scanTableBackupMap.get(barcode);
      this.scanTableArray[this.currentScanCell].positionRow = (this.currentScanCell % 8) + 1;
      this.scanTableArray[this.currentScanCell].positionCol = Math.trunc(this.currentScanCell / 8) + 1;
      this.mapOfScannedBarcodes.set(barcode, currentPositionString);
      this.plateMap.set(currentPositionString, Object.assign({}, this.scanTableArray[this.currentScanCell]));
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'MOVED!',
        detail: barcode + ' has been moved',
      });
      this.moveFocus();
      return;
    }

    this.blocked = true;
    this.apgTestingService.validateScannedBarcode(barcode, this.selectedLabId).subscribe(
      result => {
        this.blocked = false;
        let animalSamplesOrders: UnboxedSample = result.data.output;
        let orderMap = new Map<string, UnboxedSample>();
        Object.values(animalSamplesOrders).forEach(sampleOrder => {
          for (let i = 0; i < sampleOrder.unboxedSamples.order.length; i++) {
            orderMap.set(sampleOrder.unboxedSamples.order[i], sampleOrder.unboxedSamples);
          }
        });
        var match = false;
        for(var o of this.selectedBatch.workFlow.product){
          if(orderMap.has(o)){
            match = true;
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'SCANNED!',
              detail: barcode + ' is OK',
            });
            this.dirty = true;
            this.updateScanTableArray(barcode, currentPositionString, orderMap.get(o));
            this.saveScannedSamplesForBatch();     
            break;
          }
        }
        if(!match){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Not a match',
            detail: 'Order does not match with selected workflow products'
          })
          return;
        }
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this.scannedSampleErrorMessage = message.detail;
        this.showSampleErrorPopUp = true;
        if (isBeingReplaced) {
          this.restoreBarcode(currentCellSample);
        }
      }
     );
    var isBarcodePositiveExControl : boolean = this.regexMatcher(this.positiveControlRegex, barcode);
    var isBarcodeNegativeExControl : boolean = (barcode == this.negativeControlRegex);
    if (isBarcodePositiveExControl || isBarcodeNegativeExControl) {
      if (!this.plateMap.has(currentPositionString)) {
        if (isBarcodePositiveExControl && this.posControlsRemaining > 0) {
          this.posControlsRemaining--;
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          return;
        } else if (isBarcodeNegativeExControl && this.negativeControlRemaining > 0) {
          this.negativeControlRemaining--;
          this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
          this.scannedControls.push(this.scanTableArray[this.currentScanCell]);
          this.dirty = true;
          this.addToScanTable(this.scanTableArray[this.currentScanCell]);
          return;
        } else {
          this.focusScannedField();
          if (isBeingReplaced) {
            this.restoreBarcode(currentCellSample);
            this.focusOnCell();
          }
          if(isBarcodePositiveExControl){
            this.scannedSampleErrorMessage = 'All positive extraction controls have already been added.';
          }else{
            this.scannedSampleErrorMessage = 'All negative extraction controls have already been added.';
          }
          this.showSampleErrorPopUp = true;
          return;
        }
      } else {
        if (plateMapSample && plateMapSample.barcode === barcode) {
          this.moveFocus();
        } else {
          if (isBeingReplaced) {
            this.restoreBarcode(currentCellSample);
            this.focusOnCell();
          }
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Occupied Position!',
            detail: 'Cannot insert control here.',
          });
        }
        return;
      }
    }        
    
  }

  updateScanTableArray(barcode: string, currentPositionString: string, unboxedSample: UnboxedSample ) {
    this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));
    this.scanTableArray[this.currentScanCell].order = unboxedSample.order;
    this.scanTableArray[this.currentScanCell].tests = unboxedSample.tests;
    this.scanTableArray[this.currentScanCell].orderStatus = 'NEW';
    this.scanTableArray[this.currentScanCell].sampleType = 'SAMPLE';
    this.scanTableArray[this.currentScanCell].barcode = barcode;
    this.scanTableArray[this.currentScanCell].delivery = unboxedSample.delivery;
    this.mapOfScannedBarcodes.set(barcode, currentPositionString);
    this.addToScanTable(this.scanTableArray[this.currentScanCell]);
  }
  

  addToScanTable(sample: CovidSamples) {
    this.plateMap.set(this.getCurrentPositionString(this.currentScanCell), Object.assign({}, sample));
    this.moveFocus();
    this.activateSaveScan = true;
  }

  getCellStyle(row: number, col: number) {
    let positionalValue = this.getPositionalValue(row, col);
    let positionString = this.getCurrentPositionString(positionalValue);
    if (this.currentScanCell == positionalValue) {
      return {
        'border': '2px solid red',
        'border-radius': '4px',
        'background-color': '#86ff8a'
      };
    } else if (this.scanTableArray[positionalValue].barcode == 'POS_EX' || this.isPossitiveRegexMatch(this.scanTableArray[positionalValue].barcode) || this.positiveExtractionRegexControl.includes(this.scanTableArray[positionalValue].barcode) || this.getPositivePosition.includes(positionString)) {
      return {
        'background-color': 'aqua'
      };
    } else if (this.scanTableArray[positionalValue].barcode == 'NTC_EX' || this.isnegativeRegexMatch(this.scanTableArray[positionalValue].barcode) || this.negativeExtractionRegexControl.includes(this.scanTableArray[positionalValue].barcode) || this.getNegativePosition.includes(positionString))  {
      return {
        'background-color': 'yellow'
      };
    } else if ((this.scanTableArray[positionalValue].barcode != '') && (this.scanTableArray[positionalValue].receivedBatchID != this.selectedBatch.batchID)) {
      return { 'background-color': '#fcc888' };
    } else if (this.isEven(row)) {
      return { 'background-color': '#d8fcff' };
    } else {
      return { 'background-color': 'white' };
    }
  }

  getColHeaderStyle(col: number) {
    if (this.isScanningAllowed()) {
      if (Math.trunc(this.currentScanCell / 8) == col) {
        return {
          'background-color': 'red'
        };
      }
    }
  }

  getRowHeaderStyle(row: number) {
    if (this.isScanningAllowed()) {
      if ((this.currentScanCell % 8) == row) {
        return {
          'background-color': 'red',
          'color': 'white'
        };
      }
    }
  }

  allControlsNotPresent() {
    let posControl = this.posControlsForLab;
    let negControl = this.negativeControlForLab;
    this.selectedBatch.samples.forEach(sample => {
      if (sample.barcode == 'POS_EX'|| sample.sampleType == 'PositiveControl') {
        posControl--;
      } else if (sample.barcode == 'NTC_EX' || sample.sampleType == 'NegativeControl') {
        negControl--;
      }
    });

    if (posControl > 0) {
      return true;
    } else if (negControl > 0) {
      return true;
    } else {
      return false;
    }
  }

  getPlateViewButtonLabel(plateView: boolean) {
    if (plateView) {
      return 'View Batch';
    } else {
      if (!this.isScanningAllowed()) {
        return 'View Plate';
      } else {
        return 'Scan RNA Plate';
      }
    }
  }

  commentsDisabledIf(contaminationType: string): boolean {
    return this.selectedSample.contaminationType != contaminationType;
  }

  saveContamination() {
    this.apgTestingService.saveContaminationInformation(this.selectedBatch.batchID, this.selectedSample, this.selectedBatch.lab).subscribe(
      result => {
        if (result.data) {
          this.contaminationPopUp = false;
          this.plateMap.set(this.getCurrentPositionString(this.currentScanCell), this.selectedSample);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Sample Updated', detail: result.data });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  replacementHandler(sample: CovidSamples) {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    if (sample.barcode === 'NTC_EX' ||  sample.sampleType == 'NegativeControl') {
      this.negativeControlRemaining++;
      this.scannedControls.splice(this.scannedControls.indexOf(sample), 1);
    } else if (sample.barcode === 'POS_EX' || sample.sampleType == 'PositiveControl') {
      this.posControlsRemaining++;
      this.scannedControls.splice(this.scannedControls.indexOf(sample), 1);
    } else {
      this.mapOfScannedBarcodes.delete(sample.barcode);
    }
    this.scanTableArray[this.currentScanCell] = this.getNewCovidSampleFromPosition((this.currentScanCell % 8), Math.trunc(this.currentScanCell / 8));//, '', this.sampleSampleType);
    this.plateMap.delete(currentPositionString);
    return;
  }

  restoreBarcode(sample: CovidSamples) {
    let currentPositionString = this.getCurrentPositionString(this.currentScanCell);
    let plateMapSample = this.plateMap.get(currentPositionString);
    this.scanTableArray[this.currentScanCell] = Object.assign({}, sample);
    if (sample.barcode === 'NTC_EX' ||  sample.sampleType == 'NegativeControl') {
      this.negativeControlRemaining--;
      this.scannedControls.push(plateMapSample);
    } else if (sample.barcode === 'POS_EX' ||  sample.sampleType == 'PositiveControl') {
      this.posControlsRemaining--;
      this.scannedControls.push(plateMapSample);
    } else {
      this.mapOfScannedBarcodes.set(sample.barcode, currentPositionString);
    }
    this.plateMap.set(currentPositionString, this.scanTableArray[this.currentScanCell]);
    return;
  }

  getNewCovidSampleFromPosition(row: number, col: number) {
    let sample = new CovidSamples();
    sample.positionRow = row + 1;
    sample.positionCol = col + 1;
    sample.barcode = '';
    sample.sampleType = '';
    sample.contaminationType = 'No Contamination';
    return sample;
  }

  allChannelsUpdated(sample: CovidSamples): boolean {
    let showResult = true;
    if (this.selectedBatch.resultUploaded && sample && sample.channels) {
      sample.channels.forEach(channel => {
        if (!channel.resultUploaded) {
          showResult = false;
        }
      });
      return showResult;
    } else {
      return false;
    }
  }

  getGeneFromFileName(fileName: string, pcrKitName: string) {
    let pcrKit: any = this.getPcrKitFromMap(pcrKitName);
    if (!pcrKit || (!pcrKit.channel1Gene && !pcrKit.channel2Gene && !pcrKit.channel3Gene && !pcrKit.channel4Gene && !pcrKit.channel5Gene)) {
      return this.emptyGeneName;
    } else {
      if (pcrKit.channel1Gene && this.fileEndChecker(pcrKit.channel1File, fileName)) {
        return pcrKit.channel1Gene;
      } else if (pcrKit.channel2Gene && this.fileEndChecker(pcrKit.channel2File, fileName)) {
        return pcrKit.channel2Gene;
      } else if (pcrKit.channel3Gene && this.fileEndChecker(pcrKit.channel3File, fileName)) {
        return pcrKit.channel3Gene;
      } else if (pcrKit.channel4Gene && this.fileEndChecker(pcrKit.channel4File, fileName)) {
        return pcrKit.channel4Gene;
      } else if (pcrKit.channel5Gene && this.fileEndChecker(pcrKit.channel5File, fileName)) {
        return pcrKit.channel5Gene;
      } else {
        return 'error';
      }
    }
  }

  fileEndChecker(endString: string, fileName: string): boolean {
    return fileName.includes(endString);
  }

  getPcrKitFromMap(pcrKitName: string) {
    let mapKits = new Map(Object.entries(this.mapOfKits));
    let pcrKitMap = new Map(Object.entries(mapKits.get("pcr")));
    return pcrKitMap.get(pcrKitName);
  }

  allChannelsUpdatedForBatch() {
    if (this.selectedBatch.resultUploaded && this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
      return this.allChannelsUpdated(this.selectedBatch.samples[0]);
    }
  }

  isContaminated(sample: CovidSamples): boolean {
    return (sample.contaminationType && sample.contaminationType != 'No Contamination') || (sample.comments && sample.comments.trim() != '');
  }

  isNCSample(sample: CovidSamples): boolean {
    return sample.nonConformanceProblem && sample.nonConformanceProblem.trim() != '' && sample.nonConformanceProblem != 'sampleOk';
  }

  hideUnboxWarningDialog() {
    this.showDifferentUnboxedErrorPopUp = false;
  }

  closeSampleErrorPopUp() {
    this.showSampleErrorPopUp = false;
  }

  disablePCRKitVendorIf() {
    return (!this.selectedBatch.precyclingStartDateTime && !this.selectedBatch.puidstartPrecycling) || this.disableTDInputsIf("Precycling");
  }

  setTemplateButtonLabel() {
    if (['CREATE_BATCH', 'SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'].includes(this.selectedBatch.statusOfTheBatch))
      this.showFilledTemplateLabel = false;
    else
      this.showFilledTemplateLabel = true;
  }

  getTemplateButtonLabel() {
    return !['CREATE_BATCH', 'SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'].includes(this.selectedBatch.statusOfTheBatch) ? 'Filled Template' : 'Template';
  }

  getContaminationString(sample: CovidSamples): string {
    let comment = this.getContaminationComment(sample);
    return 'Contamination With: ' + comment + ' (' + sample.contaminationType + ')' + ' at ' + this.getContaminatedSamplePos(comment);
  }

  getContaminationComment(sample: CovidSamples): string {
    if (sample.contaminationType == 'Two Swabs')
      return sample.twoSwabsComment;
    else if (sample.contaminationType == 'Contamination')
      return sample.defaultContaminationComment;
    else
      return '';
  }

  getContaminatedSamplePos(sample: string): any {
    let position = '';
    this.plateMap.forEach((value, key) => {
      if (value.barcode == sample)
        position = key;
    });
    return position;
  }

  verifyIfSameBatch(textInput: HTMLInputElement) {
    if (this.selectedBatch.batchID == textInput.value) {
      this.scanBlock = false;
      this.sameScanBatch = true;
    } else {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Mismatch', detail: 'Scanned batch ' + textInput.value + ' does not match selected batch ' + this.selectedBatch.batchID });
    }
    textInput.value = null;
  }

  showBatchIDScannerIfDisabled() {
    if (!this.sameScanBatch) {
      this.scanBlock = true;
    }
  }

  clearScanBatchField(textInput: HTMLInputElement) {
    textInput.value = null;
  }

  getDominantChannelFromKit(pcrKitName: string) {
    let pcrKit: any = this.getPcrKitFromMap(pcrKitName);
    if (pcrKit) {
      return pcrKit.dominantChannel;
    }
    return null;
  }

  isQuadrantIgnored(value: CovidSamples) {
    let quadrantIgnored = false;
    if (this.selectedBatch.wellType == WellType.WELL384) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.quadrant == value.quadrant && mergedBatch.finalResult != 'Report') {
          quadrantIgnored = true;
        }
      });
    } else if (this.selectedBatch.finalResult != 'Report') {
      quadrantIgnored = true;
    }
    return quadrantIgnored;
  }

  allNonICRChannelsUploaded() {
    let allChannelsUploaed = true;
    if (this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
      let sample = this.selectedBatch.samples[0];
      if (sample.channels) {
        sample.channels.forEach(channel => {
          if (channel.gene != 'ICR' && !channel.resultUploaded) {
            allChannelsUploaed = false;
          }
        });
      }
    }
    return allChannelsUploaed;
  }

  isChannelDominant(channelName: string): boolean {
    return channelName == this.dominantChannelName;
  }

  getResultOptions(sample: CovidSamples): SelectItem[] {
    if (['NTC_EX', 'PCR-NTC'].includes(sample.barcode)) {
      return this.negativeControlResultOptions;
    } else if (['POS_EX', 'PCR-PC'].includes(sample.barcode)) {
      return this.positiveControlResultOptions;
    } else {
      if (this.sampleHasPositiveBlock(sample, 'N-Gene', 39)) {
        return this.sampleResultOptionsWithoutPositive;
      } else {
        return this.sampleResultOptions;
      }
    }
  }

  sampleHasPositiveBlock(sample: CovidSamples, geneName: string, blockerValue: number) {
    let channels = sample.channels;
    let block = false;
    if (channels && channels.length > 0) {
      channels.forEach(channel => {
        if (channel.gene == geneName && (!channel.cpValue || channel.cpValue > blockerValue)) {
          block = true;
        }
      });
    }
    return block;
  }

  proceedToCompleteAnalysis() {
    return ((this.selectedBatch.statusOfTheBatch == 'ANALYSIS_STARTED' || this.selectedBatch.statusOfTheBatch == 'ANALYSIS_DONE') && (
      (this.allChannelsUpdatedForBatch() && this.allChecksResolved) || this.reportingOutsideBB))
  }



  getResultOptionsForChannel(sampleBarcode: string): SelectItem[] {
    return (['NTC_EX', 'PCR-NTC'].includes(sampleBarcode)) ? this.icrResultOptionsNegative : this.icrResultOptionsNormal;
  }

  getResultValues(result: string): SelectItem[] {
    let dropdownValues = [
      { value: result, label: result },
      { value: 'artifact', label: 'artifact' }
    ];
    return dropdownValues;
  }
  disableVerifyReception(vrPUID: string, vrPassword: string) {
    return ((!vrPUID || vrPUID.trim() == '') || (!vrPassword || vrPassword.trim() == ''));
  }

  disablePopupSubmitButton(vrPUID: string) {
    return (!vrPUID || vrPUID.trim() == '');
  }

  puidPopupMethod(status: string) {
    this.enteredPassword = "";
    this.enteredPuid = "";
    this.enteredPasswordToByeArray = [];
    setTimeout(() => {
      this.searchElement2.nativeElement.focus();
    }, 1000);
    this.puidPopup = true;
    this.puidPopupFunction = status;
  }

  puidPopupToFunction() {
    this.puidPopup = false;
    this.enteredPasswordToByeArray = this.convertStringToUTF8ByteArray(this.enteredPassword);
    if (this.puidPopupFunction == 'COMPLETE_PRECYCLING') {
      this.showDialogForCpValues(true);
    }
    else
      this.saveBatchStatus(this.puidPopupFunction)
  }

  showCommentsInClipping() {
    return (this.showPlateView);
  }

  getPreviewComment(batch: AnimalBatch) {
    let comment = new Comment();
    if (batch.comment && (!batch.comments || batch.comments.length == 0)) {
      comment.batchId = batch.batchID;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = batch.comment;
      batch.comments.push(comment);
    }

    if (batch.comments && batch.comments.length > 0) {
      comment = batch.comments[batch.comments.length - 1];
    } else {
      comment.userComment = 'No Comments added yet'
    }
    return comment;
  }

  showComments() {
    this.formCommentsMap(this.selectedBatch.comments);
    this.newComment = this.initializeNewComment();

    this.showCommentDialog = true;
  }

  isCommentAdditionDisabled() {
    return (!this.selectedBatch || !this.selectedBatch.batchID || this.selectedBatch.batchID.trim() == '');
  }

  formCommentsMap(comments: Comment[]) {
    if (!comments || this.commentsMap.size != 0) {
      return;
    }
    this.batchCommentVisibility = new Map<string, boolean>();
    comments.forEach(comment => {
      let cmnt = this.getArrayOfCommentsToAnother(comment.batchId, comment);
      this.commentsMap.set(comment.batchId, cmnt);
      this.batchCommentVisibility.set(comment.batchId, true);
    });
  }

  getCommentKeys(commentMap: Map<string, Comment>) {
    return Array.from(commentMap.keys());
  }

  initializeNewComment() {
    let comment = new Comment();
    comment.batchId = this.selectedBatch.batchID;
    comment.puid = this.puid;

    return comment;
  }

  getArrayOfCommentsToAnother(batchID: string, comment: Comment) {
    let commentItem = this.commentsMap.get(batchID);
    if (!commentItem) {
      commentItem = [];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }

  toggleBatchContent(batchID: string, showState: boolean) {
    this.batchCommentVisibility.set(batchID, showState);
  }

  convertStringToUTF8ByteArray(str) {
    var data = [];
    for (var i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }
  getBoxColour(quad: string) {
    if (quad == "A1") {
      return { 'outline-color': '#5858fa' }
    }
    if (quad == "A2") {
      return { 'outline-color': '#ff9000' }
    }
    if (quad == "B1") {
      return { 'outline-color': '#39ff14' }
    }
    if (quad == "B2") {
      return { 'outline-color': '#886a08' }
    }
  }

  getBoxColour1(finalResultForQuad: number) {
    let colorCheck384 = '';
    if (this.selectedBatch.mergedBatches &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult !== 'Report'
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redoReason
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redone) {
      colorCheck384 = 'Red';
    }
    return colorCheck384;
  }

  getBoxColourFor96() {
    let colorCheck96 = '';
    if (this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report' && !this.selectedBatch.redoReason) {
      colorCheck96 = 'Red';
    }
    return colorCheck96;
  }

  disableDownloadIf() {
    if (this.selectedBatch.statusOfTheBatch === 'REDO' && this.selectedBatch.wellType === WellType.WELL384) {
      return false;
    } else {
      return (!(['ANALYSIS_DONE', 'DATA_READY', 'COMPLETED'].includes(this.selectedBatch.statusOfTheBatch)))
        && (!(['ANALYSIS_STARTED'].includes(this.selectedBatch.statusOfTheBatch) && this.mapOfMachineInfo.get(this.selectedBatch.machineName1) && this.mapOfMachineInfo.get(this.selectedBatch.machineName1).fileType == 'Fast Finder'));
    }
  }

  getFontColorFor96() {
    let fontColorCheck96 = 'Black';
    if (this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report' && !this.selectedBatch.redoReason) {
      fontColorCheck96 = 'White';
    }
    return fontColorCheck96;
  }

  getFontColorFor384(finalResultForQuad: number) {
    let fontColorCheck384 = 'Black';
    if (this.selectedBatch.mergedBatches &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult &&
      this.selectedBatch.mergedBatches[finalResultForQuad].finalResult !== 'Report'
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redoReason
      && !this.selectedBatch.mergedBatches[finalResultForQuad].redone) {
      fontColorCheck384 = 'White';
    }
    return fontColorCheck384;
  }

  setRedoReason() {
    if (this.selectedBatch.wellType == 'WELL96') {
      this.selectedBatch.finalResult = this.selectedRedoReasonStep;
      this.selectedBatch.redoChannel = this.selectedRedoReasonChannel;
      this.selectedBatch.redoReason = this.selectedRedoReason != 'Other' ? this.selectedRedoReason : this.enteredRedoReason;
      this.selectedBatch.redoStep = this.selectedBatch.finalResult;
    } else {
      this.selectedMergedBatch.redoReason = this.selectedRedoReason != 'Other' ? this.selectedRedoReason : this.enteredRedoReason;
      this.selectedMergedBatch.finalResult = this.selectedRedoReasonStep;
      this.selectedMergedBatch.redoChannel = this.selectedRedoReasonChannel;
      this.selectedBatch.redoChannel = this.selectedRedoReasonChannel;
    }
    this.redoReasonsPopup = false;
  }

  checkIfFinalResultIsRedo(finalResult: string) {
    return (finalResult && finalResult != 'Report');
  }

  checkIfFinalResultIsCheck(finalResult: string) {
    return finalResult != 'Check';
  }

  showRedoReasonPopup(index: number) {
    this.selectedRedoReason = null;
    this.enteredRedoReason = null;
    this.selectedMergedBatch = this.selectedBatch.mergedBatches[index];
     if (this.selectedMergedBatch.redoReason) {
       this.redoReasons.forEach(reason => {
         if (reason.reasonName == this.selectedMergedBatch.redoReason){
          this.selectedRedoReason = reason.reasonName;
          this.selectedRedoReasonInfo = reason.reasonInfo;
          this.askForChannelDisabled = !reason.askForChannel;
         }
       });
       this.selectedRedoReasonStep = this.selectedMergedBatch.finalResult;
       this.selectedRedoReasonChannel = this.selectedMergedBatch.redoChannel;
     }
    this.redoReasonsPopup = true;
  }

  getLinkColorFor96() {
    let fontColorCheck96 = 'Blue';
    if (this.selectedBatch.finalResult && this.selectedBatch.finalResult !== 'Report' && !this.selectedBatch.redoReason) {
      fontColorCheck96 = 'Yellow';
    }
    return fontColorCheck96;
  }

  getLinkColorFor384(index: number) {
    let fontColorCheck384 = 'Blue';
    if (this.selectedBatch.mergedBatches &&
      this.selectedBatch.mergedBatches[index].finalResult &&
      this.selectedBatch.mergedBatches[index].finalResult !== 'Report'
      && !this.selectedBatch.mergedBatches[index].redoReason
      && !this.selectedBatch.mergedBatches[index].redone) {
      fontColorCheck384 = 'Yellow';
    }
    return fontColorCheck384;
  }

  redoButtonDisabledIf() {
    if (!this.selectedRedoReason || !this.selectedRedoReasonStep ||(!this.askForChannelDisabled && !this.selectedRedoReasonChannel)
    || (this.selectedMergedBatch && this.selectedMergedBatch.redone))
      return true;
    else if (this.selectedRedoReason != 'Other')
      return false;
    else
      return !(this.enteredRedoReason && this.enteredRedoReason.trim() != '');
  }

  resultReportDownload(batchID: string) {
    this.blocked = true;
    this.apgTestingService.resultReportExcelDowload(batchID, this.selectedLabId).subscribe(
      result => {
        this.blocked = false;
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        let filename = batchID + '_' + this.puid + '_report.xlsx'
        this.saveFile(blob, filename);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  getResultCount() {
    return this.getCountAsString(this.selectedBatch.positiveResultCount) + ' / ' + this.getCountAsString(this.selectedBatch.negativeCount) + ' / ' + this.getCountAsString(this.selectedBatch.invalidCount);
  }

  getFailedICRCount() {
    return this.getCountAsString(this.selectedBatch.failedICRCount);
  }
  getCountAsString(count: number) {
    return count ? count : 0;
  }

  getChannelResultForAnalysisTable(sample: CovidSamples, channelName: string) {
    let geneValue = null;
    sample.channels.forEach(channel => {
      if (channel.gene == channelName) {
        geneValue = channel.cpValue;
      }
    });
    return geneValue;
  }

  isAnalysisConfirmDisabled() {
    let isInvalidverifyPUID = this.invalidVerifyPUIDCheck();
    return (!this.analysisVerifyPUID || this.analysisVerifyPUID.trim() == '' || !this.enteredPassword || this.enteredPassword.trim() == '' || isInvalidverifyPUID);
  }

  clearVerificationPUID() {
    this.showAnalysisDialog = false;
    this.analysisVerifyPUID = null;
    this.enteredPassword = null;
  }

  invalidVerifyPUIDCheck() {
    return (this.analysisVerifyPUID && this.puid && (this.analysisVerifyPUID.toLowerCase() === this.puid.toLowerCase()));
  }

  getFinalStatusList(mergedBatch: MergedBatch) {
    if (this.selectedBatch.wellType == WellType.WELL96) {
      if (this.selectedBatch.redoCount == 0 || this.selectedBatch.swabType !== 'Dry')
        return (this.selectedBatch.swabType == 'Wet' && this.selectedBatch.createdFromAnalysis ) ? this.finalStatusListWithoutLysis : this.finalStatusList ;
      else {
        return this.selectedBatch.batchID.substring(this.selectedBatch.batchID.lastIndexOf('_')).includes('L') ? this.finalStatusListWithoutLysis : this.finalStatusList;
      }
    } else {
      return mergedBatch.redoLysisDone || mergedBatch.createdFromAnalysis ? this.finalStatusListWithoutLysis : this.finalStatusList;
    }
  }

  getRedoReason(mergedBatch: MergedBatch) {
    let redoReason: string = '';
    if (mergedBatch.finalResult != 'Report' && mergedBatch.redoReason) {
      this.redoReasons.forEach(reason => {
        if (reason.reasonName == mergedBatch.redoReason)
          redoReason = reason.reasonName;
      });
    }
    return redoReason;
  }

  externalFileTransfer() {

    if (!this.selectedBatch.ixoUploaded && this.isIXOMandatory) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Raw file not uploaded',
        detail: 'Please upload the Raw file before sending result file',
      });
      return;
    }

    if (this.manufacturerConfigMap && this.manufacturerConfigMap.size > 0) {
      this.missingPatterns = this.checkIfAllMandatoryFilesUploaded();
      if (this.missingPatterns && this.missingPatterns.length > 0) {
        this.missingFilesPopUp = true;
        this.commentPopup = false;
        return;
      }

    } else if (this.machineShortInfos.get(this.selectedBatch.machineName1) == APGCovid19Constants.bioradLimsMechine) {
      let csvFiles = Array.from(this.selectedBatch.csvFiles.values());
      if (csvFiles.length < 5) {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Missing CSV Files!',
          detail: 'At Least 5 CSV Files Should be Uploaded Before Sending The Files!',
        });
        return;
      }
    }

    this.blocked = true;
    this.refStatusOfPrev = this.selectedBatch.previousStatusOfTheBatch;
    this.selectedBatch.previousStatusOfTheBatch = this.selectedBatch.statusOfTheBatch;
    this.selectedBatch.statusOfTheBatch = "DATA_READY";
    this.selectedBatch.externalUploadDateTime = new Date();
    this.apgTestingService.externalFileTransfer(this.selectedBatch).subscribe(
      results => {
        this.selectedBatch = results.data;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Result  Sent!',
          detail: 'Batch ' + this.selectedBatch.batchID + ' - result sent successfully '
        });
        this.blocked = false;
        this.commentPopup = false;
      },
      error => {
        this.blocked = false;
        this.selectedBatch.statusOfTheBatch = this.selectedBatch.previousStatusOfTheBatch;
        this.selectedBatch.previousStatusOfTheBatch = this.refStatusOfPrev;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  checkIfAllMandatoryFilesUploaded() {
    let missingPatterns: any[] = [];
    Array.from(this.manufacturerFileMandatoryMap.keys()).forEach(key => {
      let mandatoryPatterns = this.manufacturerFileMandatoryMap.get(key);
      mandatoryPatterns.forEach(filePattern => {
        let filesUploadedForFormat = this.filesPerManufacturerMap.get(key);
        let isPatternUploaded = false;
        if (filesUploadedForFormat) {
          filesUploadedForFormat.forEach(file => {
            let pattern = filePattern.pattern.replace("<batchID>", this.selectedBatch.batchID);
            if (file.fileName.includes(pattern)) {
              isPatternUploaded = true;
            }
          });
        }
        if (!isPatternUploaded)
          missingPatterns.push(filePattern);
      });
    });
    return missingPatterns;
  }

  isProceedDisabled() {
    return !(this.selectedBatch.readmeFileComment && this.selectedBatch.readmeFileComment.trim() !== '');
  }
  populateSenders() {
    this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
      (result) => {
        this.populateSendersMergeGroup(result);
      },
      (error) => {
        this.getAllBatchWithNoFilter();
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  getExternalPUID() {
    if (this.selectedBatch && this.selectedBatch.externalUploadPUID) {
      return this.selectedBatch.externalUploadPUID.substring(0, this.selectedBatch.externalUploadPUID.indexOf('@'));
    }
  }
  saveKitVendorConfirm(message: string) {
    let image:string = "";
    if (this.kitimage != "") {
      image = "<img  src='" + this.kitimage + "' width='100%' height='100%' /> </br>"
    }
   let currentMessage = image + 'Selcted kit vendor is <b>' + this.selectedBatch.rtPCRKitVendor + '</b>. do you want to proceed ?'
    this.confirmationService.confirm({
      message: currentMessage,
      header: 'Kit Vendor Confirmation',
      accept: () => {
        if (message == 'ANALYSIS_STARTED') {
          this.saveBatchStatus(message);
        } else if (message == 'COMPLETE_PRECYCLING') {
          this.kitConfirmed = true;
        }
      },
      reject: () => { }
    });
  }

  getChannelTestingMapper() {
    let channelTestingTypeList = [];
    let sample = this.getFirstValidSample(this.selectedBatch.samples);
    let channelTestingTypeMap = new ChannelTestingTypeMapping();
    if (sample.results && sample.results.length > 0) {
      sample.results.forEach(_result => {
        channelTestingTypeMap.channelAssosiatedToDisease = [];
        channelTestingTypeList.push(Object.assign({}, channelTestingTypeMap));
      });
    } else {
      channelTestingTypeMap.diseaseName = "Covid";
      channelTestingTypeMap.channelAssosiatedToDisease = [];
      if (sample.channels) {
        sample.channels.forEach(channel => {
          channelTestingTypeMap.channelAssosiatedToDisease.push(channel.gene);
        });
      }
      channelTestingTypeList.push(Object.assign({}, channelTestingTypeMap));
    }
    return channelTestingTypeList;
  }

  getFirstValidSample(samples: CovidSamples[]) {
    for (let i = 0; i < samples.length; i++) {
      if (!this.controlArray.includes(samples[i].barcode)) {
        return samples[i];
      }
    }
  }

  getSelectedSampleHistoryMap(barcode: string) {
    if (this.sampleHistoryMap && !this.controlArray.includes(barcode)) {
      let sampleHistory = this.sampleHistoryMap[barcode];
      let sampleHistoryMap = new Map<string, Object>();
      if (sampleHistory && sampleHistory.length > 0) {
        sampleHistory.forEach(history => {
          if (history.channelTestingTypeMapping && history.channelTestingTypeMapping.length > 0 && (history.samples.result || (history.samples.results && history.samples.results.length > 0))) {
            this.batchHeaders.push(history['batchID']);
            sampleHistoryMap.set(history['batchID'], history);
          }
        });
        return sampleHistoryMap;
      }
      return null;
    }
    return null;
  }

  getHistoryForCurrentBatch(batchID: string) {
    if (this.selectedSampleHistoryMap && this.selectedSampleHistoryMap.size > 0) {
      return this.selectedSampleHistoryMap.get(batchID);
    }
    return null;
  }
  onRightDirectionClick() {
    this.headerIndex = this.headerIndex + 1;
    this.reset = [{}];
  }

  onLeftDirectionClick() {
    this.headerIndex = this.headerIndex - 1;
    this.reset = [{}];
  }

  isRightDirectionClickDisabled() {
    return (!this.analysisAndUpwardsStatuses.includes(this.selectedBatch.statusOfTheBatch) || this.headerIndex == (this.batchHeaders.length - 1));
  }

  isLeftClickDirectionDisabled() {
    return (!this.analysisAndUpwardsStatuses.includes(this.selectedBatch.statusOfTheBatch) || this.headerIndex == 0);
  }

  getSubSenders() {
    this.selectedBatch.samples.forEach(sample => {
      this.subSender.add(sample.unboxedSender);
    });
  }

  getSubSendersForPlateOne() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateOne) {
        this.subSenderForPlateOne.add(sample.unboxedSender);
      }
    });
  }

  getSubSendersForPlateTwo() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateTwo) {
        this.subSenderForPlateTwo.add(sample.unboxedSender);
      }
    });
  }

  getSubSendersForPlateThree() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateThree) {
        this.subSenderForPlateThree.add(sample.unboxedSender);
      }
    });
  }

  getSubSendersForPlateFour() {
    this.selectedBatch.samples.forEach(sample => {
      if (sample.receivedBatchID == this.plateFour) {
        this.subSenderForPlateFour.add(sample.unboxedSender);
      }
    });
  }


  assignRandomLightColour(i: number, sub: string) {
    return {
      'color': this.generateRandomLightColour(i, sub)
    };
  }

  generateRandomLightColour(i: number, sub: string) {
    let senderColor: string;
    if (i > this.colours.length - 1) {
      i = i % 10;
    }
    senderColor = this.colours[i];

    if (sub) {
      this.colorSenderMap.set(sub, senderColor);
    }
    return senderColor;
  }

  getSampleColorByUnboxedSender(sub: string) {
    let bgColorSender = this.colorSenderMap.get(sub);
    if (!bgColorSender) {
      return {
        'background-color': '#FFFFFF'
      };
    }
    else {
      return {
        'background-color': bgColorSender
      };
    }
  }

  completeAnalysisForReportingOutsideProcess() {
    let isRedoReasonSelected = true;
    if (this.selectedBatch.wellType == WellType.WELL384) {
      this.selectedBatch.mergedBatches.forEach(mergedBatch => {
        if (mergedBatch.finalResult != 'Report' && !mergedBatch.redoReason)
          isRedoReasonSelected = false;
      });

    } else {
      isRedoReasonSelected = !(this.selectedBatch.finalResult != 'Report' && !this.selectedBatch.redoReason);

    }
    if (!isRedoReasonSelected) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Redo Reason Not Selected!',
        detail: 'Please Select Redo Reason for Each Batch Set for Redo',
      });
      this.blocked = false;
      return;
    }
    this.selectedBatch.resultSentDateTime = new Date();
    this.selectedBatch.statusOfTheBatch = 'COMPLETED';
    this.selectedBatch.previousStatusOfTheBatch = 'COMPLETED';
    this.apgTestingService.confirmPlates(this.selectedBatch, this.reportingOutsideBB,this.resultReportPerSender).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.previewComment = this.getPreviewComment(this.selectedBatch);
          this.commentsMap = new Map<string, Comment[]>();
          this.togglePlateView();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Completed batch!',
            detail: 'Successfully completed batch',
          });
        }
        this.blocked = false;
      },
      error => {
        this.selectedBatch.resultSentDateTime = null;
        this.selectedBatch.resultDispatchedyPUID = '';
        this.selectedBatch.statusOfTheBatch = 'ANALYSIS_STARTED';
        this.selectedBatch.previousStatusOfTheBatch = 'ANALYSIS_STARTED';
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  getManufacturerConfig() {
    if (this.selectedBatch.cyclerManufacturer) {
      this.masterDataService.getPattersFromManufacturer(this.selectedBatch.cyclerManufacturer, this.selectedBatch.lab).subscribe(
        result => {
          if (result.data) {
            Object.entries(result.data).forEach(([key, value]) => {
              this.manufacturerConfigMap.set(key, value);
              let manufacturerPatterns: any = value;
              let mandatoryPatterns = manufacturerPatterns.filter(pattern => pattern.mandatory);
              this.manufacturerFileMandatoryMap.set(key, mandatoryPatterns);
            });
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        });
    }
  }

  getUploadedFileCount() {
    this.apgTestingService.getUploadedFileCountForCovidBatch(this.selectedBatch.lab, this.selectedBatch.batchID).subscribe(
      result => {
        if (result.data) {
          this.filesPerManufacturerMap = new Map(Object.entries(result.data));
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  verifyKitCompatibility() {
    let pcrKit: any = this.getPcrKitFromMap(this.selectedBatch.rtPCRKitVendor);
   if(this.mapOfMachineInfo.get(this.selectedBatch.machineName1) && APGCovid19Constants.bioradManufacturer == this.mapOfMachineInfo.get(this.selectedBatch.machineName1).manufacturer && this.channelsCount(pcrKit) == 5) {
    this.selectedBatch.machineName1 = "";
    this._messagesService.addErrorMessage({ severity: 'error', summary: 'Wrong Cycler', detail: 'Cycler with Biorad Manufacturer is not allowed for 5 Channels Kit' });
   }
  }
  populateBatchHistory() {

    let sourceBatchIds = this.selectedBatch.wellType == 'WELL384' ? this.selectedBatch.sourceBatchIds.join(",") : '';
    this.apgTestingService.getBatchHistory(this.selectedBatch.lab, this.selectedBatch.batchID, this.selectedBatch.wellType, sourceBatchIds).subscribe(
      result => {
        this.batchHistory = [];
        this.groupedBatches = [];
        if (result.data) {
          if (this.selectedBatch.wellType == 'WELL384') {
            let groupLabel = '';
            Object.entries(result.data).forEach(([key]) => {
              let batchGroup = new BatchGroup();
              let batcheIds = result.data[key];
              batcheIds.forEach((element: string) => {
                if (this.selectedBatch.sourceBatchIds.includes(element)) {
                  groupLabel = element;
                }
              });
              batchGroup.label = groupLabel;
              result.data[key].forEach((element: string) => {
                let batchItems = new BatchItemHistory();
                batchItems.label = element;
                batchItems.value = element;
                batchGroup.items.push(batchItems);
              });
              this.groupedBatches.push(batchGroup);
            });

          } else {
            result.data.forEach(batch => {
              this.batchHistory.push({label: batch, value: batch});
            });
            this.batchHistory.sort((item1: SelectItem, item2: SelectItem) => {
              return item1.label.localeCompare(item2.label);
            });
          }
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  getStatus(){
    if(this.selectedBatch.statusOfTheBatch && this.selectedBatch.statusOfTheBatch == 'REDO')
      return this.selectedBatch.statusOfTheBatch + '     By: ' + this.selectedBatch.redoPUID + '  ' + this.datepipe.transform(this.selectedBatch.redoDateTime, 'dd.MM.yy HH:mm');
    else
      return this.selectedBatch.statusOfTheBatch
  }

  showArchiveView(){
   return ['ARCHIVE_DEFINED','ARCHIVED'].includes(this.selectedBatch.statusOfTheBatch)
  }

  saveArchiveBatch(){
    this.selectedBatch.archiveProcessedDateTime = new Date();
    this.enteredPuid = this.puid;
    if('Process' == this.selectedArchiveOption) {
      this.extractionComplete('EXTRACTION_COMPLETE')
      this.showPlateView = false;
    }
    else
      this.updateBatch('ARCHIVED');
    this.selectedArchiveOption = null;
  }

  isReAnalysisDisabled() {
    if(this.selectedBatch.statusOfTheBatch != "COMPLETED" || this.selectedBatch.wellType == "WELL96" ) {
      return true;
    }
    let disabled = true;
    this.selectedBatch.mergedBatches.forEach(mergedBatch => {
      if(!mergedBatch.reAnalysisDone && !mergedBatch.redone) {
        disabled = false;
      }
    });
    return disabled;
  }

  confirmAnalysis() {
    this.confirmationService.confirm({
      header: 'Confirm Re-Analysis',
      message: 'Do you really want to go through with the re-analysis?',
      accept: () => {
        this.doReAnalysis()
      },
      reject: () => { }
    });
  }

  doReAnalysis() {
    let batchListTobeReAnalyzed = [];
    this.selectedBatch.mergedBatches.forEach(mergedBatch => {
      if(!mergedBatch.reAnalysisDone && !mergedBatch.redone) {
        batchListTobeReAnalyzed.push(mergedBatch.batchId);
        mergedBatch.reAnalysisDone = true;
      }
    });
    this.selectedBatch.reAnalysedDateTime = new Date();
    this.selectedBatch.reAnalysedByPUID = this.puid;
    this.apgTestingService.createReAnalysisbatches(this.selectedBatch, batchListTobeReAnalyzed).subscribe(
      result => {
        this.selectedBatch = result.data;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Re analysis batches created',
          detail: 'ReAnalysed batches have been created successfully '
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  private populateSendersMergeGroup(result: BBResponseContainer) {
    if (result.data) {
      Object.entries(result.data).forEach(([key, value]) => {
        this.mapOfSenders.set(key, value);
        let tempValue: any = value;
        let labelValue = tempValue.senderShortName ? tempValue.senderShortName : key;
        this.filterMapOfSenders.set(key, labelValue);
        if (tempValue.mergeGroup) {
          if (!this.mapOfMergeGroup.has(tempValue.mergeGroup)) {
            this.mergeGroupList.push({ label: tempValue.mergeGroup, value: tempValue.mergeGroup });
            let list: string[] = [];
            list.push(labelValue);
            this.mapOfMergeGroup.set(tempValue.mergeGroup, list);
          }
          else {
            let existinglist = this.mapOfMergeGroup.get(tempValue.mergeGroup);
            existinglist.push(labelValue);
            this.mapOfMergeGroup.set(tempValue.mergeGroup, existinglist);
          }
        }
      });
    }
    this.onApplyFilter();
  }

  private getDate() {
    let filterDate = new Date();
    if (!this.fromDate) {
      filterDate.setDate(filterDate.getDate() - 7);
    }
    else {
      filterDate.setTime(this.fromDate.getTime());
    }
    return filterDate;
  }

  private getAllBatchWithNoFilter() {
    this.apgTestingService.getBatchesForLab(this.selectedLabId).subscribe(
      results => {
        this.batches = results.data;
        this.loading = false;
        this.fromDate = null;
      },
      error => {
        this.loading = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  private retainFilter() {
    if (this.isFirstTime) {
      this.selectedMergeGroup = JSON.parse(sessionStorage.getItem('selectedMergeGroup'));
      this.selectedStates = JSON.parse(sessionStorage.getItem('selectedStates'));
      if (sessionStorage.getItem('fromDate')) {
        this.fromDate = new Date(JSON.parse(sessionStorage.getItem('fromDate')));
      }
    }else{
      sessionStorage.removeItem('selectedStates');
      sessionStorage.removeItem('fromDate');
    }
  }

  mergeGroupApplyFilter() {
    if (this.selectedMergeGroup && this.selectedMergeGroup.length>0) {
      let filterDate = this.getDate();
      sessionStorage.setItem('fromDate',JSON.stringify(filterDate));
      let selectedMergeGroupList = this.selectedMergeGroup.join(",");
      let selectedStatusList = this.getSelectedBatchState();
      let selectedWorkflowNamesList = '';
      if(this.workFlowNameList != null){
        selectedWorkflowNamesList = this.workFlowNameList.join(",");
      }
      this.getBatchWithAppliedFilters(selectedStatusList, filterDate, selectedMergeGroupList, selectedWorkflowNamesList);
    }else{
      this.onApplyFilter();
    }
    sessionStorage.setItem('selectedMergeGroup',JSON.stringify(this.selectedMergeGroup));
  }
  private getSelectedBatchState() {
    let selectedStatusList = '';
    if (this.selectedStates != null) {
      selectedStatusList = this.selectedStates.join(",");
    }
    return selectedStatusList;
  }

  private getBatchWithAppliedFilters(selectedStatusList: string, filterDate: Date, selectedMergeGroupList: string, selectedWorkflowList : string) {
    this.apgTestingService.filterBatchesForSamplesMenu(selectedStatusList, this.selectedLabId, filterDate, selectedMergeGroupList, selectedWorkflowList).subscribe(
      results => {
        this.loading = false;
        this.batches = results.data;
      },
      error => {
        this.loading = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  resetAllFilter(){
    sessionStorage.removeItem('selectedMergeGroup');
    sessionStorage.removeItem('selectedStates');
    sessionStorage.removeItem('fromDate');
    sessionStorage.removeItem('workFlowName');
    this.selectedMergeGroup=[];
    this.selectedStates=[];
    this.fromDate=null;
    this.workFlowNameList = null;
    this.getAllBatchWithNoFilter();

  }

  changeSingleSampleRedo(event) {
    if (event) {
      this.selectedSample.singleSampleInconclussiveRedo = false;
      this.selectedSample.singleSampleTechnicalRedo = false;
    }
  }

  changeInconclussiveRedo(event) {
    if (event) {
      this.selectedSample.singleSampleTechnicalRedo = false;
    }
  }

  changeTechnicalSampleRedo(event) {
    if (event) {
      if(this.singleSampleRedoCount === 0){
        this.selectedSample.singleSampleRedo = false;
      }
      this.selectedSample.singleSampleInconclussiveRedo = false;
    }
  }

  findRedoSample(lab: string, barcode: string) {
    this.apgTestingService.getRedoSample(lab, barcode).subscribe(
      result => {
        if (result.data) {
          this.singleSampleRedoCount = result.data.singleSampleRedoCount;
        } else {
          this.singleSampleRedoCount = 0
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  isUndoArchiveDisabled() {
    if (this.selectedBatch.statusOfTheBatch == "ARCHIVE_DEFINED") {
       this.isUndoArchiveBtnDiabled=false;
    }
    return this.isUndoArchiveBtnDiabled;
  }

  undoArchive() {
    let samples = [];
    this.selectedBatch.samples.forEach(sample => {
      samples.push(sample.barcode);
    });
    this.apgTestingService.undoArchive(this.selectedBatch.batchID, this.selectedLabId, samples).subscribe(
      result => {
        if (result.data) {
          this.selectedBatch = result.data;
          this.isUndoArchiveBtnDiabled=true;
          this.setBatchView();
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Removed',
            detail: 'Archive Batch ' + this.selectedBatch.batchID + ' has been rmoved successfully'
          });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      });
  }

  getRedoResonsDetails(){
    this.selectedRedoReasonInfo = null;
    this.askForChannelDisabled = false;
    this.selectedRedoReasonStep = null;
    this.selectedRedoReasonChannel = null;
    this.redoReasons.forEach(readoReson => {
      if(this.selectedRedoReason == readoReson.reasonName){
        this.selectedRedoReasonInfo = readoReson.reasonInfo;
        this.askForChannelDisabled = !readoReson.askForChannel;
        if(readoReson.defaultRedoStep){
          if(readoReson.defaultRedoStep == "REDO_PCR"){
            this.selectedRedoReasonStep = "Redo_PCR";
          }else if(readoReson.defaultRedoStep == "REDO_LYSIS"){
            this.selectedRedoReasonStep = "Redo_Lysis";
          }
        }
      }
    });
    if(this.redoChannelList.length <1){
      this.askForChannelDisabled = true;
    }
  }

  findKit(){
    this.redoReasons = [];
    this.redoChannelList = [];
    this.masterDataService.getKitByName(this.selectedBatch.lab, this.selectedBatch.rtPCRKitVendor, "PCR Kit").subscribe(
      result => {
        if(result.data){
          this.pcrKitRedoInfoForBatch = result.data;
          this.redoReasons = result.data.kitRedoReason;
          if(result.data.channel1Gene){
            this.redoChannelList.push({label:result.data.channel1Gene , value:result.data.channel1Gene});
          }
          if(result.data.channel2Gene){
            this.redoChannelList.push({label:result.data.channel2Gene, value:result.data.channel2Gene});
          }
          if(result.data.channel3Gene){
            this.redoChannelList.push({label:result.data.channel3Gene, value:result.data.channel3Gene});
          }
          if(result.data.channel4Gene){
            this.redoChannelList.push({label:result.data.channel4Gene, value:result.data.channel4Gene});
          }
          if(result.data.channel5Gene){
            this.redoChannelList.push({label:result.data.channel5Gene, value:result.data.channel5Gene});
          }
        }
        if(this.redoReasons && this.redoReasons.length<1){
          //find active redo reasons for Lab
          this.findAllActiveRedoReasonsForLab();
        }
        this.redoReasons.sort((item1, item2) => item1.reasonCode.localeCompare(item2.reasonCode));
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  findAllActiveRedoReasonsForLab(){
    this.noRedoReasonConfiguredForLab = false;
    this.masterDataService.getRedoReasons(this.selectedLab).subscribe(
      results => {
        if (!results) {
          this.noRedoReasonConfiguredForLab = true;
          return;
        }
        this.redoReasonsForLab = results.data;  
        this.redoReasonsForLab.forEach(ele => {
          if (ele.active) {
            this.redoReasons.push(ele);
          }
        });
        if(this.redoReasons && this.redoReasons.length<1){
          this.noRedoReasonConfiguredForLab = true;
          return;
        }
        this.redoReasons.sort((item1, item2) => item1.reasonCode.localeCompare(item2.reasonCode));
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  showRedoReasonDialog() {
    this.selectedRedoReason = null;
    if(this.selectedBatch.redoReason){
      this.selectedRedoReason = this.selectedBatch.redoReason;
    }
    this.selectedRedoReasonStep = null;
    if(this.selectedBatch.redoStep){
      this.selectedRedoReasonStep = this.selectedBatch.redoStep;
    }
    this.selectedRedoReasonChannel = null;
    if(this.selectedBatch.redoChannel){
      this.selectedRedoReasonChannel = this.selectedBatch.redoChannel;
    }
    this.redoReasons.forEach(readoReson => {
      if(this.selectedRedoReason == readoReson.reasonName){
        this.selectedRedoReasonInfo = readoReson.reasonInfo;
        this.askForChannelDisabled = !readoReson.askForChannel;
      }
    });
    this.enteredRedoReason = null;
    this.redoReasonsPopup = true;
  }

  exportStrFile(){
    var animalExportFile : AnimalBatchExportFileDTO = {} as AnimalBatchExportFileDTO;
    animalExportFile.samples = [];
    animalExportFile.delivery = [];
    animalExportFile.sampleDeliveries =[];
    animalExportFile.batchId = this.selectedBatch.batchID;
    animalExportFile.exportedAlready = this.selectedBatch.exported;
    animalExportFile.labId = this.selectedBatch.lab;
    this.selectedBatch.samples.forEach(item=>{
        animalExportFile.samples.push(item.barcode);
        animalExportFile.delivery.push(item.delivery);
        animalExportFile.sampleDeliveries.push(item.barcode+"#"+item.delivery);
      });
    this.blocked = true
    this.apgTestingService.exportStrFile(animalExportFile).subscribe(
      result => {
        this.blocked = false
        this.selectedBatch.exported = true;
        this.selectedBatch.version = this.selectedBatch.version+1;
        var fileData = {
          fileContent: new Blob([result.body], { type: result.headers.get('content-Type') }),
          filename: result.headers.get('filename')
        }
        var blob = new Blob([fileData.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, "SCC_BL_" + this.selectedBatch.batchID + ".csv");
      },
      error => {
        this.blocked = false
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  exportClippingFile(){
    this.blocked = true;
    this.apgTestingService.exportClippingFile(this.selectedBatch.batchID, this.selectedBatch.lab).subscribe(
      result => {
        this.blocked = false
        var excelData = {
          fileContent: new Blob([result.body], { type: result.headers.get('content-Type') }),
          filename: result.headers.get('filename')
        }
        var blob = new Blob([excelData.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, this.selectedBatch.batchID + ".xlsx");
      },
      err => {
        this.blocked = false;
        let message = this.errorHandler.handleError(err);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  
  getResultOfSTRProfile(){
  this.strResultStatus= this.getResultOfSTR() + ' / ' + this.totalCountOfSTR(); 
  }

  totalCountOfSTR(){
    let count =0;
    this.selectedBatch.samples.forEach((element) => {
    if(element.order != undefined && element.order !=null)
    {
     if(element.order.includes('STR')){
       count++;
     }
    } 
  });
  return count;
  }

  getResultOfSTR(){
    let count = 0;
    this.selectedBatch.samples.forEach((element) => {
      if(element.result != undefined && element.result != null && element.order.includes('STR')){
        var resultMap = new Map(Object.entries(element.result));
        if(resultMap.get("STR") !== undefined && resultMap.get("STR") !== null && resultMap.get("STR").markers !== undefined && resultMap.get("STR").markers !== null  && resultMap.get("STR").markers.length > 0){
          count++;
        }
      }
    });
    return count;
   }

   getResultOfParentage(){
    this.strpResultStatus= this.getResultOfSTRP() + ' / ' + this.totalCountOfSTRP();  
  }

  totalCountOfSTRP(){
    let count =0;
    this.selectedBatch.samples.forEach(element => {
      if(element.order != undefined  && element.order !=null){
        if(element.order.includes('STR-P'))
     {
       count++;
     }
      }
  }); 
  return count;
  }

  getResultOfSTRP(){
    let count =0;
    this.selectedBatch.samples.forEach(element => {
      if(element.result != undefined && element.result != null && element.order.includes('STR-P')){
        var resultMap = new Map(Object.entries(element.result));
        if(resultMap.get("STR-P") !== undefined  && resultMap.get("STR-P") !== null  && resultMap.get("STR-P").result !== undefined && resultMap.get("STR-P").result !== '' ){
          count++;
        }
      }
    });   
     return count;
   }

   getResultOfGeneTests(){
    this.testResultStatus= this.getResultOfTEST() + ' / ' + this.totalCountOfTEST();
  }

  getResultOfTEST(){
    let count =0;
    this.selectedBatch.samples.forEach(element => {
      if(element.result != undefined && element.result != null ){
        var resultMap = new Map(Object.entries(element.result));
        if(resultMap.get("TEST") !== undefined  && resultMap.get("TEST") !== null && resultMap.get("TEST").length !== undefined && resultMap.get("TEST").length !== null && resultMap.get("TEST").length > 0){
          count= count + resultMap.get("TEST").length;
        }
      }
    });
  return count; 
  }

  totalCountOfTEST(){
    let count =0;
    this.selectedBatch.samples.forEach(element => {
      if(element.tests != undefined  && element.tests !=null){
      count=count+element.tests.length;
      }
  });
  return count;
  }
  getParentageResult(element: CovidSamples) {
    let value;
    if (element.result != undefined && element.result != null && element.order.includes('STR-P') && this.selectedSample.barcode != null && this.selectedSample.barcode != undefined) {
      var resultMap = new Map(Object.entries(element.result));
      if (resultMap.get("STR-P") !== undefined && resultMap.get("STR-P") !== null && resultMap.get("STR-P").result !== undefined && resultMap.get("STR-P").result !== null && resultMap.get("STR-P").result != '') {
        value = resultMap.get("STR-P").result;
      }
    }
    return value;
  }
  getDeliveryId(sample : CovidSamples) {
    return (sample.delivery ? sample.delivery : "");
  }

  getGeneTestsValue(sample: CovidSamples) {
    let value1 = [];
    let value2 = [];
    let value3 = [];
    let value = [];
    let value4 = [];
    if (this.selectedSample.tests != undefined && this.selectedSample.tests != null) {
      this.selectedSample.tests.forEach(element => {
        value1.push(element.code);
      });
    }
    if (sample.result != undefined && sample.result != null) {
      var resultMap = new Map(Object.entries(sample.result));
      if (resultMap.get("TEST") !== undefined && resultMap.get("TEST") !== null && resultMap.get("TEST").length !== undefined && resultMap.get("TEST").length !== null && resultMap.get("TEST").length > 0) {
        value2.push(resultMap.get("TEST"));
        value2.forEach(element => {
          for (let i = 0; i < element.length; i++) {
            value3.push(element[i].result);
          }
        });
      }
    }
    if (value1 != null && value1 != undefined) {
      for (let i = 0; i < value1.length; i++) {
        if (value3[i] != null && value3[i] != undefined) {
          value.push(value3[i]);
        }
        else {
          value.push('');
        }

      }
    }
    for (let i = 0; i < value1.length; i++) {
      let my_object = {};
      let data_array = ["code", "result"];

      my_object[data_array[0]] = value1[i];
      my_object[data_array[1]] = value[i];
      value4.push(my_object);
    }
    return value4;
  }

  getSTRMarkerValue(sample : CovidSamples) {
    let value = [];
    let val;
    let val1;
    let val2 = [];
    let val3 = [];
    if (sample.result != undefined && sample.result != null && sample.order.includes('STR')) {
      var resultMap = new Map(Object.entries(sample.result));
      if (resultMap.get("STR") !== undefined && resultMap.get("STR") !== null && resultMap.get("STR").markers !== undefined && resultMap.get("STR").markers !== null && resultMap.get("STR").markers.length > 0) {
        value.push(resultMap.get("STR").markers);
        value.forEach(element => {
          for (let i = 0; i < element.length; i++) {
            val = element[i].value;
            val1 = val.split("/");
            val1.push(element[i].markerName);
            val2.push(val1);
          }
        });
      }
    }
    val2.forEach(element => {
      let arr = ["numerator", "denominator", "markerName"];
      let obj = {};
      for (let i = 0; i < element.length; i++) {
        obj[arr[i]] = element[i];
      }
      val3.push(obj);
    });
    return val3;
  }

  getSelectedWorkflowBatches(){
    let  workFlowNames= this.getSelectedWorkflowNames();
     this.apgTestingService.filterWorkflowBatches("", this.selectedLabId, workFlowNames).subscribe(
       results => {
         this.loading = false;
         this.batches = results.data;
       },
       error => {
         this.loading = false;
         let message = this.errorHandler.handleError(error);
         this._messagesService.addErrorMessage(message);
       }
     )};
 
     private getSelectedWorkflowNames() {
       let selectedworkFlowList = '';
       if (this.workFlowNameList != null) {
         selectedworkFlowList = this.workFlowNameList.join(",");
       }
       return selectedworkFlowList;
     }

     getAllActiveWorkFlowList(){
      this.blocked = true;
      this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results =>{
        if(results && results.data){
        this.workFlowData = results.data;
        this.workFlowData.forEach(e=>{
          this.workFlowList.push({label: e.workFlowName, value: e.workFlowName});
        });
        this.blocked = false;
      }
      },
      (error: any) => {
        this.blocked = false;
        this.showError(error);
      });
  
    }
    showError(error: any) {
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    }
 
}
